// source: aviwest/web/v1/web_v1.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var aviwest_commons_v2_commons_pb = require('../../../aviwest/commons/v2/commons_pb.js');
goog.object.extend(proto, aviwest_commons_v2_commons_pb);
goog.exportSymbol('proto.aviwest.web.v1.Account', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountDockerOption', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountDockerOptions', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountName', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountNameSearchRequest', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountNames', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountOption', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountOption.ComputeOption', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountOption.DockerOption', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountOption.OptiondataCase', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountOption.PAYGOption', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountOptionSet', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountOptions', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AccountProductsStatistics', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Accounts', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Action', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Actions', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AddIceCandidateForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.AllRoutes', null, global);
goog.exportSymbol('proto.aviwest.web.v1.BitrateForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.BookForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Booking', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Bookings', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Call', null, global);
goog.exportSymbol('proto.aviwest.web.v1.ClientInfo', null, global);
goog.exportSymbol('proto.aviwest.web.v1.CloudProduct', null, global);
goog.exportSymbol('proto.aviwest.web.v1.CloudProductCreationForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.CloudProductError', null, global);
goog.exportSymbol('proto.aviwest.web.v1.CloudProducts', null, global);
goog.exportSymbol('proto.aviwest.web.v1.ConsumptionGlobalInfo', null, global);
goog.exportSymbol('proto.aviwest.web.v1.CtrlFuEvent', null, global);
goog.exportSymbol('proto.aviwest.web.v1.CtrlFuPreview', null, global);
goog.exportSymbol('proto.aviwest.web.v1.CtrlMakEvent', null, global);
goog.exportSymbol('proto.aviwest.web.v1.CtrlShEvent', null, global);
goog.exportSymbol('proto.aviwest.web.v1.CtrlShPreviewInput', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Device', null, global);
goog.exportSymbol('proto.aviwest.web.v1.DeviceId', null, global);
goog.exportSymbol('proto.aviwest.web.v1.DeviceId.IdCase', null, global);
goog.exportSymbol('proto.aviwest.web.v1.DeviceIds', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Devices', null, global);
goog.exportSymbol('proto.aviwest.web.v1.DownloadUriForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.FieldUnit', null, global);
goog.exportSymbol('proto.aviwest.web.v1.FieldUnitStatus', null, global);
goog.exportSymbol('proto.aviwest.web.v1.FieldUnits', null, global);
goog.exportSymbol('proto.aviwest.web.v1.GetRoutesByHwIdForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.GroupReceiverPriority', null, global);
goog.exportSymbol('proto.aviwest.web.v1.GroupReceiversPriority', null, global);
goog.exportSymbol('proto.aviwest.web.v1.IceCandidate', null, global);
goog.exportSymbol('proto.aviwest.web.v1.IceConnectionInfo', null, global);
goog.exportSymbol('proto.aviwest.web.v1.IceServerConfiguration', null, global);
goog.exportSymbol('proto.aviwest.web.v1.JellyfishAccount', null, global);
goog.exportSymbol('proto.aviwest.web.v1.JellyfishAccounts', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LatencyForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveGuestActionForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveGuestAuthenticationForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveGuestAuthenticationResponse', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveGuestNotificationMessage', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveGuestNotificationMessage.DataCase', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveNotificationFilters', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveNotificationMessage', null, global);
goog.exportSymbol('proto.aviwest.web.v1.LiveNotificationMessage.MessageCase', null, global);
goog.exportSymbol('proto.aviwest.web.v1.MakitoConfigurationForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationAccountInfo', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationEcho', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationFilter', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationFilter.FilterCase', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationFilterAccount', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationFilterProduct', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationFilters', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationInfo', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationInfo.InfoCase', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationInfos', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationMessage', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationMessage.MessageCase', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationProductInfo', null, global);
goog.exportSymbol('proto.aviwest.web.v1.NotificationProductOptionInfo', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Option', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Option.OptionData', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Option.OptionExpiracy', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Option.OptionExpiracyActive', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Option.OptionExpiracyCount', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Option.OptiondataCase', null, global);
goog.exportSymbol('proto.aviwest.web.v1.OptionConsumptionInfo', null, global);
goog.exportSymbol('proto.aviwest.web.v1.OptionMonthlyConsumption', null, global);
goog.exportSymbol('proto.aviwest.web.v1.OptionMonthlyConsumptions', null, global);
goog.exportSymbol('proto.aviwest.web.v1.OptionSet', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Options', null, global);
goog.exportSymbol('proto.aviwest.web.v1.PAYGOption', null, global);
goog.exportSymbol('proto.aviwest.web.v1.PAYGOptions', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Product', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Products', null, global);
goog.exportSymbol('proto.aviwest.web.v1.RegistrationCode', null, global);
goog.exportSymbol('proto.aviwest.web.v1.RegistrationCodes', null, global);
goog.exportSymbol('proto.aviwest.web.v1.RequestFieldUnits', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Route', null, global);
goog.exportSymbol('proto.aviwest.web.v1.RouteInput', null, global);
goog.exportSymbol('proto.aviwest.web.v1.RouteNode', null, global);
goog.exportSymbol('proto.aviwest.web.v1.RouteUpdateForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Routes', null, global);
goog.exportSymbol('proto.aviwest.web.v1.SancusEntity', null, global);
goog.exportSymbol('proto.aviwest.web.v1.SancusTokens', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Sdp', null, global);
goog.exportSymbol('proto.aviwest.web.v1.SellRentForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.ServiceReady', null, global);
goog.exportSymbol('proto.aviwest.web.v1.ShInputForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.StreamhubInputRequest', null, global);
goog.exportSymbol('proto.aviwest.web.v1.StreamhubList', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Subscription', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Subscriptions', null, global);
goog.exportSymbol('proto.aviwest.web.v1.SubscriptionsForm', null, global);
goog.exportSymbol('proto.aviwest.web.v1.SubscriptionsForm.IdCase', null, global);
goog.exportSymbol('proto.aviwest.web.v1.ToCtrlId', null, global);
goog.exportSymbol('proto.aviwest.web.v1.ToCtrlSId', null, global);
goog.exportSymbol('proto.aviwest.web.v1.UploadLegacyReq', null, global);
goog.exportSymbol('proto.aviwest.web.v1.UploadLegacyRes', null, global);
goog.exportSymbol('proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct', null, global);
goog.exportSymbol('proto.aviwest.web.v1.Versions', null, global);
goog.exportSymbol('proto.aviwest.web.v1.liveGuestError', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.SancusEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.SancusEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.SancusEntity.displayName = 'proto.aviwest.web.v1.SancusEntity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.SancusTokens = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.SancusTokens, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.SancusTokens.displayName = 'proto.aviwest.web.v1.SancusTokens';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.SubscriptionsForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.aviwest.web.v1.SubscriptionsForm.oneofGroups_);
};
goog.inherits(proto.aviwest.web.v1.SubscriptionsForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.SubscriptionsForm.displayName = 'proto.aviwest.web.v1.SubscriptionsForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Subscription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Subscription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Subscription.displayName = 'proto.aviwest.web.v1.Subscription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Subscriptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.Subscriptions.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.Subscriptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Subscriptions.displayName = 'proto.aviwest.web.v1.Subscriptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LiveGuestAuthenticationForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.LiveGuestAuthenticationForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LiveGuestAuthenticationForm.displayName = 'proto.aviwest.web.v1.LiveGuestAuthenticationForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AddIceCandidateForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.AddIceCandidateForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AddIceCandidateForm.displayName = 'proto.aviwest.web.v1.AddIceCandidateForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.IceConnectionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.IceConnectionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.IceConnectionInfo.displayName = 'proto.aviwest.web.v1.IceConnectionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LiveGuestAuthenticationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.LiveGuestAuthenticationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LiveGuestAuthenticationResponse.displayName = 'proto.aviwest.web.v1.LiveGuestAuthenticationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LiveGuestActionForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.LiveGuestActionForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LiveGuestActionForm.displayName = 'proto.aviwest.web.v1.LiveGuestActionForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.liveGuestError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.liveGuestError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.liveGuestError.displayName = 'proto.aviwest.web.v1.liveGuestError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.IceServerConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.IceServerConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.IceServerConfiguration.displayName = 'proto.aviwest.web.v1.IceServerConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.IceCandidate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.IceCandidate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.IceCandidate.displayName = 'proto.aviwest.web.v1.IceCandidate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Sdp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Sdp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Sdp.displayName = 'proto.aviwest.web.v1.Sdp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.ClientInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.ClientInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.ClientInfo.displayName = 'proto.aviwest.web.v1.ClientInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.aviwest.web.v1.LiveGuestNotificationMessage.oneofGroups_);
};
goog.inherits(proto.aviwest.web.v1.LiveGuestNotificationMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LiveGuestNotificationMessage.displayName = 'proto.aviwest.web.v1.LiveGuestNotificationMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.displayName = 'proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.displayName = 'proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.displayName = 'proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.displayName = 'proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Call = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Call, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Call.displayName = 'proto.aviwest.web.v1.Call';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountProductsStatistics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.AccountProductsStatistics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountProductsStatistics.displayName = 'proto.aviwest.web.v1.AccountProductsStatistics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.GroupReceiverPriority = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.GroupReceiverPriority, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.GroupReceiverPriority.displayName = 'proto.aviwest.web.v1.GroupReceiverPriority';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.GroupReceiversPriority = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.GroupReceiversPriority.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.GroupReceiversPriority, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.GroupReceiversPriority.displayName = 'proto.aviwest.web.v1.GroupReceiversPriority';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.DownloadUriForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.DownloadUriForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.DownloadUriForm.displayName = 'proto.aviwest.web.v1.DownloadUriForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.aviwest.web.v1.AccountOption.oneofGroups_);
};
goog.inherits(proto.aviwest.web.v1.AccountOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountOption.displayName = 'proto.aviwest.web.v1.AccountOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountOption.PAYGOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.AccountOption.PAYGOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountOption.PAYGOption.displayName = 'proto.aviwest.web.v1.AccountOption.PAYGOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountOption.DockerOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.AccountOption.DockerOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountOption.DockerOption.displayName = 'proto.aviwest.web.v1.AccountOption.DockerOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountOption.ComputeOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.AccountOption.ComputeOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountOption.ComputeOption.displayName = 'proto.aviwest.web.v1.AccountOption.ComputeOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.AccountOptions.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.AccountOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountOptions.displayName = 'proto.aviwest.web.v1.AccountOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountOptionSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.AccountOptionSet.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.AccountOptionSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountOptionSet.displayName = 'proto.aviwest.web.v1.AccountOptionSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.PAYGOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.PAYGOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.PAYGOption.displayName = 'proto.aviwest.web.v1.PAYGOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.PAYGOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.PAYGOptions.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.PAYGOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.PAYGOptions.displayName = 'proto.aviwest.web.v1.PAYGOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountNameSearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.AccountNameSearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountNameSearchRequest.displayName = 'proto.aviwest.web.v1.AccountNameSearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.JellyfishAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.JellyfishAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.JellyfishAccount.displayName = 'proto.aviwest.web.v1.JellyfishAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.JellyfishAccounts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.JellyfishAccounts.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.JellyfishAccounts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.JellyfishAccounts.displayName = 'proto.aviwest.web.v1.JellyfishAccounts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountName = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.AccountName, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountName.displayName = 'proto.aviwest.web.v1.AccountName';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountNames = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.AccountNames.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.AccountNames, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountNames.displayName = 'proto.aviwest.web.v1.AccountNames';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Account = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Account, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Account.displayName = 'proto.aviwest.web.v1.Account';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Accounts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.Accounts.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.Accounts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Accounts.displayName = 'proto.aviwest.web.v1.Accounts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.SellRentForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.SellRentForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.SellRentForm.displayName = 'proto.aviwest.web.v1.SellRentForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Product.displayName = 'proto.aviwest.web.v1.Product';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Products = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.Products.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.Products, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Products.displayName = 'proto.aviwest.web.v1.Products';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.UploadLegacyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.UploadLegacyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.UploadLegacyReq.displayName = 'proto.aviwest.web.v1.UploadLegacyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.UploadLegacyRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.UploadLegacyRes.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.UploadLegacyRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.UploadLegacyRes.displayName = 'proto.aviwest.web.v1.UploadLegacyRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.displayName = 'proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Option = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.aviwest.web.v1.Option.oneofGroups_);
};
goog.inherits(proto.aviwest.web.v1.Option, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Option.displayName = 'proto.aviwest.web.v1.Option';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Option.OptionData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Option.OptionData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Option.OptionData.displayName = 'proto.aviwest.web.v1.Option.OptionData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Option.OptionExpiracy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Option.OptionExpiracy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Option.OptionExpiracy.displayName = 'proto.aviwest.web.v1.Option.OptionExpiracy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Option.OptionExpiracyActive = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Option.OptionExpiracyActive, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Option.OptionExpiracyActive.displayName = 'proto.aviwest.web.v1.Option.OptionExpiracyActive';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Option.OptionExpiracyCount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Option.OptionExpiracyCount.displayName = 'proto.aviwest.web.v1.Option.OptionExpiracyCount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.OptionSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.OptionSet.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.OptionSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.OptionSet.displayName = 'proto.aviwest.web.v1.OptionSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Options = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.Options.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.Options, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Options.displayName = 'proto.aviwest.web.v1.Options';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.ConsumptionGlobalInfo.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.ConsumptionGlobalInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.ConsumptionGlobalInfo.displayName = 'proto.aviwest.web.v1.ConsumptionGlobalInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.OptionConsumptionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.OptionConsumptionInfo.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.OptionConsumptionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.OptionConsumptionInfo.displayName = 'proto.aviwest.web.v1.OptionConsumptionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.OptionMonthlyConsumption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.OptionMonthlyConsumption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.OptionMonthlyConsumption.displayName = 'proto.aviwest.web.v1.OptionMonthlyConsumption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.OptionMonthlyConsumptions.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.OptionMonthlyConsumptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.OptionMonthlyConsumptions.displayName = 'proto.aviwest.web.v1.OptionMonthlyConsumptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.NotificationFilters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.NotificationFilters.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.NotificationFilters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.NotificationFilters.displayName = 'proto.aviwest.web.v1.NotificationFilters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.NotificationFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.aviwest.web.v1.NotificationFilter.oneofGroups_);
};
goog.inherits(proto.aviwest.web.v1.NotificationFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.NotificationFilter.displayName = 'proto.aviwest.web.v1.NotificationFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.NotificationFilterProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.NotificationFilterProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.NotificationFilterProduct.displayName = 'proto.aviwest.web.v1.NotificationFilterProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.NotificationFilterAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.NotificationFilterAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.NotificationFilterAccount.displayName = 'proto.aviwest.web.v1.NotificationFilterAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.NotificationMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.aviwest.web.v1.NotificationMessage.oneofGroups_);
};
goog.inherits(proto.aviwest.web.v1.NotificationMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.NotificationMessage.displayName = 'proto.aviwest.web.v1.NotificationMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.NotificationEcho = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.NotificationEcho, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.NotificationEcho.displayName = 'proto.aviwest.web.v1.NotificationEcho';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.NotificationInfos = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.NotificationInfos.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.NotificationInfos, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.NotificationInfos.displayName = 'proto.aviwest.web.v1.NotificationInfos';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.NotificationInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.aviwest.web.v1.NotificationInfo.oneofGroups_);
};
goog.inherits(proto.aviwest.web.v1.NotificationInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.NotificationInfo.displayName = 'proto.aviwest.web.v1.NotificationInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.NotificationProductInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.NotificationProductInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.NotificationProductInfo.displayName = 'proto.aviwest.web.v1.NotificationProductInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.NotificationProductOptionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.NotificationProductOptionInfo.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.NotificationProductOptionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.NotificationProductOptionInfo.displayName = 'proto.aviwest.web.v1.NotificationProductOptionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.NotificationAccountInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.NotificationAccountInfo.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.NotificationAccountInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.NotificationAccountInfo.displayName = 'proto.aviwest.web.v1.NotificationAccountInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Action = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Action, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Action.displayName = 'proto.aviwest.web.v1.Action';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Actions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.Actions.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.Actions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Actions.displayName = 'proto.aviwest.web.v1.Actions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountDockerOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.AccountDockerOption.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.AccountDockerOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountDockerOption.displayName = 'proto.aviwest.web.v1.AccountDockerOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AccountDockerOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.AccountDockerOptions.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.AccountDockerOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AccountDockerOptions.displayName = 'proto.aviwest.web.v1.AccountDockerOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.FieldUnit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.FieldUnit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.FieldUnit.displayName = 'proto.aviwest.web.v1.FieldUnit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.FieldUnits = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.FieldUnits.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.FieldUnits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.FieldUnits.displayName = 'proto.aviwest.web.v1.FieldUnits';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.MakitoConfigurationForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.MakitoConfigurationForm.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.MakitoConfigurationForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.MakitoConfigurationForm.displayName = 'proto.aviwest.web.v1.MakitoConfigurationForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LiveForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.LiveForm.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.LiveForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LiveForm.displayName = 'proto.aviwest.web.v1.LiveForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LatencyForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.LatencyForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LatencyForm.displayName = 'proto.aviwest.web.v1.LatencyForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.BitrateForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.BitrateForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.BitrateForm.displayName = 'proto.aviwest.web.v1.BitrateForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.ShInputForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.ShInputForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.ShInputForm.displayName = 'proto.aviwest.web.v1.ShInputForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.RouteUpdateForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.RouteUpdateForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.RouteUpdateForm.displayName = 'proto.aviwest.web.v1.RouteUpdateForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.GetRoutesByHwIdForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.GetRoutesByHwIdForm.displayName = 'proto.aviwest.web.v1.GetRoutesByHwIdForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.BookForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.BookForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.BookForm.displayName = 'proto.aviwest.web.v1.BookForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.StreamhubList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.StreamhubList.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.StreamhubList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.StreamhubList.displayName = 'proto.aviwest.web.v1.StreamhubList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.AllRoutes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.AllRoutes.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.AllRoutes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.AllRoutes.displayName = 'proto.aviwest.web.v1.AllRoutes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LiveNotificationMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.aviwest.web.v1.LiveNotificationMessage.oneofGroups_);
};
goog.inherits(proto.aviwest.web.v1.LiveNotificationMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LiveNotificationMessage.displayName = 'proto.aviwest.web.v1.LiveNotificationMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.ServiceReady = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.ServiceReady, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.ServiceReady.displayName = 'proto.aviwest.web.v1.ServiceReady';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Routes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.Routes.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.Routes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Routes.displayName = 'proto.aviwest.web.v1.Routes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Route = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.Route.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.Route, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Route.displayName = 'proto.aviwest.web.v1.Route';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.RouteInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.RouteInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.RouteInput.displayName = 'proto.aviwest.web.v1.RouteInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.RouteNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.RouteNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.RouteNode.displayName = 'proto.aviwest.web.v1.RouteNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.CtrlShEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.CtrlShEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.CtrlShEvent.displayName = 'proto.aviwest.web.v1.CtrlShEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.CtrlFuEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.CtrlFuEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.CtrlFuEvent.displayName = 'proto.aviwest.web.v1.CtrlFuEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.CtrlMakEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.CtrlMakEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.CtrlMakEvent.displayName = 'proto.aviwest.web.v1.CtrlMakEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.CtrlShPreviewInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.CtrlShPreviewInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.CtrlShPreviewInput.displayName = 'proto.aviwest.web.v1.CtrlShPreviewInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.CtrlFuPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.CtrlFuPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.CtrlFuPreview.displayName = 'proto.aviwest.web.v1.CtrlFuPreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.FieldUnitStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.FieldUnitStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.FieldUnitStatus.displayName = 'proto.aviwest.web.v1.FieldUnitStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.ToCtrlId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.ToCtrlId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.ToCtrlId.displayName = 'proto.aviwest.web.v1.ToCtrlId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.ToCtrlSId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.ToCtrlSId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.ToCtrlSId.displayName = 'proto.aviwest.web.v1.ToCtrlSId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.LiveNotificationFilters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.LiveNotificationFilters.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.LiveNotificationFilters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.LiveNotificationFilters.displayName = 'proto.aviwest.web.v1.LiveNotificationFilters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Booking = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Booking, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Booking.displayName = 'proto.aviwest.web.v1.Booking';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Bookings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.Bookings.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.Bookings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Bookings.displayName = 'proto.aviwest.web.v1.Bookings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.StreamhubInputRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.StreamhubInputRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.StreamhubInputRequest.displayName = 'proto.aviwest.web.v1.StreamhubInputRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Versions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.Versions.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.Versions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Versions.displayName = 'proto.aviwest.web.v1.Versions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.CloudProductCreationForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.CloudProductCreationForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.CloudProductCreationForm.displayName = 'proto.aviwest.web.v1.CloudProductCreationForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.CloudProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.CloudProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.CloudProduct.displayName = 'proto.aviwest.web.v1.CloudProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.CloudProducts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.CloudProducts.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.CloudProducts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.CloudProducts.displayName = 'proto.aviwest.web.v1.CloudProducts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.CloudProductError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.CloudProductError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.CloudProductError.displayName = 'proto.aviwest.web.v1.CloudProductError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.RequestFieldUnits = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.RequestFieldUnits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.RequestFieldUnits.displayName = 'proto.aviwest.web.v1.RequestFieldUnits';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.RegistrationCode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.RegistrationCode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.RegistrationCode.displayName = 'proto.aviwest.web.v1.RegistrationCode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.RegistrationCodes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.RegistrationCodes.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.RegistrationCodes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.RegistrationCodes.displayName = 'proto.aviwest.web.v1.RegistrationCodes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Device = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.aviwest.web.v1.Device, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Device.displayName = 'proto.aviwest.web.v1.Device';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.Devices = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.Devices.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.Devices, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.Devices.displayName = 'proto.aviwest.web.v1.Devices';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.DeviceId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.aviwest.web.v1.DeviceId.oneofGroups_);
};
goog.inherits(proto.aviwest.web.v1.DeviceId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.DeviceId.displayName = 'proto.aviwest.web.v1.DeviceId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.aviwest.web.v1.DeviceIds = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.aviwest.web.v1.DeviceIds.repeatedFields_, null);
};
goog.inherits(proto.aviwest.web.v1.DeviceIds, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.aviwest.web.v1.DeviceIds.displayName = 'proto.aviwest.web.v1.DeviceIds';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.SancusEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.SancusEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.SancusEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.SancusEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
    entity: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.SancusEntity}
 */
proto.aviwest.web.v1.SancusEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.SancusEntity;
  return proto.aviwest.web.v1.SancusEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.SancusEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.SancusEntity}
 */
proto.aviwest.web.v1.SancusEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.SancusEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.SancusEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.SancusEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.SancusEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntity();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string entity = 1;
 * @return {string}
 */
proto.aviwest.web.v1.SancusEntity.prototype.getEntity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.SancusEntity} returns this
 */
proto.aviwest.web.v1.SancusEntity.prototype.setEntity = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.SancusTokens.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.SancusTokens.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.SancusTokens} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.SancusTokens.toObject = function(includeInstance, msg) {
  var f, obj = {
    hat: jspb.Message.getFieldWithDefault(msg, 1, ""),
    refreshToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
    expires: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.SancusTokens}
 */
proto.aviwest.web.v1.SancusTokens.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.SancusTokens;
  return proto.aviwest.web.v1.SancusTokens.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.SancusTokens} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.SancusTokens}
 */
proto.aviwest.web.v1.SancusTokens.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHat(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefreshToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpires(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.SancusTokens.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.SancusTokens.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.SancusTokens} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.SancusTokens.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHat();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRefreshToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExpires();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string hat = 1;
 * @return {string}
 */
proto.aviwest.web.v1.SancusTokens.prototype.getHat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.SancusTokens} returns this
 */
proto.aviwest.web.v1.SancusTokens.prototype.setHat = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string refresh_token = 2;
 * @return {string}
 */
proto.aviwest.web.v1.SancusTokens.prototype.getRefreshToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.SancusTokens} returns this
 */
proto.aviwest.web.v1.SancusTokens.prototype.setRefreshToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 expires = 3;
 * @return {number}
 */
proto.aviwest.web.v1.SancusTokens.prototype.getExpires = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.SancusTokens} returns this
 */
proto.aviwest.web.v1.SancusTokens.prototype.setExpires = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.aviwest.web.v1.SubscriptionsForm.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.aviwest.web.v1.SubscriptionsForm.IdCase = {
  ID_NOT_SET: 0,
  ACCOUNT_ID: 1,
  ORGANIZATION_ID: 2
};

/**
 * @return {proto.aviwest.web.v1.SubscriptionsForm.IdCase}
 */
proto.aviwest.web.v1.SubscriptionsForm.prototype.getIdCase = function() {
  return /** @type {proto.aviwest.web.v1.SubscriptionsForm.IdCase} */(jspb.Message.computeOneofCase(this, proto.aviwest.web.v1.SubscriptionsForm.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.SubscriptionsForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.SubscriptionsForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.SubscriptionsForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.SubscriptionsForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.SubscriptionsForm}
 */
proto.aviwest.web.v1.SubscriptionsForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.SubscriptionsForm;
  return proto.aviwest.web.v1.SubscriptionsForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.SubscriptionsForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.SubscriptionsForm}
 */
proto.aviwest.web.v1.SubscriptionsForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.SubscriptionsForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.SubscriptionsForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.SubscriptionsForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.SubscriptionsForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.SubscriptionsForm.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.SubscriptionsForm} returns this
 */
proto.aviwest.web.v1.SubscriptionsForm.prototype.setAccountId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.aviwest.web.v1.SubscriptionsForm.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.aviwest.web.v1.SubscriptionsForm} returns this
 */
proto.aviwest.web.v1.SubscriptionsForm.prototype.clearAccountId = function() {
  return jspb.Message.setOneofField(this, 1, proto.aviwest.web.v1.SubscriptionsForm.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.SubscriptionsForm.prototype.hasAccountId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string organization_id = 2;
 * @return {string}
 */
proto.aviwest.web.v1.SubscriptionsForm.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.SubscriptionsForm} returns this
 */
proto.aviwest.web.v1.SubscriptionsForm.prototype.setOrganizationId = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.aviwest.web.v1.SubscriptionsForm.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.aviwest.web.v1.SubscriptionsForm} returns this
 */
proto.aviwest.web.v1.SubscriptionsForm.prototype.clearOrganizationId = function() {
  return jspb.Message.setOneofField(this, 2, proto.aviwest.web.v1.SubscriptionsForm.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.SubscriptionsForm.prototype.hasOrganizationId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Subscription.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Subscription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Subscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Subscription.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    created: jspb.Message.getFieldWithDefault(msg, 3, ""),
    updated: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Subscription}
 */
proto.aviwest.web.v1.Subscription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Subscription;
  return proto.aviwest.web.v1.Subscription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Subscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Subscription}
 */
proto.aviwest.web.v1.Subscription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreated(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdated(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Subscription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Subscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Subscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Subscription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCreated();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUpdated();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Subscription.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Subscription} returns this
 */
proto.aviwest.web.v1.Subscription.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 version = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Subscription.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Subscription} returns this
 */
proto.aviwest.web.v1.Subscription.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string created = 3;
 * @return {string}
 */
proto.aviwest.web.v1.Subscription.prototype.getCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Subscription} returns this
 */
proto.aviwest.web.v1.Subscription.prototype.setCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string updated = 4;
 * @return {string}
 */
proto.aviwest.web.v1.Subscription.prototype.getUpdated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Subscription} returns this
 */
proto.aviwest.web.v1.Subscription.prototype.setUpdated = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 account_id = 5;
 * @return {number}
 */
proto.aviwest.web.v1.Subscription.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Subscription} returns this
 */
proto.aviwest.web.v1.Subscription.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string organization_id = 6;
 * @return {string}
 */
proto.aviwest.web.v1.Subscription.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Subscription} returns this
 */
proto.aviwest.web.v1.Subscription.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string subscription_id = 7;
 * @return {string}
 */
proto.aviwest.web.v1.Subscription.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Subscription} returns this
 */
proto.aviwest.web.v1.Subscription.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.Subscriptions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Subscriptions.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Subscriptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Subscriptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Subscriptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.Subscription.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Subscriptions}
 */
proto.aviwest.web.v1.Subscriptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Subscriptions;
  return proto.aviwest.web.v1.Subscriptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Subscriptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Subscriptions}
 */
proto.aviwest.web.v1.Subscriptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.Subscription;
      reader.readMessage(value,proto.aviwest.web.v1.Subscription.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Subscriptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Subscriptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Subscriptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Subscriptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.Subscription.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Subscription data = 1;
 * @return {!Array<!proto.aviwest.web.v1.Subscription>}
 */
proto.aviwest.web.v1.Subscriptions.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Subscription>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Subscription, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Subscription>} value
 * @return {!proto.aviwest.web.v1.Subscriptions} returns this
*/
proto.aviwest.web.v1.Subscriptions.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.Subscription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Subscription}
 */
proto.aviwest.web.v1.Subscriptions.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.Subscription, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.Subscriptions} returns this
 */
proto.aviwest.web.v1.Subscriptions.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LiveGuestAuthenticationForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LiveGuestAuthenticationForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LiveGuestAuthenticationForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestAuthenticationForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    password: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LiveGuestAuthenticationForm}
 */
proto.aviwest.web.v1.LiveGuestAuthenticationForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LiveGuestAuthenticationForm;
  return proto.aviwest.web.v1.LiveGuestAuthenticationForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LiveGuestAuthenticationForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LiveGuestAuthenticationForm}
 */
proto.aviwest.web.v1.LiveGuestAuthenticationForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LiveGuestAuthenticationForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LiveGuestAuthenticationForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LiveGuestAuthenticationForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestAuthenticationForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string identifier = 1;
 * @return {string}
 */
proto.aviwest.web.v1.LiveGuestAuthenticationForm.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveGuestAuthenticationForm} returns this
 */
proto.aviwest.web.v1.LiveGuestAuthenticationForm.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.aviwest.web.v1.LiveGuestAuthenticationForm.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveGuestAuthenticationForm} returns this
 */
proto.aviwest.web.v1.LiveGuestAuthenticationForm.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AddIceCandidateForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AddIceCandidateForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AddIceCandidateForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AddIceCandidateForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    candidate: (f = msg.getCandidate()) && proto.aviwest.web.v1.IceCandidate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AddIceCandidateForm}
 */
proto.aviwest.web.v1.AddIceCandidateForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AddIceCandidateForm;
  return proto.aviwest.web.v1.AddIceCandidateForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AddIceCandidateForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AddIceCandidateForm}
 */
proto.aviwest.web.v1.AddIceCandidateForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.IceCandidate;
      reader.readMessage(value,proto.aviwest.web.v1.IceCandidate.deserializeBinaryFromReader);
      msg.setCandidate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AddIceCandidateForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AddIceCandidateForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AddIceCandidateForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AddIceCandidateForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCandidate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.aviwest.web.v1.IceCandidate.serializeBinaryToWriter
    );
  }
};


/**
 * optional string identifier = 1;
 * @return {string}
 */
proto.aviwest.web.v1.AddIceCandidateForm.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.AddIceCandidateForm} returns this
 */
proto.aviwest.web.v1.AddIceCandidateForm.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional IceCandidate candidate = 2;
 * @return {?proto.aviwest.web.v1.IceCandidate}
 */
proto.aviwest.web.v1.AddIceCandidateForm.prototype.getCandidate = function() {
  return /** @type{?proto.aviwest.web.v1.IceCandidate} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.IceCandidate, 2));
};


/**
 * @param {?proto.aviwest.web.v1.IceCandidate|undefined} value
 * @return {!proto.aviwest.web.v1.AddIceCandidateForm} returns this
*/
proto.aviwest.web.v1.AddIceCandidateForm.prototype.setCandidate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.AddIceCandidateForm} returns this
 */
proto.aviwest.web.v1.AddIceCandidateForm.prototype.clearCandidate = function() {
  return this.setCandidate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.AddIceCandidateForm.prototype.hasCandidate = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.IceConnectionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.IceConnectionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.IceConnectionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    origin: jspb.Message.getFieldWithDefault(msg, 2, ""),
    connectionType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    type: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.IceConnectionInfo}
 */
proto.aviwest.web.v1.IceConnectionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.IceConnectionInfo;
  return proto.aviwest.web.v1.IceConnectionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.IceConnectionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.IceConnectionInfo}
 */
proto.aviwest.web.v1.IceConnectionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectionType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.IceConnectionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.IceConnectionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.IceConnectionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrigin();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConnectionType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string identifier = 1;
 * @return {string}
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.IceConnectionInfo} returns this
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string origin = 2;
 * @return {string}
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.getOrigin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.IceConnectionInfo} returns this
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.setOrigin = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string connection_type = 3;
 * @return {string}
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.getConnectionType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.IceConnectionInfo} returns this
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string type = 4;
 * @return {string}
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.IceConnectionInfo} returns this
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.IceConnectionInfo} returns this
 */
proto.aviwest.web.v1.IceConnectionInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LiveGuestAuthenticationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LiveGuestAuthenticationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LiveGuestAuthenticationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestAuthenticationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LiveGuestAuthenticationResponse}
 */
proto.aviwest.web.v1.LiveGuestAuthenticationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LiveGuestAuthenticationResponse;
  return proto.aviwest.web.v1.LiveGuestAuthenticationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LiveGuestAuthenticationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LiveGuestAuthenticationResponse}
 */
proto.aviwest.web.v1.LiveGuestAuthenticationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LiveGuestAuthenticationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LiveGuestAuthenticationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LiveGuestAuthenticationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestAuthenticationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.aviwest.web.v1.LiveGuestAuthenticationResponse.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveGuestAuthenticationResponse} returns this
 */
proto.aviwest.web.v1.LiveGuestAuthenticationResponse.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LiveGuestActionForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LiveGuestActionForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LiveGuestActionForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestActionForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sdp: (f = msg.getSdp()) && proto.aviwest.web.v1.Sdp.toObject(includeInstance, f),
    clientInfo: (f = msg.getClientInfo()) && proto.aviwest.web.v1.ClientInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LiveGuestActionForm}
 */
proto.aviwest.web.v1.LiveGuestActionForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LiveGuestActionForm;
  return proto.aviwest.web.v1.LiveGuestActionForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LiveGuestActionForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LiveGuestActionForm}
 */
proto.aviwest.web.v1.LiveGuestActionForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.Sdp;
      reader.readMessage(value,proto.aviwest.web.v1.Sdp.deserializeBinaryFromReader);
      msg.setSdp(value);
      break;
    case 3:
      var value = new proto.aviwest.web.v1.ClientInfo;
      reader.readMessage(value,proto.aviwest.web.v1.ClientInfo.deserializeBinaryFromReader);
      msg.setClientInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LiveGuestActionForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LiveGuestActionForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LiveGuestActionForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestActionForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSdp();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.aviwest.web.v1.Sdp.serializeBinaryToWriter
    );
  }
  f = message.getClientInfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.aviwest.web.v1.ClientInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string identifier = 1;
 * @return {string}
 */
proto.aviwest.web.v1.LiveGuestActionForm.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveGuestActionForm} returns this
 */
proto.aviwest.web.v1.LiveGuestActionForm.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Sdp sdp = 2;
 * @return {?proto.aviwest.web.v1.Sdp}
 */
proto.aviwest.web.v1.LiveGuestActionForm.prototype.getSdp = function() {
  return /** @type{?proto.aviwest.web.v1.Sdp} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.Sdp, 2));
};


/**
 * @param {?proto.aviwest.web.v1.Sdp|undefined} value
 * @return {!proto.aviwest.web.v1.LiveGuestActionForm} returns this
*/
proto.aviwest.web.v1.LiveGuestActionForm.prototype.setSdp = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveGuestActionForm} returns this
 */
proto.aviwest.web.v1.LiveGuestActionForm.prototype.clearSdp = function() {
  return this.setSdp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveGuestActionForm.prototype.hasSdp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ClientInfo client_info = 3;
 * @return {?proto.aviwest.web.v1.ClientInfo}
 */
proto.aviwest.web.v1.LiveGuestActionForm.prototype.getClientInfo = function() {
  return /** @type{?proto.aviwest.web.v1.ClientInfo} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.ClientInfo, 3));
};


/**
 * @param {?proto.aviwest.web.v1.ClientInfo|undefined} value
 * @return {!proto.aviwest.web.v1.LiveGuestActionForm} returns this
*/
proto.aviwest.web.v1.LiveGuestActionForm.prototype.setClientInfo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveGuestActionForm} returns this
 */
proto.aviwest.web.v1.LiveGuestActionForm.prototype.clearClientInfo = function() {
  return this.setClientInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveGuestActionForm.prototype.hasClientInfo = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.liveGuestError.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.liveGuestError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.liveGuestError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.liveGuestError.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, ""),
    origin: jspb.Message.getFieldWithDefault(msg, 3, ""),
    errorCode: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.liveGuestError}
 */
proto.aviwest.web.v1.liveGuestError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.liveGuestError;
  return proto.aviwest.web.v1.liveGuestError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.liveGuestError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.liveGuestError}
 */
proto.aviwest.web.v1.liveGuestError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigin(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setErrorCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.liveGuestError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.liveGuestError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.liveGuestError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.liveGuestError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrigin();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getErrorCode();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string identifier = 1;
 * @return {string}
 */
proto.aviwest.web.v1.liveGuestError.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.liveGuestError} returns this
 */
proto.aviwest.web.v1.liveGuestError.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.aviwest.web.v1.liveGuestError.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.liveGuestError} returns this
 */
proto.aviwest.web.v1.liveGuestError.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string origin = 3;
 * @return {string}
 */
proto.aviwest.web.v1.liveGuestError.prototype.getOrigin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.liveGuestError} returns this
 */
proto.aviwest.web.v1.liveGuestError.prototype.setOrigin = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 error_code = 4;
 * @return {number}
 */
proto.aviwest.web.v1.liveGuestError.prototype.getErrorCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.liveGuestError} returns this
 */
proto.aviwest.web.v1.liveGuestError.prototype.setErrorCode = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.IceServerConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.IceServerConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.IceServerConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.IceServerConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    iceServers: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.IceServerConfiguration}
 */
proto.aviwest.web.v1.IceServerConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.IceServerConfiguration;
  return proto.aviwest.web.v1.IceServerConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.IceServerConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.IceServerConfiguration}
 */
proto.aviwest.web.v1.IceServerConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIceServers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.IceServerConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.IceServerConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.IceServerConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.IceServerConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIceServers();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string identifier = 1;
 * @return {string}
 */
proto.aviwest.web.v1.IceServerConfiguration.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.IceServerConfiguration} returns this
 */
proto.aviwest.web.v1.IceServerConfiguration.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ice_servers = 2;
 * @return {string}
 */
proto.aviwest.web.v1.IceServerConfiguration.prototype.getIceServers = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.IceServerConfiguration} returns this
 */
proto.aviwest.web.v1.IceServerConfiguration.prototype.setIceServers = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.IceCandidate.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.IceCandidate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.IceCandidate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.IceCandidate.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    origin: jspb.Message.getFieldWithDefault(msg, 2, ""),
    content: jspb.Message.getFieldWithDefault(msg, 3, ""),
    connectionType: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.IceCandidate}
 */
proto.aviwest.web.v1.IceCandidate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.IceCandidate;
  return proto.aviwest.web.v1.IceCandidate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.IceCandidate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.IceCandidate}
 */
proto.aviwest.web.v1.IceCandidate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.IceCandidate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.IceCandidate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.IceCandidate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.IceCandidate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrigin();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getConnectionType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string identifier = 1;
 * @return {string}
 */
proto.aviwest.web.v1.IceCandidate.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.IceCandidate} returns this
 */
proto.aviwest.web.v1.IceCandidate.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string origin = 2;
 * @return {string}
 */
proto.aviwest.web.v1.IceCandidate.prototype.getOrigin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.IceCandidate} returns this
 */
proto.aviwest.web.v1.IceCandidate.prototype.setOrigin = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string content = 3;
 * @return {string}
 */
proto.aviwest.web.v1.IceCandidate.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.IceCandidate} returns this
 */
proto.aviwest.web.v1.IceCandidate.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string connection_type = 4;
 * @return {string}
 */
proto.aviwest.web.v1.IceCandidate.prototype.getConnectionType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.IceCandidate} returns this
 */
proto.aviwest.web.v1.IceCandidate.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Sdp.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Sdp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Sdp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Sdp.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, ""),
    origin: jspb.Message.getFieldWithDefault(msg, 3, ""),
    content: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Sdp}
 */
proto.aviwest.web.v1.Sdp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Sdp;
  return proto.aviwest.web.v1.Sdp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Sdp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Sdp}
 */
proto.aviwest.web.v1.Sdp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Sdp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Sdp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Sdp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Sdp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrigin();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string identifier = 1;
 * @return {string}
 */
proto.aviwest.web.v1.Sdp.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Sdp} returns this
 */
proto.aviwest.web.v1.Sdp.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.aviwest.web.v1.Sdp.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Sdp} returns this
 */
proto.aviwest.web.v1.Sdp.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string origin = 3;
 * @return {string}
 */
proto.aviwest.web.v1.Sdp.prototype.getOrigin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Sdp} returns this
 */
proto.aviwest.web.v1.Sdp.prototype.setOrigin = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string content = 4;
 * @return {string}
 */
proto.aviwest.web.v1.Sdp.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Sdp} returns this
 */
proto.aviwest.web.v1.Sdp.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.ClientInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.ClientInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.ClientInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ClientInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    browser: jspb.Message.getFieldWithDefault(msg, 1, ""),
    browserVersion: jspb.Message.getFieldWithDefault(msg, 2, ""),
    os: jspb.Message.getFieldWithDefault(msg, 3, ""),
    osVersion: jspb.Message.getFieldWithDefault(msg, 4, ""),
    browserIdentifier: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.ClientInfo}
 */
proto.aviwest.web.v1.ClientInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.ClientInfo;
  return proto.aviwest.web.v1.ClientInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.ClientInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.ClientInfo}
 */
proto.aviwest.web.v1.ClientInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrowser(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrowserVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOs(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOsVersion(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrowserIdentifier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.ClientInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.ClientInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.ClientInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ClientInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrowser();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrowserVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOs();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOsVersion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBrowserIdentifier();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string browser = 1;
 * @return {string}
 */
proto.aviwest.web.v1.ClientInfo.prototype.getBrowser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ClientInfo} returns this
 */
proto.aviwest.web.v1.ClientInfo.prototype.setBrowser = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string browser_version = 2;
 * @return {string}
 */
proto.aviwest.web.v1.ClientInfo.prototype.getBrowserVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ClientInfo} returns this
 */
proto.aviwest.web.v1.ClientInfo.prototype.setBrowserVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string os = 3;
 * @return {string}
 */
proto.aviwest.web.v1.ClientInfo.prototype.getOs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ClientInfo} returns this
 */
proto.aviwest.web.v1.ClientInfo.prototype.setOs = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string os_version = 4;
 * @return {string}
 */
proto.aviwest.web.v1.ClientInfo.prototype.getOsVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ClientInfo} returns this
 */
proto.aviwest.web.v1.ClientInfo.prototype.setOsVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string browser_identifier = 5;
 * @return {string}
 */
proto.aviwest.web.v1.ClientInfo.prototype.getBrowserIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ClientInfo} returns this
 */
proto.aviwest.web.v1.ClientInfo.prototype.setBrowserIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.oneofGroups_ = [[1,2,3,4,5,6]];

/**
 * @enum {number}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.DataCase = {
  DATA_NOT_SET: 0,
  ECHO: 1,
  ICE_CANDIDATE: 2,
  JANUS_EVENT: 3,
  EVENT: 4,
  RESPONSE: 5,
  ERROR: 6
};

/**
 * @return {proto.aviwest.web.v1.LiveGuestNotificationMessage.DataCase}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.getDataCase = function() {
  return /** @type {proto.aviwest.web.v1.LiveGuestNotificationMessage.DataCase} */(jspb.Message.computeOneofCase(this, proto.aviwest.web.v1.LiveGuestNotificationMessage.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LiveGuestNotificationMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    echo: (f = msg.getEcho()) && proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.toObject(includeInstance, f),
    iceCandidate: (f = msg.getIceCandidate()) && proto.aviwest.web.v1.IceCandidate.toObject(includeInstance, f),
    janusEvent: (f = msg.getJanusEvent()) && proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.toObject(includeInstance, f),
    event: (f = msg.getEvent()) && proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.toObject(includeInstance, f),
    response: (f = msg.getResponse()) && proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && proto.aviwest.web.v1.liveGuestError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LiveGuestNotificationMessage;
  return proto.aviwest.web.v1.LiveGuestNotificationMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho;
      reader.readMessage(value,proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.deserializeBinaryFromReader);
      msg.setEcho(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.IceCandidate;
      reader.readMessage(value,proto.aviwest.web.v1.IceCandidate.deserializeBinaryFromReader);
      msg.setIceCandidate(value);
      break;
    case 3:
      var value = new proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent;
      reader.readMessage(value,proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.deserializeBinaryFromReader);
      msg.setJanusEvent(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent;
      reader.readMessage(value,proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    case 5:
      var value = new proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse;
      reader.readMessage(value,proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.deserializeBinaryFromReader);
      msg.setResponse(value);
      break;
    case 6:
      var value = new proto.aviwest.web.v1.liveGuestError;
      reader.readMessage(value,proto.aviwest.web.v1.liveGuestError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LiveGuestNotificationMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEcho();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.serializeBinaryToWriter
    );
  }
  f = message.getIceCandidate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.aviwest.web.v1.IceCandidate.serializeBinaryToWriter
    );
  }
  f = message.getJanusEvent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.serializeBinaryToWriter
    );
  }
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.serializeBinaryToWriter
    );
  }
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.aviwest.web.v1.liveGuestError.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    content: jspb.Message.getFieldWithDefault(msg, 2, ""),
    connectionType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent;
  return proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConnectionType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string connection_type = 3;
 * @return {string}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.prototype.getConnectionType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent.prototype.setConnectionType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho;
  return proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sdp: (f = msg.getSdp()) && proto.aviwest.web.v1.Sdp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent;
  return proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.Sdp;
      reader.readMessage(value,proto.aviwest.web.v1.Sdp.deserializeBinaryFromReader);
      msg.setSdp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSdp();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.aviwest.web.v1.Sdp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Sdp sdp = 2;
 * @return {?proto.aviwest.web.v1.Sdp}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.prototype.getSdp = function() {
  return /** @type{?proto.aviwest.web.v1.Sdp} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.Sdp, 2));
};


/**
 * @param {?proto.aviwest.web.v1.Sdp|undefined} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent} returns this
*/
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.prototype.setSdp = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.prototype.clearSdp = function() {
  return this.setSdp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent.prototype.hasSdp = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sdp: (f = msg.getSdp()) && proto.aviwest.web.v1.Sdp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse;
  return proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.Sdp;
      reader.readMessage(value,proto.aviwest.web.v1.Sdp.deserializeBinaryFromReader);
      msg.setSdp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSdp();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.aviwest.web.v1.Sdp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Sdp sdp = 2;
 * @return {?proto.aviwest.web.v1.Sdp}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.prototype.getSdp = function() {
  return /** @type{?proto.aviwest.web.v1.Sdp} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.Sdp, 2));
};


/**
 * @param {?proto.aviwest.web.v1.Sdp|undefined} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse} returns this
*/
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.prototype.setSdp = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.prototype.clearSdp = function() {
  return this.setSdp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse.prototype.hasSdp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LiveGuestEcho echo = 1;
 * @return {?proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.getEcho = function() {
  return /** @type{?proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho, 1));
};


/**
 * @param {?proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEcho|undefined} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.setEcho = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.aviwest.web.v1.LiveGuestNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.clearEcho = function() {
  return this.setEcho(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.hasEcho = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional IceCandidate ice_candidate = 2;
 * @return {?proto.aviwest.web.v1.IceCandidate}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.getIceCandidate = function() {
  return /** @type{?proto.aviwest.web.v1.IceCandidate} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.IceCandidate, 2));
};


/**
 * @param {?proto.aviwest.web.v1.IceCandidate|undefined} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.setIceCandidate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.aviwest.web.v1.LiveGuestNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.clearIceCandidate = function() {
  return this.setIceCandidate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.hasIceCandidate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional JanusEvent janus_event = 3;
 * @return {?proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.getJanusEvent = function() {
  return /** @type{?proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent, 3));
};


/**
 * @param {?proto.aviwest.web.v1.LiveGuestNotificationMessage.JanusEvent|undefined} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.setJanusEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.aviwest.web.v1.LiveGuestNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.clearJanusEvent = function() {
  return this.setJanusEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.hasJanusEvent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional LiveGuestEvent event = 4;
 * @return {?proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.getEvent = function() {
  return /** @type{?proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent, 4));
};


/**
 * @param {?proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestEvent|undefined} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.setEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.aviwest.web.v1.LiveGuestNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional LiveGuestActionResponse response = 5;
 * @return {?proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.getResponse = function() {
  return /** @type{?proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse, 5));
};


/**
 * @param {?proto.aviwest.web.v1.LiveGuestNotificationMessage.LiveGuestActionResponse|undefined} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.setResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.aviwest.web.v1.LiveGuestNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.clearResponse = function() {
  return this.setResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.hasResponse = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional liveGuestError error = 6;
 * @return {?proto.aviwest.web.v1.liveGuestError}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.getError = function() {
  return /** @type{?proto.aviwest.web.v1.liveGuestError} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.liveGuestError, 6));
};


/**
 * @param {?proto.aviwest.web.v1.liveGuestError|undefined} value
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.aviwest.web.v1.LiveGuestNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveGuestNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveGuestNotificationMessage.prototype.hasError = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Call.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Call.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Call} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Call.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    guestName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    guestEmail: jspb.Message.getFieldWithDefault(msg, 3, ""),
    hostName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    startDate: jspb.Message.getFieldWithDefault(msg, 5, ""),
    duration: jspb.Message.getFieldWithDefault(msg, 6, 0),
    passwordProtected: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    password: jspb.Message.getFieldWithDefault(msg, 8, ""),
    standard: jspb.Message.getFieldWithDefault(msg, 9, ""),
    aspectRatio: jspb.Message.getFieldWithDefault(msg, 10, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Call}
 */
proto.aviwest.web.v1.Call.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Call;
  return proto.aviwest.web.v1.Call.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Call} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Call}
 */
proto.aviwest.web.v1.Call.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGuestName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGuestEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setDuration(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPasswordProtected(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStandard(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAspectRatio(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Call.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Call.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Call} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Call.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGuestName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGuestEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHostName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getPasswordProtected();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStandard();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAspectRatio();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string identifier = 1;
 * @return {string}
 */
proto.aviwest.web.v1.Call.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Call} returns this
 */
proto.aviwest.web.v1.Call.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string guest_name = 2;
 * @return {string}
 */
proto.aviwest.web.v1.Call.prototype.getGuestName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Call} returns this
 */
proto.aviwest.web.v1.Call.prototype.setGuestName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string guest_email = 3;
 * @return {string}
 */
proto.aviwest.web.v1.Call.prototype.getGuestEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Call} returns this
 */
proto.aviwest.web.v1.Call.prototype.setGuestEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string host_name = 4;
 * @return {string}
 */
proto.aviwest.web.v1.Call.prototype.getHostName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Call} returns this
 */
proto.aviwest.web.v1.Call.prototype.setHostName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string start_date = 5;
 * @return {string}
 */
proto.aviwest.web.v1.Call.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Call} returns this
 */
proto.aviwest.web.v1.Call.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint64 duration = 6;
 * @return {number}
 */
proto.aviwest.web.v1.Call.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Call} returns this
 */
proto.aviwest.web.v1.Call.prototype.setDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool password_protected = 7;
 * @return {boolean}
 */
proto.aviwest.web.v1.Call.prototype.getPasswordProtected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.Call} returns this
 */
proto.aviwest.web.v1.Call.prototype.setPasswordProtected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string password = 8;
 * @return {string}
 */
proto.aviwest.web.v1.Call.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Call} returns this
 */
proto.aviwest.web.v1.Call.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string standard = 9;
 * @return {string}
 */
proto.aviwest.web.v1.Call.prototype.getStandard = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Call} returns this
 */
proto.aviwest.web.v1.Call.prototype.setStandard = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string aspect_ratio = 10;
 * @return {string}
 */
proto.aviwest.web.v1.Call.prototype.getAspectRatio = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Call} returns this
 */
proto.aviwest.web.v1.Call.prototype.setAspectRatio = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string product_id = 11;
 * @return {string}
 */
proto.aviwest.web.v1.Call.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Call} returns this
 */
proto.aviwest.web.v1.Call.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountProductsStatistics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountProductsStatistics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountProductsStatistics.toObject = function(includeInstance, msg) {
  var f, obj = {
    nbOwnedUsedInside: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nbOwnedUsedInsideExpired: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nbOwnedUsedOutside: jspb.Message.getFieldWithDefault(msg, 3, 0),
    nbOwnedUsedOutsideExpired: jspb.Message.getFieldWithDefault(msg, 4, 0),
    nbNotOwnedUsedInside: jspb.Message.getFieldWithDefault(msg, 5, 0),
    nbNotOwnedUsedInsideExpired: jspb.Message.getFieldWithDefault(msg, 6, 0),
    nbUsedInsideOffline: jspb.Message.getFieldWithDefault(msg, 7, 0),
    nbUsedInsideOnline: jspb.Message.getFieldWithDefault(msg, 8, 0),
    nbUsedInsideStandalone: jspb.Message.getFieldWithDefault(msg, 9, 0),
    nbUsedOutsideOffline: jspb.Message.getFieldWithDefault(msg, 10, 0),
    nbUsedOutsideOnline: jspb.Message.getFieldWithDefault(msg, 11, 0),
    nbUsedOutsideStandalone: jspb.Message.getFieldWithDefault(msg, 12, 0),
    nbPaygDockerOnline: jspb.Message.getFieldWithDefault(msg, 13, 0),
    nbPaygDocker: jspb.Message.getFieldWithDefault(msg, 14, 0),
    nbDockerInstancesOnline: jspb.Message.getFieldWithDefault(msg, 15, 0),
    nbDockerInstances: jspb.Message.getFieldWithDefault(msg, 16, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics}
 */
proto.aviwest.web.v1.AccountProductsStatistics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountProductsStatistics;
  return proto.aviwest.web.v1.AccountProductsStatistics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountProductsStatistics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics}
 */
proto.aviwest.web.v1.AccountProductsStatistics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbOwnedUsedInside(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbOwnedUsedInsideExpired(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbOwnedUsedOutside(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbOwnedUsedOutsideExpired(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbNotOwnedUsedInside(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbNotOwnedUsedInsideExpired(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbUsedInsideOffline(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbUsedInsideOnline(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbUsedInsideStandalone(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbUsedOutsideOffline(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbUsedOutsideOnline(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbUsedOutsideStandalone(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbPaygDockerOnline(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbPaygDocker(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbDockerInstancesOnline(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNbDockerInstances(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountProductsStatistics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountProductsStatistics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountProductsStatistics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNbOwnedUsedInside();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getNbOwnedUsedInsideExpired();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getNbOwnedUsedOutside();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getNbOwnedUsedOutsideExpired();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getNbNotOwnedUsedInside();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getNbNotOwnedUsedInsideExpired();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getNbUsedInsideOffline();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getNbUsedInsideOnline();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getNbUsedInsideStandalone();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getNbUsedOutsideOffline();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getNbUsedOutsideOnline();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getNbUsedOutsideStandalone();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getNbPaygDockerOnline();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = message.getNbPaygDocker();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getNbDockerInstancesOnline();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getNbDockerInstances();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
};


/**
 * optional uint32 nb_owned_used_inside = 1;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbOwnedUsedInside = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbOwnedUsedInside = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 nb_owned_used_inside_expired = 2;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbOwnedUsedInsideExpired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbOwnedUsedInsideExpired = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 nb_owned_used_outside = 3;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbOwnedUsedOutside = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbOwnedUsedOutside = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 nb_owned_used_outside_expired = 4;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbOwnedUsedOutsideExpired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbOwnedUsedOutsideExpired = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 nb_not_owned_used_inside = 5;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbNotOwnedUsedInside = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbNotOwnedUsedInside = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 nb_not_owned_used_inside_expired = 6;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbNotOwnedUsedInsideExpired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbNotOwnedUsedInsideExpired = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 nb_used_inside_offline = 7;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbUsedInsideOffline = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbUsedInsideOffline = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 nb_used_inside_online = 8;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbUsedInsideOnline = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbUsedInsideOnline = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 nb_used_inside_standalone = 9;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbUsedInsideStandalone = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbUsedInsideStandalone = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 nb_used_outside_offline = 10;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbUsedOutsideOffline = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbUsedOutsideOffline = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional uint32 nb_used_outside_online = 11;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbUsedOutsideOnline = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbUsedOutsideOnline = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional uint32 nb_used_outside_standalone = 12;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbUsedOutsideStandalone = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbUsedOutsideStandalone = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional uint32 nb_payg_docker_online = 13;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbPaygDockerOnline = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbPaygDockerOnline = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional uint32 nb_payg_docker = 14;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbPaygDocker = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbPaygDocker = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional uint32 nb_docker_instances_online = 15;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbDockerInstancesOnline = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbDockerInstancesOnline = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional uint32 nb_docker_instances = 16;
 * @return {number}
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.getNbDockerInstances = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountProductsStatistics} returns this
 */
proto.aviwest.web.v1.AccountProductsStatistics.prototype.setNbDockerInstances = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.GroupReceiverPriority.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.GroupReceiverPriority} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.GroupReceiverPriority.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    created: jspb.Message.getFieldWithDefault(msg, 3, ""),
    updated: jspb.Message.getFieldWithDefault(msg, 4, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    productName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    priority: jspb.Message.getFieldWithDefault(msg, 8, 0),
    groupUuid: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.GroupReceiverPriority}
 */
proto.aviwest.web.v1.GroupReceiverPriority.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.GroupReceiverPriority;
  return proto.aviwest.web.v1.GroupReceiverPriority.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.GroupReceiverPriority} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.GroupReceiverPriority}
 */
proto.aviwest.web.v1.GroupReceiverPriority.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreated(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdated(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setProductId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPriority(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.GroupReceiverPriority.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.GroupReceiverPriority} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.GroupReceiverPriority.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCreated();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUpdated();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProductId();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPriority();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getGroupUuid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.GroupReceiverPriority} returns this
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 version = 2;
 * @return {number}
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.GroupReceiverPriority} returns this
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string created = 3;
 * @return {string}
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.getCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.GroupReceiverPriority} returns this
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.setCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string updated = 4;
 * @return {string}
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.getUpdated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.GroupReceiverPriority} returns this
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.setUpdated = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint64 product_id = 6;
 * @return {number}
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.getProductId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.GroupReceiverPriority} returns this
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.setProductId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string product_name = 7;
 * @return {string}
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.GroupReceiverPriority} returns this
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint64 priority = 8;
 * @return {number}
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.getPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.GroupReceiverPriority} returns this
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.setPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string group_uuid = 9;
 * @return {string}
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.getGroupUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.GroupReceiverPriority} returns this
 */
proto.aviwest.web.v1.GroupReceiverPriority.prototype.setGroupUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.GroupReceiversPriority.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.GroupReceiversPriority.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.GroupReceiversPriority.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.GroupReceiversPriority} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.GroupReceiversPriority.toObject = function(includeInstance, msg) {
  var f, obj = {
    prioritiesList: jspb.Message.toObjectList(msg.getPrioritiesList(),
    proto.aviwest.web.v1.GroupReceiverPriority.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.GroupReceiversPriority}
 */
proto.aviwest.web.v1.GroupReceiversPriority.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.GroupReceiversPriority;
  return proto.aviwest.web.v1.GroupReceiversPriority.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.GroupReceiversPriority} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.GroupReceiversPriority}
 */
proto.aviwest.web.v1.GroupReceiversPriority.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.GroupReceiverPriority;
      reader.readMessage(value,proto.aviwest.web.v1.GroupReceiverPriority.deserializeBinaryFromReader);
      msg.addPriorities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.GroupReceiversPriority.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.GroupReceiversPriority.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.GroupReceiversPriority} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.GroupReceiversPriority.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrioritiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.GroupReceiverPriority.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GroupReceiverPriority priorities = 1;
 * @return {!Array<!proto.aviwest.web.v1.GroupReceiverPriority>}
 */
proto.aviwest.web.v1.GroupReceiversPriority.prototype.getPrioritiesList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.GroupReceiverPriority>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.GroupReceiverPriority, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.GroupReceiverPriority>} value
 * @return {!proto.aviwest.web.v1.GroupReceiversPriority} returns this
*/
proto.aviwest.web.v1.GroupReceiversPriority.prototype.setPrioritiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.GroupReceiverPriority=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.GroupReceiverPriority}
 */
proto.aviwest.web.v1.GroupReceiversPriority.prototype.addPriorities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.GroupReceiverPriority, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.GroupReceiversPriority} returns this
 */
proto.aviwest.web.v1.GroupReceiversPriority.prototype.clearPrioritiesList = function() {
  return this.setPrioritiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.DownloadUriForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.DownloadUriForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.DownloadUriForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.DownloadUriForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    legacy: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.DownloadUriForm}
 */
proto.aviwest.web.v1.DownloadUriForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.DownloadUriForm;
  return proto.aviwest.web.v1.DownloadUriForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.DownloadUriForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.DownloadUriForm}
 */
proto.aviwest.web.v1.DownloadUriForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLegacy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.DownloadUriForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.DownloadUriForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.DownloadUriForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.DownloadUriForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getLegacy();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.DownloadUriForm.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.DownloadUriForm} returns this
 */
proto.aviwest.web.v1.DownloadUriForm.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 account_id = 2;
 * @return {number}
 */
proto.aviwest.web.v1.DownloadUriForm.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.DownloadUriForm} returns this
 */
proto.aviwest.web.v1.DownloadUriForm.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool legacy = 3;
 * @return {boolean}
 */
proto.aviwest.web.v1.DownloadUriForm.prototype.getLegacy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.DownloadUriForm} returns this
 */
proto.aviwest.web.v1.DownloadUriForm.prototype.setLegacy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.aviwest.web.v1.AccountOption.oneofGroups_ = [[6,7,8]];

/**
 * @enum {number}
 */
proto.aviwest.web.v1.AccountOption.OptiondataCase = {
  OPTIONDATA_NOT_SET: 0,
  PAYG: 6,
  DOCKER: 7,
  COMPUTE: 8
};

/**
 * @return {proto.aviwest.web.v1.AccountOption.OptiondataCase}
 */
proto.aviwest.web.v1.AccountOption.prototype.getOptiondataCase = function() {
  return /** @type {proto.aviwest.web.v1.AccountOption.OptiondataCase} */(jspb.Message.computeOneofCase(this, proto.aviwest.web.v1.AccountOption.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountOption.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    payg: (f = msg.getPayg()) && proto.aviwest.web.v1.AccountOption.PAYGOption.toObject(includeInstance, f),
    docker: (f = msg.getDocker()) && proto.aviwest.web.v1.AccountOption.DockerOption.toObject(includeInstance, f),
    compute: (f = msg.getCompute()) && proto.aviwest.web.v1.AccountOption.ComputeOption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountOption}
 */
proto.aviwest.web.v1.AccountOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountOption;
  return proto.aviwest.web.v1.AccountOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountOption}
 */
proto.aviwest.web.v1.AccountOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 6:
      var value = new proto.aviwest.web.v1.AccountOption.PAYGOption;
      reader.readMessage(value,proto.aviwest.web.v1.AccountOption.PAYGOption.deserializeBinaryFromReader);
      msg.setPayg(value);
      break;
    case 7:
      var value = new proto.aviwest.web.v1.AccountOption.DockerOption;
      reader.readMessage(value,proto.aviwest.web.v1.AccountOption.DockerOption.deserializeBinaryFromReader);
      msg.setDocker(value);
      break;
    case 8:
      var value = new proto.aviwest.web.v1.AccountOption.ComputeOption;
      reader.readMessage(value,proto.aviwest.web.v1.AccountOption.ComputeOption.deserializeBinaryFromReader);
      msg.setCompute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPayg();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.aviwest.web.v1.AccountOption.PAYGOption.serializeBinaryToWriter
    );
  }
  f = message.getDocker();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.aviwest.web.v1.AccountOption.DockerOption.serializeBinaryToWriter
    );
  }
  f = message.getCompute();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.aviwest.web.v1.AccountOption.ComputeOption.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountOption.PAYGOption.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountOption.PAYGOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountOption.PAYGOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOption.PAYGOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountOption.PAYGOption}
 */
proto.aviwest.web.v1.AccountOption.PAYGOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountOption.PAYGOption;
  return proto.aviwest.web.v1.AccountOption.PAYGOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountOption.PAYGOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountOption.PAYGOption}
 */
proto.aviwest.web.v1.AccountOption.PAYGOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountOption.PAYGOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountOption.PAYGOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountOption.PAYGOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOption.PAYGOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.aviwest.web.v1.AccountOption.PAYGOption.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.AccountOption.PAYGOption} returns this
 */
proto.aviwest.web.v1.AccountOption.PAYGOption.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool active = 2;
 * @return {boolean}
 */
proto.aviwest.web.v1.AccountOption.PAYGOption.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.AccountOption.PAYGOption} returns this
 */
proto.aviwest.web.v1.AccountOption.PAYGOption.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountOption.DockerOption.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountOption.DockerOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountOption.DockerOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOption.DockerOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    plan: jspb.Message.getFieldWithDefault(msg, 1, ""),
    level: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountOption.DockerOption}
 */
proto.aviwest.web.v1.AccountOption.DockerOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountOption.DockerOption;
  return proto.aviwest.web.v1.AccountOption.DockerOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountOption.DockerOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountOption.DockerOption}
 */
proto.aviwest.web.v1.AccountOption.DockerOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlan(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountOption.DockerOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountOption.DockerOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountOption.DockerOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOption.DockerOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlan();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLevel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string plan = 1;
 * @return {string}
 */
proto.aviwest.web.v1.AccountOption.DockerOption.prototype.getPlan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.AccountOption.DockerOption} returns this
 */
proto.aviwest.web.v1.AccountOption.DockerOption.prototype.setPlan = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string level = 2;
 * @return {string}
 */
proto.aviwest.web.v1.AccountOption.DockerOption.prototype.getLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.AccountOption.DockerOption} returns this
 */
proto.aviwest.web.v1.AccountOption.DockerOption.prototype.setLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountOption.ComputeOption.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountOption.ComputeOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountOption.ComputeOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOption.ComputeOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    max: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountOption.ComputeOption}
 */
proto.aviwest.web.v1.AccountOption.ComputeOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountOption.ComputeOption;
  return proto.aviwest.web.v1.AccountOption.ComputeOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountOption.ComputeOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountOption.ComputeOption}
 */
proto.aviwest.web.v1.AccountOption.ComputeOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountOption.ComputeOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountOption.ComputeOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountOption.ComputeOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOption.ComputeOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMax();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 max = 1;
 * @return {number}
 */
proto.aviwest.web.v1.AccountOption.ComputeOption.prototype.getMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountOption.ComputeOption} returns this
 */
proto.aviwest.web.v1.AccountOption.ComputeOption.prototype.setMax = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.AccountOption.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountOption} returns this
 */
proto.aviwest.web.v1.AccountOption.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 version = 2;
 * @return {number}
 */
proto.aviwest.web.v1.AccountOption.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountOption} returns this
 */
proto.aviwest.web.v1.AccountOption.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 account_id = 3;
 * @return {number}
 */
proto.aviwest.web.v1.AccountOption.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountOption} returns this
 */
proto.aviwest.web.v1.AccountOption.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string organization_id = 4;
 * @return {string}
 */
proto.aviwest.web.v1.AccountOption.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.AccountOption} returns this
 */
proto.aviwest.web.v1.AccountOption.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional PAYGOption payg = 6;
 * @return {?proto.aviwest.web.v1.AccountOption.PAYGOption}
 */
proto.aviwest.web.v1.AccountOption.prototype.getPayg = function() {
  return /** @type{?proto.aviwest.web.v1.AccountOption.PAYGOption} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.AccountOption.PAYGOption, 6));
};


/**
 * @param {?proto.aviwest.web.v1.AccountOption.PAYGOption|undefined} value
 * @return {!proto.aviwest.web.v1.AccountOption} returns this
*/
proto.aviwest.web.v1.AccountOption.prototype.setPayg = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.aviwest.web.v1.AccountOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.AccountOption} returns this
 */
proto.aviwest.web.v1.AccountOption.prototype.clearPayg = function() {
  return this.setPayg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.AccountOption.prototype.hasPayg = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional DockerOption docker = 7;
 * @return {?proto.aviwest.web.v1.AccountOption.DockerOption}
 */
proto.aviwest.web.v1.AccountOption.prototype.getDocker = function() {
  return /** @type{?proto.aviwest.web.v1.AccountOption.DockerOption} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.AccountOption.DockerOption, 7));
};


/**
 * @param {?proto.aviwest.web.v1.AccountOption.DockerOption|undefined} value
 * @return {!proto.aviwest.web.v1.AccountOption} returns this
*/
proto.aviwest.web.v1.AccountOption.prototype.setDocker = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.aviwest.web.v1.AccountOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.AccountOption} returns this
 */
proto.aviwest.web.v1.AccountOption.prototype.clearDocker = function() {
  return this.setDocker(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.AccountOption.prototype.hasDocker = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional ComputeOption compute = 8;
 * @return {?proto.aviwest.web.v1.AccountOption.ComputeOption}
 */
proto.aviwest.web.v1.AccountOption.prototype.getCompute = function() {
  return /** @type{?proto.aviwest.web.v1.AccountOption.ComputeOption} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.AccountOption.ComputeOption, 8));
};


/**
 * @param {?proto.aviwest.web.v1.AccountOption.ComputeOption|undefined} value
 * @return {!proto.aviwest.web.v1.AccountOption} returns this
*/
proto.aviwest.web.v1.AccountOption.prototype.setCompute = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.aviwest.web.v1.AccountOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.AccountOption} returns this
 */
proto.aviwest.web.v1.AccountOption.prototype.clearCompute = function() {
  return this.setCompute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.AccountOption.prototype.hasCompute = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.AccountOptions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.AccountOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountOptions}
 */
proto.aviwest.web.v1.AccountOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountOptions;
  return proto.aviwest.web.v1.AccountOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountOptions}
 */
proto.aviwest.web.v1.AccountOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.AccountOption;
      reader.readMessage(value,proto.aviwest.web.v1.AccountOption.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.AccountOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountOption data = 1;
 * @return {!Array<!proto.aviwest.web.v1.AccountOption>}
 */
proto.aviwest.web.v1.AccountOptions.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.AccountOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.AccountOption, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.AccountOption>} value
 * @return {!proto.aviwest.web.v1.AccountOptions} returns this
*/
proto.aviwest.web.v1.AccountOptions.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.AccountOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.AccountOption}
 */
proto.aviwest.web.v1.AccountOptions.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.AccountOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.AccountOptions} returns this
 */
proto.aviwest.web.v1.AccountOptions.prototype.clearDataList = function() {
  return this.setDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.AccountOptionSet.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountOptionSet.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountOptionSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountOptionSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOptionSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.AccountOption.toObject, includeInstance),
    manufacturingOrder: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountOptionSet}
 */
proto.aviwest.web.v1.AccountOptionSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountOptionSet;
  return proto.aviwest.web.v1.AccountOptionSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountOptionSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountOptionSet}
 */
proto.aviwest.web.v1.AccountOptionSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.AccountOption;
      reader.readMessage(value,proto.aviwest.web.v1.AccountOption.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturingOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountOptionSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountOptionSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountOptionSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountOptionSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.AccountOption.serializeBinaryToWriter
    );
  }
  f = message.getManufacturingOrder();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated AccountOption data = 1;
 * @return {!Array<!proto.aviwest.web.v1.AccountOption>}
 */
proto.aviwest.web.v1.AccountOptionSet.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.AccountOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.AccountOption, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.AccountOption>} value
 * @return {!proto.aviwest.web.v1.AccountOptionSet} returns this
*/
proto.aviwest.web.v1.AccountOptionSet.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.AccountOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.AccountOption}
 */
proto.aviwest.web.v1.AccountOptionSet.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.AccountOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.AccountOptionSet} returns this
 */
proto.aviwest.web.v1.AccountOptionSet.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional string manufacturing_order = 2;
 * @return {string}
 */
proto.aviwest.web.v1.AccountOptionSet.prototype.getManufacturingOrder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.AccountOptionSet} returns this
 */
proto.aviwest.web.v1.AccountOptionSet.prototype.setManufacturingOrder = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.PAYGOption.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.PAYGOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.PAYGOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.PAYGOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    type: jspb.Message.getFieldWithDefault(msg, 3, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    accountId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.PAYGOption}
 */
proto.aviwest.web.v1.PAYGOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.PAYGOption;
  return proto.aviwest.web.v1.PAYGOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.PAYGOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.PAYGOption}
 */
proto.aviwest.web.v1.PAYGOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.PAYGOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.PAYGOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.PAYGOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.PAYGOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.PAYGOption.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.PAYGOption} returns this
 */
proto.aviwest.web.v1.PAYGOption.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 version = 2;
 * @return {number}
 */
proto.aviwest.web.v1.PAYGOption.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.PAYGOption} returns this
 */
proto.aviwest.web.v1.PAYGOption.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.aviwest.web.v1.PAYGOption.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.PAYGOption} returns this
 */
proto.aviwest.web.v1.PAYGOption.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool active = 4;
 * @return {boolean}
 */
proto.aviwest.web.v1.PAYGOption.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.PAYGOption} returns this
 */
proto.aviwest.web.v1.PAYGOption.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional uint64 account_id = 5;
 * @return {number}
 */
proto.aviwest.web.v1.PAYGOption.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.PAYGOption} returns this
 */
proto.aviwest.web.v1.PAYGOption.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string organization_id = 6;
 * @return {string}
 */
proto.aviwest.web.v1.PAYGOption.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.PAYGOption} returns this
 */
proto.aviwest.web.v1.PAYGOption.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.PAYGOptions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.PAYGOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.PAYGOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.PAYGOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.PAYGOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.PAYGOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.PAYGOptions}
 */
proto.aviwest.web.v1.PAYGOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.PAYGOptions;
  return proto.aviwest.web.v1.PAYGOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.PAYGOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.PAYGOptions}
 */
proto.aviwest.web.v1.PAYGOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.PAYGOption;
      reader.readMessage(value,proto.aviwest.web.v1.PAYGOption.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.PAYGOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.PAYGOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.PAYGOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.PAYGOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.PAYGOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PAYGOption data = 1;
 * @return {!Array<!proto.aviwest.web.v1.PAYGOption>}
 */
proto.aviwest.web.v1.PAYGOptions.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.PAYGOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.PAYGOption, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.PAYGOption>} value
 * @return {!proto.aviwest.web.v1.PAYGOptions} returns this
*/
proto.aviwest.web.v1.PAYGOptions.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.PAYGOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.PAYGOption}
 */
proto.aviwest.web.v1.PAYGOptions.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.PAYGOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.PAYGOptions} returns this
 */
proto.aviwest.web.v1.PAYGOptions.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountNameSearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountNameSearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountNameSearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountNameSearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    search: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountNameSearchRequest}
 */
proto.aviwest.web.v1.AccountNameSearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountNameSearchRequest;
  return proto.aviwest.web.v1.AccountNameSearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountNameSearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountNameSearchRequest}
 */
proto.aviwest.web.v1.AccountNameSearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountNameSearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountNameSearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountNameSearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountNameSearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.AccountNameSearchRequest.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountNameSearchRequest} returns this
 */
proto.aviwest.web.v1.AccountNameSearchRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.AccountNameSearchRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountNameSearchRequest} returns this
 */
proto.aviwest.web.v1.AccountNameSearchRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string search = 3;
 * @return {string}
 */
proto.aviwest.web.v1.AccountNameSearchRequest.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.AccountNameSearchRequest} returns this
 */
proto.aviwest.web.v1.AccountNameSearchRequest.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.JellyfishAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.JellyfishAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.JellyfishAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, ""),
    support: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    supportEnd: jspb.Message.getFieldWithDefault(msg, 5, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.JellyfishAccount}
 */
proto.aviwest.web.v1.JellyfishAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.JellyfishAccount;
  return proto.aviwest.web.v1.JellyfishAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.JellyfishAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.JellyfishAccount}
 */
proto.aviwest.web.v1.JellyfishAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupport(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupportEnd(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.JellyfishAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.JellyfishAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.JellyfishAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSupport();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSupportEnd();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.JellyfishAccount} returns this
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.JellyfishAccount} returns this
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.JellyfishAccount} returns this
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool support = 4;
 * @return {boolean}
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.getSupport = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.JellyfishAccount} returns this
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.setSupport = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string support_end = 5;
 * @return {string}
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.getSupportEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.JellyfishAccount} returns this
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.setSupportEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint64 account_id = 6;
 * @return {number}
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.JellyfishAccount} returns this
 */
proto.aviwest.web.v1.JellyfishAccount.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.JellyfishAccounts.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.JellyfishAccounts.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.JellyfishAccounts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.JellyfishAccounts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.JellyfishAccounts.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.JellyfishAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.JellyfishAccounts}
 */
proto.aviwest.web.v1.JellyfishAccounts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.JellyfishAccounts;
  return proto.aviwest.web.v1.JellyfishAccounts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.JellyfishAccounts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.JellyfishAccounts}
 */
proto.aviwest.web.v1.JellyfishAccounts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.JellyfishAccount;
      reader.readMessage(value,proto.aviwest.web.v1.JellyfishAccount.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.JellyfishAccounts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.JellyfishAccounts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.JellyfishAccounts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.JellyfishAccounts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.JellyfishAccount.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.JellyfishAccounts.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.JellyfishAccounts} returns this
 */
proto.aviwest.web.v1.JellyfishAccounts.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.JellyfishAccounts.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.JellyfishAccounts} returns this
 */
proto.aviwest.web.v1.JellyfishAccounts.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.aviwest.web.v1.JellyfishAccounts.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.JellyfishAccounts} returns this
 */
proto.aviwest.web.v1.JellyfishAccounts.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated JellyfishAccount data = 4;
 * @return {!Array<!proto.aviwest.web.v1.JellyfishAccount>}
 */
proto.aviwest.web.v1.JellyfishAccounts.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.JellyfishAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.JellyfishAccount, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.JellyfishAccount>} value
 * @return {!proto.aviwest.web.v1.JellyfishAccounts} returns this
*/
proto.aviwest.web.v1.JellyfishAccounts.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.JellyfishAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.JellyfishAccount}
 */
proto.aviwest.web.v1.JellyfishAccounts.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.JellyfishAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.JellyfishAccounts} returns this
 */
proto.aviwest.web.v1.JellyfishAccounts.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountName.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountName.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountName} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountName.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    type: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountName}
 */
proto.aviwest.web.v1.AccountName.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountName;
  return proto.aviwest.web.v1.AccountName.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountName} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountName}
 */
proto.aviwest.web.v1.AccountName.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountName.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountName.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountName} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountName.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.AccountName.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountName} returns this
 */
proto.aviwest.web.v1.AccountName.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string type = 5;
 * @return {string}
 */
proto.aviwest.web.v1.AccountName.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.AccountName} returns this
 */
proto.aviwest.web.v1.AccountName.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.aviwest.web.v1.AccountName.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.AccountName} returns this
 */
proto.aviwest.web.v1.AccountName.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.AccountNames.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountNames.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountNames.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountNames} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountNames.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.AccountName.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountNames}
 */
proto.aviwest.web.v1.AccountNames.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountNames;
  return proto.aviwest.web.v1.AccountNames.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountNames} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountNames}
 */
proto.aviwest.web.v1.AccountNames.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.AccountName;
      reader.readMessage(value,proto.aviwest.web.v1.AccountName.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountNames.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountNames.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountNames} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountNames.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.AccountName.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.AccountNames.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountNames} returns this
 */
proto.aviwest.web.v1.AccountNames.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.AccountNames.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountNames} returns this
 */
proto.aviwest.web.v1.AccountNames.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.aviwest.web.v1.AccountNames.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.AccountNames} returns this
 */
proto.aviwest.web.v1.AccountNames.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated AccountName data = 4;
 * @return {!Array<!proto.aviwest.web.v1.AccountName>}
 */
proto.aviwest.web.v1.AccountNames.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.AccountName>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.AccountName, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.AccountName>} value
 * @return {!proto.aviwest.web.v1.AccountNames} returns this
*/
proto.aviwest.web.v1.AccountNames.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.AccountName=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.AccountName}
 */
proto.aviwest.web.v1.AccountNames.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.AccountName, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.AccountNames} returns this
 */
proto.aviwest.web.v1.AccountNames.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Account.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Account.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Account} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Account.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    type: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    keyCreation: jspb.Message.getFieldWithDefault(msg, 8, ""),
    endOfSupport: jspb.Message.getFieldWithDefault(msg, 9, ""),
    defaultLocation: jspb.Message.getFieldWithDefault(msg, 11, ""),
    jellyfishId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    updatedFromJellyfish: jspb.Message.getFieldWithDefault(msg, 13, ""),
    organizationId: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Account}
 */
proto.aviwest.web.v1.Account.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Account;
  return proto.aviwest.web.v1.Account.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Account} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Account}
 */
proto.aviwest.web.v1.Account.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyCreation(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndOfSupport(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultLocation(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setJellyfishId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedFromJellyfish(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Account.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Account.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Account} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Account.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getKeyCreation();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getEndOfSupport();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDefaultLocation();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getJellyfishId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getUpdatedFromJellyfish();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Account.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Account} returns this
 */
proto.aviwest.web.v1.Account.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 version = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Account.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Account} returns this
 */
proto.aviwest.web.v1.Account.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string type = 5;
 * @return {string}
 */
proto.aviwest.web.v1.Account.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Account} returns this
 */
proto.aviwest.web.v1.Account.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.aviwest.web.v1.Account.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Account} returns this
 */
proto.aviwest.web.v1.Account.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string key_creation = 8;
 * @return {string}
 */
proto.aviwest.web.v1.Account.prototype.getKeyCreation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Account} returns this
 */
proto.aviwest.web.v1.Account.prototype.setKeyCreation = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string end_of_support = 9;
 * @return {string}
 */
proto.aviwest.web.v1.Account.prototype.getEndOfSupport = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Account} returns this
 */
proto.aviwest.web.v1.Account.prototype.setEndOfSupport = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string default_location = 11;
 * @return {string}
 */
proto.aviwest.web.v1.Account.prototype.getDefaultLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Account} returns this
 */
proto.aviwest.web.v1.Account.prototype.setDefaultLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string jellyfish_id = 12;
 * @return {string}
 */
proto.aviwest.web.v1.Account.prototype.getJellyfishId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Account} returns this
 */
proto.aviwest.web.v1.Account.prototype.setJellyfishId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string updated_from_jellyfish = 13;
 * @return {string}
 */
proto.aviwest.web.v1.Account.prototype.getUpdatedFromJellyfish = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Account} returns this
 */
proto.aviwest.web.v1.Account.prototype.setUpdatedFromJellyfish = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string organization_id = 14;
 * @return {string}
 */
proto.aviwest.web.v1.Account.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Account} returns this
 */
proto.aviwest.web.v1.Account.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.Accounts.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Accounts.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Accounts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Accounts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Accounts.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.Account.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Accounts}
 */
proto.aviwest.web.v1.Accounts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Accounts;
  return proto.aviwest.web.v1.Accounts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Accounts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Accounts}
 */
proto.aviwest.web.v1.Accounts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.Account;
      reader.readMessage(value,proto.aviwest.web.v1.Account.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Accounts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Accounts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Accounts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Accounts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.Account.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Accounts.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Accounts} returns this
 */
proto.aviwest.web.v1.Accounts.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Accounts.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Accounts} returns this
 */
proto.aviwest.web.v1.Accounts.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.aviwest.web.v1.Accounts.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Accounts} returns this
 */
proto.aviwest.web.v1.Accounts.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Account data = 4;
 * @return {!Array<!proto.aviwest.web.v1.Account>}
 */
proto.aviwest.web.v1.Accounts.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Account>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Account, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Account>} value
 * @return {!proto.aviwest.web.v1.Accounts} returns this
*/
proto.aviwest.web.v1.Accounts.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.Account=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Account}
 */
proto.aviwest.web.v1.Accounts.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.Account, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.Accounts} returns this
 */
proto.aviwest.web.v1.Accounts.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.SellRentForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.SellRentForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.SellRentForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.SellRentForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    productId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.SellRentForm}
 */
proto.aviwest.web.v1.SellRentForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.SellRentForm;
  return proto.aviwest.web.v1.SellRentForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.SellRentForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.SellRentForm}
 */
proto.aviwest.web.v1.SellRentForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setProductId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.SellRentForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.SellRentForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.SellRentForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.SellRentForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint64 product_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.SellRentForm.prototype.getProductId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.SellRentForm} returns this
 */
proto.aviwest.web.v1.SellRentForm.prototype.setProductId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 account_id = 2;
 * @return {number}
 */
proto.aviwest.web.v1.SellRentForm.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.SellRentForm} returns this
 */
proto.aviwest.web.v1.SellRentForm.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string organization_id = 3;
 * @return {string}
 */
proto.aviwest.web.v1.SellRentForm.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.SellRentForm} returns this
 */
proto.aviwest.web.v1.SellRentForm.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string subscription_id = 4;
 * @return {string}
 */
proto.aviwest.web.v1.SellRentForm.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.SellRentForm} returns this
 */
proto.aviwest.web.v1.SellRentForm.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Product.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    type: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 8, 0),
    status: jspb.Message.getFieldWithDefault(msg, 9, ""),
    firmwareVersion: jspb.Message.getFieldWithDefault(msg, 10, ""),
    lastPublicIp: jspb.Message.getFieldWithDefault(msg, 11, ""),
    lastConnectedDate: jspb.Message.getFieldWithDefault(msg, 12, ""),
    lastUpdateDate: jspb.Message.getFieldWithDefault(msg, 13, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    externalAccessMethod: jspb.Message.getFieldWithDefault(msg, 15, ""),
    licenseType: jspb.Message.getFieldWithDefault(msg, 16, ""),
    expiracy: jspb.Message.getFieldWithDefault(msg, 17, ""),
    ownerAccountId: jspb.Message.getFieldWithDefault(msg, 18, 0),
    licenseApplied: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
    hubControl: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    liveInputsNb: jspb.Message.getFieldWithDefault(msg, 22, 0),
    sso: jspb.Message.getFieldWithDefault(msg, 23, ""),
    organizationId: jspb.Message.getFieldWithDefault(msg, 24, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 25, ""),
    host: jspb.Message.getFieldWithDefault(msg, 26, ""),
    ownerOrganizationId: jspb.Message.getFieldWithDefault(msg, 27, ""),
    groupUuid: jspb.Message.getFieldWithDefault(msg, 28, ""),
    mcrVisible: jspb.Message.getBooleanFieldWithDefault(msg, 29, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Product}
 */
proto.aviwest.web.v1.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Product;
  return proto.aviwest.web.v1.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Product}
 */
proto.aviwest.web.v1.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmwareVersion(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastPublicIp(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastConnectedDate(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastUpdateDate(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalAccessMethod(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLicenseType(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpiracy(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOwnerAccountId(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLicenseApplied(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHubControl(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLiveInputsNb(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setSso(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerOrganizationId(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupUuid(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMcrVisible(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFirmwareVersion();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLastPublicIp();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLastConnectedDate();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLastUpdateDate();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getExternalAccessMethod();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getLicenseType();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getExpiracy();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getOwnerAccountId();
  if (f !== 0) {
    writer.writeUint64(
      18,
      f
    );
  }
  f = message.getLicenseApplied();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getHubControl();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getLiveInputsNb();
  if (f !== 0) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getSso();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getOwnerOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getGroupUuid();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getMcrVisible();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Product.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 version = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Product.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string type = 5;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string product_id = 7;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint64 account_id = 8;
 * @return {number}
 */
proto.aviwest.web.v1.Product.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string status = 9;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string firmware_version = 10;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getFirmwareVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setFirmwareVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string last_public_ip = 11;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getLastPublicIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setLastPublicIp = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string last_connected_date = 12;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getLastConnectedDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setLastConnectedDate = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string last_update_date = 13;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getLastUpdateDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setLastUpdateDate = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool active = 14;
 * @return {boolean}
 */
proto.aviwest.web.v1.Product.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string external_access_method = 15;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getExternalAccessMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setExternalAccessMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string license_type = 16;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getLicenseType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setLicenseType = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string expiracy = 17;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getExpiracy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setExpiracy = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional uint64 owner_account_id = 18;
 * @return {number}
 */
proto.aviwest.web.v1.Product.prototype.getOwnerAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setOwnerAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional bool license_applied = 19;
 * @return {boolean}
 */
proto.aviwest.web.v1.Product.prototype.getLicenseApplied = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setLicenseApplied = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional bool hub_control = 21;
 * @return {boolean}
 */
proto.aviwest.web.v1.Product.prototype.getHubControl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setHubControl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional int32 live_inputs_nb = 22;
 * @return {number}
 */
proto.aviwest.web.v1.Product.prototype.getLiveInputsNb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setLiveInputsNb = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional string sso = 23;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getSso = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setSso = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string organization_id = 24;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string subscription_id = 25;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string host = 26;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string owner_organization_id = 27;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getOwnerOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setOwnerOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string group_uuid = 28;
 * @return {string}
 */
proto.aviwest.web.v1.Product.prototype.getGroupUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setGroupUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional bool mcr_visible = 29;
 * @return {boolean}
 */
proto.aviwest.web.v1.Product.prototype.getMcrVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.Product} returns this
 */
proto.aviwest.web.v1.Product.prototype.setMcrVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.Products.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Products.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Products.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Products} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Products.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.Product.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Products}
 */
proto.aviwest.web.v1.Products.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Products;
  return proto.aviwest.web.v1.Products.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Products} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Products}
 */
proto.aviwest.web.v1.Products.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.Product;
      reader.readMessage(value,proto.aviwest.web.v1.Product.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Products.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Products.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Products} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Products.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.Product.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Products.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Products} returns this
 */
proto.aviwest.web.v1.Products.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Products.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Products} returns this
 */
proto.aviwest.web.v1.Products.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.aviwest.web.v1.Products.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Products} returns this
 */
proto.aviwest.web.v1.Products.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Product data = 4;
 * @return {!Array<!proto.aviwest.web.v1.Product>}
 */
proto.aviwest.web.v1.Products.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Product>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Product, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Product>} value
 * @return {!proto.aviwest.web.v1.Products} returns this
*/
proto.aviwest.web.v1.Products.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.Product=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Product}
 */
proto.aviwest.web.v1.Products.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.Product, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.Products} returns this
 */
proto.aviwest.web.v1.Products.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.UploadLegacyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.UploadLegacyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.UploadLegacyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    legacyHexaContent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    productType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    organizationId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.UploadLegacyReq}
 */
proto.aviwest.web.v1.UploadLegacyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.UploadLegacyReq;
  return proto.aviwest.web.v1.UploadLegacyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.UploadLegacyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.UploadLegacyReq}
 */
proto.aviwest.web.v1.UploadLegacyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegacyHexaContent(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.UploadLegacyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.UploadLegacyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.UploadLegacyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLegacyHexaContent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getProductType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string legacy_hexa_content = 1;
 * @return {string}
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.getLegacyHexaContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.UploadLegacyReq} returns this
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.setLegacyHexaContent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 account_id = 2;
 * @return {number}
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.UploadLegacyReq} returns this
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string product_type = 3;
 * @return {string}
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.getProductType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.UploadLegacyReq} returns this
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.setProductType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string organization_id = 4;
 * @return {string}
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.UploadLegacyReq} returns this
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subscription_id = 5;
 * @return {string}
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.UploadLegacyReq} returns this
 */
proto.aviwest.web.v1.UploadLegacyReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.UploadLegacyRes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.UploadLegacyRes.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.UploadLegacyRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.UploadLegacyRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.UploadLegacyRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.UploadLegacyRes}
 */
proto.aviwest.web.v1.UploadLegacyRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.UploadLegacyRes;
  return proto.aviwest.web.v1.UploadLegacyRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.UploadLegacyRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.UploadLegacyRes}
 */
proto.aviwest.web.v1.UploadLegacyRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct;
      reader.readMessage(value,proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.UploadLegacyRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.UploadLegacyRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.UploadLegacyRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.UploadLegacyRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct}
 */
proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct;
  return proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct}
 */
proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct} returns this
 */
proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct} returns this
 */
proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated UploadLegacyProduct data = 1;
 * @return {!Array<!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct>}
 */
proto.aviwest.web.v1.UploadLegacyRes.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct>} value
 * @return {!proto.aviwest.web.v1.UploadLegacyRes} returns this
*/
proto.aviwest.web.v1.UploadLegacyRes.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct}
 */
proto.aviwest.web.v1.UploadLegacyRes.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.UploadLegacyRes.UploadLegacyProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.UploadLegacyRes} returns this
 */
proto.aviwest.web.v1.UploadLegacyRes.prototype.clearDataList = function() {
  return this.setDataList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.aviwest.web.v1.Option.oneofGroups_ = [[8,9,10,11]];

/**
 * @enum {number}
 */
proto.aviwest.web.v1.Option.OptiondataCase = {
  OPTIONDATA_NOT_SET: 0,
  DATA: 8,
  EXPIRACY: 9,
  ACTIVE_DATA: 10,
  COUNT_DATA: 11
};

/**
 * @return {proto.aviwest.web.v1.Option.OptiondataCase}
 */
proto.aviwest.web.v1.Option.prototype.getOptiondataCase = function() {
  return /** @type {proto.aviwest.web.v1.Option.OptiondataCase} */(jspb.Message.computeOneofCase(this, proto.aviwest.web.v1.Option.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Option.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Option.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Option} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Option.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    created: jspb.Message.getFieldWithDefault(msg, 3, ""),
    updated: jspb.Message.getFieldWithDefault(msg, 4, ""),
    type: jspb.Message.getFieldWithDefault(msg, 5, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    data: (f = msg.getData()) && proto.aviwest.web.v1.Option.OptionData.toObject(includeInstance, f),
    expiracy: (f = msg.getExpiracy()) && proto.aviwest.web.v1.Option.OptionExpiracy.toObject(includeInstance, f),
    activeData: (f = msg.getActiveData()) && proto.aviwest.web.v1.Option.OptionExpiracyActive.toObject(includeInstance, f),
    countData: (f = msg.getCountData()) && proto.aviwest.web.v1.Option.OptionExpiracyCount.toObject(includeInstance, f),
    firstSupportedVersion: jspb.Message.getFieldWithDefault(msg, 12, ""),
    organizationId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Option}
 */
proto.aviwest.web.v1.Option.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Option;
  return proto.aviwest.web.v1.Option.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Option} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Option}
 */
proto.aviwest.web.v1.Option.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreated(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdated(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setProductId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 8:
      var value = new proto.aviwest.web.v1.Option.OptionData;
      reader.readMessage(value,proto.aviwest.web.v1.Option.OptionData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 9:
      var value = new proto.aviwest.web.v1.Option.OptionExpiracy;
      reader.readMessage(value,proto.aviwest.web.v1.Option.OptionExpiracy.deserializeBinaryFromReader);
      msg.setExpiracy(value);
      break;
    case 10:
      var value = new proto.aviwest.web.v1.Option.OptionExpiracyActive;
      reader.readMessage(value,proto.aviwest.web.v1.Option.OptionExpiracyActive.deserializeBinaryFromReader);
      msg.setActiveData(value);
      break;
    case 11:
      var value = new proto.aviwest.web.v1.Option.OptionExpiracyCount;
      reader.readMessage(value,proto.aviwest.web.v1.Option.OptionExpiracyCount.deserializeBinaryFromReader);
      msg.setCountData(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstSupportedVersion(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Option.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Option.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Option} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Option.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCreated();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUpdated();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProductId();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.aviwest.web.v1.Option.OptionData.serializeBinaryToWriter
    );
  }
  f = message.getExpiracy();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.aviwest.web.v1.Option.OptionExpiracy.serializeBinaryToWriter
    );
  }
  f = message.getActiveData();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.aviwest.web.v1.Option.OptionExpiracyActive.serializeBinaryToWriter
    );
  }
  f = message.getCountData();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.aviwest.web.v1.Option.OptionExpiracyCount.serializeBinaryToWriter
    );
  }
  f = message.getFirstSupportedVersion();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Option.OptionData.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Option.OptionData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Option.OptionData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Option.OptionData.toObject = function(includeInstance, msg) {
  var f, obj = {
    data: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Option.OptionData}
 */
proto.aviwest.web.v1.Option.OptionData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Option.OptionData;
  return proto.aviwest.web.v1.Option.OptionData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Option.OptionData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Option.OptionData}
 */
proto.aviwest.web.v1.Option.OptionData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Option.OptionData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Option.OptionData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Option.OptionData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Option.OptionData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string data = 1;
 * @return {string}
 */
proto.aviwest.web.v1.Option.OptionData.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Option.OptionData} returns this
 */
proto.aviwest.web.v1.Option.OptionData.prototype.setData = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Option.OptionExpiracy.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Option.OptionExpiracy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Option.OptionExpiracy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Option.OptionExpiracy.toObject = function(includeInstance, msg) {
  var f, obj = {
    expiracy: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracy}
 */
proto.aviwest.web.v1.Option.OptionExpiracy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Option.OptionExpiracy;
  return proto.aviwest.web.v1.Option.OptionExpiracy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Option.OptionExpiracy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracy}
 */
proto.aviwest.web.v1.Option.OptionExpiracy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpiracy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Option.OptionExpiracy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Option.OptionExpiracy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Option.OptionExpiracy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Option.OptionExpiracy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExpiracy();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string expiracy = 1;
 * @return {string}
 */
proto.aviwest.web.v1.Option.OptionExpiracy.prototype.getExpiracy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracy} returns this
 */
proto.aviwest.web.v1.Option.OptionExpiracy.prototype.setExpiracy = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Option.OptionExpiracyActive.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Option.OptionExpiracyActive.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Option.OptionExpiracyActive} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Option.OptionExpiracyActive.toObject = function(includeInstance, msg) {
  var f, obj = {
    expiracy: jspb.Message.getFieldWithDefault(msg, 1, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracyActive}
 */
proto.aviwest.web.v1.Option.OptionExpiracyActive.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Option.OptionExpiracyActive;
  return proto.aviwest.web.v1.Option.OptionExpiracyActive.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Option.OptionExpiracyActive} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracyActive}
 */
proto.aviwest.web.v1.Option.OptionExpiracyActive.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpiracy(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Option.OptionExpiracyActive.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Option.OptionExpiracyActive.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Option.OptionExpiracyActive} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Option.OptionExpiracyActive.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExpiracy();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string expiracy = 1;
 * @return {string}
 */
proto.aviwest.web.v1.Option.OptionExpiracyActive.prototype.getExpiracy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracyActive} returns this
 */
proto.aviwest.web.v1.Option.OptionExpiracyActive.prototype.setExpiracy = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool active = 2;
 * @return {boolean}
 */
proto.aviwest.web.v1.Option.OptionExpiracyActive.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracyActive} returns this
 */
proto.aviwest.web.v1.Option.OptionExpiracyActive.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Option.OptionExpiracyCount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Option.OptionExpiracyCount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.toObject = function(includeInstance, msg) {
  var f, obj = {
    expiracy: jspb.Message.getFieldWithDefault(msg, 1, ""),
    count: jspb.Message.getFieldWithDefault(msg, 2, 0),
    max: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracyCount}
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Option.OptionExpiracyCount;
  return proto.aviwest.web.v1.Option.OptionExpiracyCount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Option.OptionExpiracyCount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracyCount}
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpiracy(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Option.OptionExpiracyCount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Option.OptionExpiracyCount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExpiracy();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getMax();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string expiracy = 1;
 * @return {string}
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.prototype.getExpiracy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracyCount} returns this
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.prototype.setExpiracy = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 count = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracyCount} returns this
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 max = 3;
 * @return {number}
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.prototype.getMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Option.OptionExpiracyCount} returns this
 */
proto.aviwest.web.v1.Option.OptionExpiracyCount.prototype.setMax = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Option.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 version = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Option.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string created = 3;
 * @return {string}
 */
proto.aviwest.web.v1.Option.prototype.getCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.setCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string updated = 4;
 * @return {string}
 */
proto.aviwest.web.v1.Option.prototype.getUpdated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.setUpdated = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string type = 5;
 * @return {string}
 */
proto.aviwest.web.v1.Option.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint64 product_id = 6;
 * @return {number}
 */
proto.aviwest.web.v1.Option.prototype.getProductId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.setProductId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint64 account_id = 7;
 * @return {number}
 */
proto.aviwest.web.v1.Option.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional OptionData data = 8;
 * @return {?proto.aviwest.web.v1.Option.OptionData}
 */
proto.aviwest.web.v1.Option.prototype.getData = function() {
  return /** @type{?proto.aviwest.web.v1.Option.OptionData} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.Option.OptionData, 8));
};


/**
 * @param {?proto.aviwest.web.v1.Option.OptionData|undefined} value
 * @return {!proto.aviwest.web.v1.Option} returns this
*/
proto.aviwest.web.v1.Option.prototype.setData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.aviwest.web.v1.Option.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.Option.prototype.hasData = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional OptionExpiracy expiracy = 9;
 * @return {?proto.aviwest.web.v1.Option.OptionExpiracy}
 */
proto.aviwest.web.v1.Option.prototype.getExpiracy = function() {
  return /** @type{?proto.aviwest.web.v1.Option.OptionExpiracy} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.Option.OptionExpiracy, 9));
};


/**
 * @param {?proto.aviwest.web.v1.Option.OptionExpiracy|undefined} value
 * @return {!proto.aviwest.web.v1.Option} returns this
*/
proto.aviwest.web.v1.Option.prototype.setExpiracy = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.aviwest.web.v1.Option.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.clearExpiracy = function() {
  return this.setExpiracy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.Option.prototype.hasExpiracy = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional OptionExpiracyActive active_data = 10;
 * @return {?proto.aviwest.web.v1.Option.OptionExpiracyActive}
 */
proto.aviwest.web.v1.Option.prototype.getActiveData = function() {
  return /** @type{?proto.aviwest.web.v1.Option.OptionExpiracyActive} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.Option.OptionExpiracyActive, 10));
};


/**
 * @param {?proto.aviwest.web.v1.Option.OptionExpiracyActive|undefined} value
 * @return {!proto.aviwest.web.v1.Option} returns this
*/
proto.aviwest.web.v1.Option.prototype.setActiveData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.aviwest.web.v1.Option.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.clearActiveData = function() {
  return this.setActiveData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.Option.prototype.hasActiveData = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional OptionExpiracyCount count_data = 11;
 * @return {?proto.aviwest.web.v1.Option.OptionExpiracyCount}
 */
proto.aviwest.web.v1.Option.prototype.getCountData = function() {
  return /** @type{?proto.aviwest.web.v1.Option.OptionExpiracyCount} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.Option.OptionExpiracyCount, 11));
};


/**
 * @param {?proto.aviwest.web.v1.Option.OptionExpiracyCount|undefined} value
 * @return {!proto.aviwest.web.v1.Option} returns this
*/
proto.aviwest.web.v1.Option.prototype.setCountData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.aviwest.web.v1.Option.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.clearCountData = function() {
  return this.setCountData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.Option.prototype.hasCountData = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string first_supported_version = 12;
 * @return {string}
 */
proto.aviwest.web.v1.Option.prototype.getFirstSupportedVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.setFirstSupportedVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string organization_id = 13;
 * @return {string}
 */
proto.aviwest.web.v1.Option.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string subscription_id = 14;
 * @return {string}
 */
proto.aviwest.web.v1.Option.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Option} returns this
 */
proto.aviwest.web.v1.Option.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.OptionSet.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.OptionSet.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.OptionSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.OptionSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.OptionSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.Option.toObject, includeInstance),
    manufacturingOrder: jspb.Message.getFieldWithDefault(msg, 2, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    licenseType: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.OptionSet}
 */
proto.aviwest.web.v1.OptionSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.OptionSet;
  return proto.aviwest.web.v1.OptionSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.OptionSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.OptionSet}
 */
proto.aviwest.web.v1.OptionSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.Option;
      reader.readMessage(value,proto.aviwest.web.v1.Option.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturingOrder(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setProductId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLicenseType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.OptionSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.OptionSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.OptionSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.OptionSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.Option.serializeBinaryToWriter
    );
  }
  f = message.getManufacturingOrder();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductId();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getLicenseType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated Option data = 1;
 * @return {!Array<!proto.aviwest.web.v1.Option>}
 */
proto.aviwest.web.v1.OptionSet.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Option>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Option, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Option>} value
 * @return {!proto.aviwest.web.v1.OptionSet} returns this
*/
proto.aviwest.web.v1.OptionSet.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.Option=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Option}
 */
proto.aviwest.web.v1.OptionSet.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.Option, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.OptionSet} returns this
 */
proto.aviwest.web.v1.OptionSet.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional string manufacturing_order = 2;
 * @return {string}
 */
proto.aviwest.web.v1.OptionSet.prototype.getManufacturingOrder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.OptionSet} returns this
 */
proto.aviwest.web.v1.OptionSet.prototype.setManufacturingOrder = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 product_id = 3;
 * @return {number}
 */
proto.aviwest.web.v1.OptionSet.prototype.getProductId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.OptionSet} returns this
 */
proto.aviwest.web.v1.OptionSet.prototype.setProductId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string license_type = 4;
 * @return {string}
 */
proto.aviwest.web.v1.OptionSet.prototype.getLicenseType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.OptionSet} returns this
 */
proto.aviwest.web.v1.OptionSet.prototype.setLicenseType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.Options.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Options.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Options.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Options} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Options.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.Option.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Options}
 */
proto.aviwest.web.v1.Options.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Options;
  return proto.aviwest.web.v1.Options.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Options} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Options}
 */
proto.aviwest.web.v1.Options.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.Option;
      reader.readMessage(value,proto.aviwest.web.v1.Option.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Options.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Options.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Options} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Options.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.Option.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Options.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Options} returns this
 */
proto.aviwest.web.v1.Options.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Options.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Options} returns this
 */
proto.aviwest.web.v1.Options.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.aviwest.web.v1.Options.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Options} returns this
 */
proto.aviwest.web.v1.Options.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Option data = 4;
 * @return {!Array<!proto.aviwest.web.v1.Option>}
 */
proto.aviwest.web.v1.Options.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Option>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Option, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Option>} value
 * @return {!proto.aviwest.web.v1.Options} returns this
*/
proto.aviwest.web.v1.Options.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.Option=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Option}
 */
proto.aviwest.web.v1.Options.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.Option, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.Options} returns this
 */
proto.aviwest.web.v1.Options.prototype.clearDataList = function() {
  return this.setDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.ConsumptionGlobalInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.ConsumptionGlobalInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    consumptionsList: jspb.Message.toObjectList(msg.getConsumptionsList(),
    proto.aviwest.web.v1.OptionConsumptionInfo.toObject, includeInstance),
    organizationId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.ConsumptionGlobalInfo}
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.ConsumptionGlobalInfo;
  return proto.aviwest.web.v1.ConsumptionGlobalInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.ConsumptionGlobalInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.ConsumptionGlobalInfo}
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.OptionConsumptionInfo;
      reader.readMessage(value,proto.aviwest.web.v1.OptionConsumptionInfo.deserializeBinaryFromReader);
      msg.addConsumptions(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.ConsumptionGlobalInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.ConsumptionGlobalInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getConsumptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.aviwest.web.v1.OptionConsumptionInfo.serializeBinaryToWriter
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint64 account_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.ConsumptionGlobalInfo} returns this
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated OptionConsumptionInfo consumptions = 2;
 * @return {!Array<!proto.aviwest.web.v1.OptionConsumptionInfo>}
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.getConsumptionsList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.OptionConsumptionInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.OptionConsumptionInfo, 2));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.OptionConsumptionInfo>} value
 * @return {!proto.aviwest.web.v1.ConsumptionGlobalInfo} returns this
*/
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.setConsumptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.aviwest.web.v1.OptionConsumptionInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.OptionConsumptionInfo}
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.addConsumptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.aviwest.web.v1.OptionConsumptionInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.ConsumptionGlobalInfo} returns this
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.clearConsumptionsList = function() {
  return this.setConsumptionsList([]);
};


/**
 * optional string organization_id = 3;
 * @return {string}
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ConsumptionGlobalInfo} returns this
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string subscription_id = 4;
 * @return {string}
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ConsumptionGlobalInfo} returns this
 */
proto.aviwest.web.v1.ConsumptionGlobalInfo.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.OptionConsumptionInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.OptionConsumptionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.OptionConsumptionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.OptionConsumptionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.OptionConsumptionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    optionType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    consumptionsList: jspb.Message.toObjectList(msg.getConsumptionsList(),
    proto.aviwest.web.v1.OptionMonthlyConsumptions.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.OptionConsumptionInfo}
 */
proto.aviwest.web.v1.OptionConsumptionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.OptionConsumptionInfo;
  return proto.aviwest.web.v1.OptionConsumptionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.OptionConsumptionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.OptionConsumptionInfo}
 */
proto.aviwest.web.v1.OptionConsumptionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionType(value);
      break;
    case 3:
      var value = new proto.aviwest.web.v1.OptionMonthlyConsumptions;
      reader.readMessage(value,proto.aviwest.web.v1.OptionMonthlyConsumptions.deserializeBinaryFromReader);
      msg.addConsumptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.OptionConsumptionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.OptionConsumptionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.OptionConsumptionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.OptionConsumptionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConsumptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.aviwest.web.v1.OptionMonthlyConsumptions.serializeBinaryToWriter
    );
  }
};


/**
 * optional string option_type = 1;
 * @return {string}
 */
proto.aviwest.web.v1.OptionConsumptionInfo.prototype.getOptionType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.OptionConsumptionInfo} returns this
 */
proto.aviwest.web.v1.OptionConsumptionInfo.prototype.setOptionType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated OptionMonthlyConsumptions consumptions = 3;
 * @return {!Array<!proto.aviwest.web.v1.OptionMonthlyConsumptions>}
 */
proto.aviwest.web.v1.OptionConsumptionInfo.prototype.getConsumptionsList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.OptionMonthlyConsumptions>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.OptionMonthlyConsumptions, 3));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.OptionMonthlyConsumptions>} value
 * @return {!proto.aviwest.web.v1.OptionConsumptionInfo} returns this
*/
proto.aviwest.web.v1.OptionConsumptionInfo.prototype.setConsumptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.aviwest.web.v1.OptionMonthlyConsumptions=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumptions}
 */
proto.aviwest.web.v1.OptionConsumptionInfo.prototype.addConsumptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.aviwest.web.v1.OptionMonthlyConsumptions, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.OptionConsumptionInfo} returns this
 */
proto.aviwest.web.v1.OptionConsumptionInfo.prototype.clearConsumptionsList = function() {
  return this.setConsumptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.OptionMonthlyConsumption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.OptionMonthlyConsumption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateStart: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
    manufacturingOrder: jspb.Message.getFieldWithDefault(msg, 5, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumption}
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.OptionMonthlyConsumption;
  return proto.aviwest.web.v1.OptionMonthlyConsumption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.OptionMonthlyConsumption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumption}
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setQuantity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturingOrder(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.OptionMonthlyConsumption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.OptionMonthlyConsumption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateStart();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getManufacturingOrder();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string date_start = 1;
 * @return {string}
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.prototype.getDateStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumption} returns this
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.prototype.setDateStart = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 quantity = 2;
 * @return {number}
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumption} returns this
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string manufacturing_order = 5;
 * @return {string}
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.prototype.getManufacturingOrder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumption} returns this
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.prototype.setManufacturingOrder = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool active = 6;
 * @return {boolean}
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumption} returns this
 */
proto.aviwest.web.v1.OptionMonthlyConsumption.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.OptionMonthlyConsumptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.OptionMonthlyConsumptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    month: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.OptionMonthlyConsumption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumptions}
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.OptionMonthlyConsumptions;
  return proto.aviwest.web.v1.OptionMonthlyConsumptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.OptionMonthlyConsumptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumptions}
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonth(value);
      break;
    case 3:
      var value = new proto.aviwest.web.v1.OptionMonthlyConsumption;
      reader.readMessage(value,proto.aviwest.web.v1.OptionMonthlyConsumption.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.OptionMonthlyConsumptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.OptionMonthlyConsumptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMonth();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.aviwest.web.v1.OptionMonthlyConsumption.serializeBinaryToWriter
    );
  }
};


/**
 * optional string month = 2;
 * @return {string}
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.prototype.getMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumptions} returns this
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.prototype.setMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated OptionMonthlyConsumption data = 3;
 * @return {!Array<!proto.aviwest.web.v1.OptionMonthlyConsumption>}
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.OptionMonthlyConsumption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.OptionMonthlyConsumption, 3));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.OptionMonthlyConsumption>} value
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumptions} returns this
*/
proto.aviwest.web.v1.OptionMonthlyConsumptions.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.aviwest.web.v1.OptionMonthlyConsumption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumption}
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.aviwest.web.v1.OptionMonthlyConsumption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.OptionMonthlyConsumptions} returns this
 */
proto.aviwest.web.v1.OptionMonthlyConsumptions.prototype.clearDataList = function() {
  return this.setDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.NotificationFilters.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.NotificationFilters.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.NotificationFilters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.NotificationFilters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationFilters.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.aviwest.web.v1.NotificationFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.NotificationFilters}
 */
proto.aviwest.web.v1.NotificationFilters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.NotificationFilters;
  return proto.aviwest.web.v1.NotificationFilters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.NotificationFilters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.NotificationFilters}
 */
proto.aviwest.web.v1.NotificationFilters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.NotificationFilter;
      reader.readMessage(value,proto.aviwest.web.v1.NotificationFilter.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.NotificationFilters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.NotificationFilters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.NotificationFilters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationFilters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.aviwest.web.v1.NotificationFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationFilters.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationFilters} returns this
 */
proto.aviwest.web.v1.NotificationFilters.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated NotificationFilter filters = 2;
 * @return {!Array<!proto.aviwest.web.v1.NotificationFilter>}
 */
proto.aviwest.web.v1.NotificationFilters.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.NotificationFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.NotificationFilter, 2));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.NotificationFilter>} value
 * @return {!proto.aviwest.web.v1.NotificationFilters} returns this
*/
proto.aviwest.web.v1.NotificationFilters.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.aviwest.web.v1.NotificationFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.NotificationFilter}
 */
proto.aviwest.web.v1.NotificationFilters.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.aviwest.web.v1.NotificationFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.NotificationFilters} returns this
 */
proto.aviwest.web.v1.NotificationFilters.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.aviwest.web.v1.NotificationFilter.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.aviwest.web.v1.NotificationFilter.FilterCase = {
  FILTER_NOT_SET: 0,
  FILTER_PRODUCT: 1,
  FILTER_ACCOUNT: 2
};

/**
 * @return {proto.aviwest.web.v1.NotificationFilter.FilterCase}
 */
proto.aviwest.web.v1.NotificationFilter.prototype.getFilterCase = function() {
  return /** @type {proto.aviwest.web.v1.NotificationFilter.FilterCase} */(jspb.Message.computeOneofCase(this, proto.aviwest.web.v1.NotificationFilter.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.NotificationFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.NotificationFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.NotificationFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    filterProduct: (f = msg.getFilterProduct()) && proto.aviwest.web.v1.NotificationFilterProduct.toObject(includeInstance, f),
    filterAccount: (f = msg.getFilterAccount()) && proto.aviwest.web.v1.NotificationFilterAccount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.NotificationFilter}
 */
proto.aviwest.web.v1.NotificationFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.NotificationFilter;
  return proto.aviwest.web.v1.NotificationFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.NotificationFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.NotificationFilter}
 */
proto.aviwest.web.v1.NotificationFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.NotificationFilterProduct;
      reader.readMessage(value,proto.aviwest.web.v1.NotificationFilterProduct.deserializeBinaryFromReader);
      msg.setFilterProduct(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.NotificationFilterAccount;
      reader.readMessage(value,proto.aviwest.web.v1.NotificationFilterAccount.deserializeBinaryFromReader);
      msg.setFilterAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.NotificationFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.NotificationFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.NotificationFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilterProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.aviwest.web.v1.NotificationFilterProduct.serializeBinaryToWriter
    );
  }
  f = message.getFilterAccount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.aviwest.web.v1.NotificationFilterAccount.serializeBinaryToWriter
    );
  }
};


/**
 * optional NotificationFilterProduct filter_product = 1;
 * @return {?proto.aviwest.web.v1.NotificationFilterProduct}
 */
proto.aviwest.web.v1.NotificationFilter.prototype.getFilterProduct = function() {
  return /** @type{?proto.aviwest.web.v1.NotificationFilterProduct} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.NotificationFilterProduct, 1));
};


/**
 * @param {?proto.aviwest.web.v1.NotificationFilterProduct|undefined} value
 * @return {!proto.aviwest.web.v1.NotificationFilter} returns this
*/
proto.aviwest.web.v1.NotificationFilter.prototype.setFilterProduct = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.aviwest.web.v1.NotificationFilter.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.NotificationFilter} returns this
 */
proto.aviwest.web.v1.NotificationFilter.prototype.clearFilterProduct = function() {
  return this.setFilterProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.NotificationFilter.prototype.hasFilterProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NotificationFilterAccount filter_account = 2;
 * @return {?proto.aviwest.web.v1.NotificationFilterAccount}
 */
proto.aviwest.web.v1.NotificationFilter.prototype.getFilterAccount = function() {
  return /** @type{?proto.aviwest.web.v1.NotificationFilterAccount} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.NotificationFilterAccount, 2));
};


/**
 * @param {?proto.aviwest.web.v1.NotificationFilterAccount|undefined} value
 * @return {!proto.aviwest.web.v1.NotificationFilter} returns this
*/
proto.aviwest.web.v1.NotificationFilter.prototype.setFilterAccount = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.aviwest.web.v1.NotificationFilter.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.NotificationFilter} returns this
 */
proto.aviwest.web.v1.NotificationFilter.prototype.clearFilterAccount = function() {
  return this.setFilterAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.NotificationFilter.prototype.hasFilterAccount = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.NotificationFilterProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.NotificationFilterProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.NotificationFilterProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationFilterProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.NotificationFilterProduct}
 */
proto.aviwest.web.v1.NotificationFilterProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.NotificationFilterProduct;
  return proto.aviwest.web.v1.NotificationFilterProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.NotificationFilterProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.NotificationFilterProduct}
 */
proto.aviwest.web.v1.NotificationFilterProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.NotificationFilterProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.NotificationFilterProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.NotificationFilterProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationFilterProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.NotificationFilterProduct.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.NotificationFilterProduct} returns this
 */
proto.aviwest.web.v1.NotificationFilterProduct.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.NotificationFilterAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.NotificationFilterAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.NotificationFilterAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationFilterAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.NotificationFilterAccount}
 */
proto.aviwest.web.v1.NotificationFilterAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.NotificationFilterAccount;
  return proto.aviwest.web.v1.NotificationFilterAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.NotificationFilterAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.NotificationFilterAccount}
 */
proto.aviwest.web.v1.NotificationFilterAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.NotificationFilterAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.NotificationFilterAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.NotificationFilterAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationFilterAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.NotificationFilterAccount.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.NotificationFilterAccount} returns this
 */
proto.aviwest.web.v1.NotificationFilterAccount.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.aviwest.web.v1.NotificationMessage.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.aviwest.web.v1.NotificationMessage.MessageCase = {
  MESSAGE_NOT_SET: 0,
  INFOS: 1,
  ECHO: 2
};

/**
 * @return {proto.aviwest.web.v1.NotificationMessage.MessageCase}
 */
proto.aviwest.web.v1.NotificationMessage.prototype.getMessageCase = function() {
  return /** @type {proto.aviwest.web.v1.NotificationMessage.MessageCase} */(jspb.Message.computeOneofCase(this, proto.aviwest.web.v1.NotificationMessage.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.NotificationMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.NotificationMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.NotificationMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    infos: (f = msg.getInfos()) && proto.aviwest.web.v1.NotificationInfos.toObject(includeInstance, f),
    echo: (f = msg.getEcho()) && proto.aviwest.web.v1.NotificationEcho.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.NotificationMessage}
 */
proto.aviwest.web.v1.NotificationMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.NotificationMessage;
  return proto.aviwest.web.v1.NotificationMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.NotificationMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.NotificationMessage}
 */
proto.aviwest.web.v1.NotificationMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.NotificationInfos;
      reader.readMessage(value,proto.aviwest.web.v1.NotificationInfos.deserializeBinaryFromReader);
      msg.setInfos(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.NotificationEcho;
      reader.readMessage(value,proto.aviwest.web.v1.NotificationEcho.deserializeBinaryFromReader);
      msg.setEcho(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.NotificationMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.NotificationMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.NotificationMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfos();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.aviwest.web.v1.NotificationInfos.serializeBinaryToWriter
    );
  }
  f = message.getEcho();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.aviwest.web.v1.NotificationEcho.serializeBinaryToWriter
    );
  }
};


/**
 * optional NotificationInfos infos = 1;
 * @return {?proto.aviwest.web.v1.NotificationInfos}
 */
proto.aviwest.web.v1.NotificationMessage.prototype.getInfos = function() {
  return /** @type{?proto.aviwest.web.v1.NotificationInfos} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.NotificationInfos, 1));
};


/**
 * @param {?proto.aviwest.web.v1.NotificationInfos|undefined} value
 * @return {!proto.aviwest.web.v1.NotificationMessage} returns this
*/
proto.aviwest.web.v1.NotificationMessage.prototype.setInfos = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.aviwest.web.v1.NotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.NotificationMessage} returns this
 */
proto.aviwest.web.v1.NotificationMessage.prototype.clearInfos = function() {
  return this.setInfos(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.NotificationMessage.prototype.hasInfos = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NotificationEcho echo = 2;
 * @return {?proto.aviwest.web.v1.NotificationEcho}
 */
proto.aviwest.web.v1.NotificationMessage.prototype.getEcho = function() {
  return /** @type{?proto.aviwest.web.v1.NotificationEcho} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.NotificationEcho, 2));
};


/**
 * @param {?proto.aviwest.web.v1.NotificationEcho|undefined} value
 * @return {!proto.aviwest.web.v1.NotificationMessage} returns this
*/
proto.aviwest.web.v1.NotificationMessage.prototype.setEcho = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.aviwest.web.v1.NotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.NotificationMessage} returns this
 */
proto.aviwest.web.v1.NotificationMessage.prototype.clearEcho = function() {
  return this.setEcho(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.NotificationMessage.prototype.hasEcho = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.NotificationEcho.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.NotificationEcho.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.NotificationEcho} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationEcho.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.NotificationEcho}
 */
proto.aviwest.web.v1.NotificationEcho.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.NotificationEcho;
  return proto.aviwest.web.v1.NotificationEcho.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.NotificationEcho} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.NotificationEcho}
 */
proto.aviwest.web.v1.NotificationEcho.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.NotificationEcho.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.NotificationEcho.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.NotificationEcho} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationEcho.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.NotificationInfos.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.NotificationInfos.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.NotificationInfos.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.NotificationInfos} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationInfos.toObject = function(includeInstance, msg) {
  var f, obj = {
    infosList: jspb.Message.toObjectList(msg.getInfosList(),
    proto.aviwest.web.v1.NotificationInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.NotificationInfos}
 */
proto.aviwest.web.v1.NotificationInfos.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.NotificationInfos;
  return proto.aviwest.web.v1.NotificationInfos.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.NotificationInfos} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.NotificationInfos}
 */
proto.aviwest.web.v1.NotificationInfos.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.NotificationInfo;
      reader.readMessage(value,proto.aviwest.web.v1.NotificationInfo.deserializeBinaryFromReader);
      msg.addInfos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.NotificationInfos.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.NotificationInfos.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.NotificationInfos} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationInfos.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.NotificationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NotificationInfo infos = 1;
 * @return {!Array<!proto.aviwest.web.v1.NotificationInfo>}
 */
proto.aviwest.web.v1.NotificationInfos.prototype.getInfosList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.NotificationInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.NotificationInfo, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.NotificationInfo>} value
 * @return {!proto.aviwest.web.v1.NotificationInfos} returns this
*/
proto.aviwest.web.v1.NotificationInfos.prototype.setInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.NotificationInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.NotificationInfo}
 */
proto.aviwest.web.v1.NotificationInfos.prototype.addInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.NotificationInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.NotificationInfos} returns this
 */
proto.aviwest.web.v1.NotificationInfos.prototype.clearInfosList = function() {
  return this.setInfosList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.aviwest.web.v1.NotificationInfo.oneofGroups_ = [[1,2,3,4,5,6]];

/**
 * @enum {number}
 */
proto.aviwest.web.v1.NotificationInfo.InfoCase = {
  INFO_NOT_SET: 0,
  ACTION: 1,
  PRODUCT_INFO: 2,
  ACCOUNT_INFO: 3,
  PRODUCT_OPTION_INFO: 4,
  CLOUD_PRODUCT: 5,
  CLOUD_PRODUCT_ERROR: 6
};

/**
 * @return {proto.aviwest.web.v1.NotificationInfo.InfoCase}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.getInfoCase = function() {
  return /** @type {proto.aviwest.web.v1.NotificationInfo.InfoCase} */(jspb.Message.computeOneofCase(this, proto.aviwest.web.v1.NotificationInfo.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.NotificationInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.NotificationInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: (f = msg.getAction()) && proto.aviwest.web.v1.Action.toObject(includeInstance, f),
    productInfo: (f = msg.getProductInfo()) && proto.aviwest.web.v1.NotificationProductInfo.toObject(includeInstance, f),
    accountInfo: (f = msg.getAccountInfo()) && proto.aviwest.web.v1.NotificationAccountInfo.toObject(includeInstance, f),
    productOptionInfo: (f = msg.getProductOptionInfo()) && proto.aviwest.web.v1.NotificationProductOptionInfo.toObject(includeInstance, f),
    cloudProduct: (f = msg.getCloudProduct()) && proto.aviwest.web.v1.CloudProduct.toObject(includeInstance, f),
    cloudProductError: (f = msg.getCloudProductError()) && proto.aviwest.web.v1.CloudProductError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.NotificationInfo}
 */
proto.aviwest.web.v1.NotificationInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.NotificationInfo;
  return proto.aviwest.web.v1.NotificationInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.NotificationInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.NotificationInfo}
 */
proto.aviwest.web.v1.NotificationInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.Action;
      reader.readMessage(value,proto.aviwest.web.v1.Action.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.NotificationProductInfo;
      reader.readMessage(value,proto.aviwest.web.v1.NotificationProductInfo.deserializeBinaryFromReader);
      msg.setProductInfo(value);
      break;
    case 3:
      var value = new proto.aviwest.web.v1.NotificationAccountInfo;
      reader.readMessage(value,proto.aviwest.web.v1.NotificationAccountInfo.deserializeBinaryFromReader);
      msg.setAccountInfo(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.NotificationProductOptionInfo;
      reader.readMessage(value,proto.aviwest.web.v1.NotificationProductOptionInfo.deserializeBinaryFromReader);
      msg.setProductOptionInfo(value);
      break;
    case 5:
      var value = new proto.aviwest.web.v1.CloudProduct;
      reader.readMessage(value,proto.aviwest.web.v1.CloudProduct.deserializeBinaryFromReader);
      msg.setCloudProduct(value);
      break;
    case 6:
      var value = new proto.aviwest.web.v1.CloudProductError;
      reader.readMessage(value,proto.aviwest.web.v1.CloudProductError.deserializeBinaryFromReader);
      msg.setCloudProductError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.NotificationInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.NotificationInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.aviwest.web.v1.Action.serializeBinaryToWriter
    );
  }
  f = message.getProductInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.aviwest.web.v1.NotificationProductInfo.serializeBinaryToWriter
    );
  }
  f = message.getAccountInfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.aviwest.web.v1.NotificationAccountInfo.serializeBinaryToWriter
    );
  }
  f = message.getProductOptionInfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.aviwest.web.v1.NotificationProductOptionInfo.serializeBinaryToWriter
    );
  }
  f = message.getCloudProduct();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.aviwest.web.v1.CloudProduct.serializeBinaryToWriter
    );
  }
  f = message.getCloudProductError();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.aviwest.web.v1.CloudProductError.serializeBinaryToWriter
    );
  }
};


/**
 * optional Action action = 1;
 * @return {?proto.aviwest.web.v1.Action}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.getAction = function() {
  return /** @type{?proto.aviwest.web.v1.Action} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.Action, 1));
};


/**
 * @param {?proto.aviwest.web.v1.Action|undefined} value
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
*/
proto.aviwest.web.v1.NotificationInfo.prototype.setAction = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.aviwest.web.v1.NotificationInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
 */
proto.aviwest.web.v1.NotificationInfo.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.hasAction = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NotificationProductInfo product_info = 2;
 * @return {?proto.aviwest.web.v1.NotificationProductInfo}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.getProductInfo = function() {
  return /** @type{?proto.aviwest.web.v1.NotificationProductInfo} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.NotificationProductInfo, 2));
};


/**
 * @param {?proto.aviwest.web.v1.NotificationProductInfo|undefined} value
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
*/
proto.aviwest.web.v1.NotificationInfo.prototype.setProductInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.aviwest.web.v1.NotificationInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
 */
proto.aviwest.web.v1.NotificationInfo.prototype.clearProductInfo = function() {
  return this.setProductInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.hasProductInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NotificationAccountInfo account_info = 3;
 * @return {?proto.aviwest.web.v1.NotificationAccountInfo}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.getAccountInfo = function() {
  return /** @type{?proto.aviwest.web.v1.NotificationAccountInfo} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.NotificationAccountInfo, 3));
};


/**
 * @param {?proto.aviwest.web.v1.NotificationAccountInfo|undefined} value
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
*/
proto.aviwest.web.v1.NotificationInfo.prototype.setAccountInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.aviwest.web.v1.NotificationInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
 */
proto.aviwest.web.v1.NotificationInfo.prototype.clearAccountInfo = function() {
  return this.setAccountInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.hasAccountInfo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional NotificationProductOptionInfo product_option_info = 4;
 * @return {?proto.aviwest.web.v1.NotificationProductOptionInfo}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.getProductOptionInfo = function() {
  return /** @type{?proto.aviwest.web.v1.NotificationProductOptionInfo} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.NotificationProductOptionInfo, 4));
};


/**
 * @param {?proto.aviwest.web.v1.NotificationProductOptionInfo|undefined} value
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
*/
proto.aviwest.web.v1.NotificationInfo.prototype.setProductOptionInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.aviwest.web.v1.NotificationInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
 */
proto.aviwest.web.v1.NotificationInfo.prototype.clearProductOptionInfo = function() {
  return this.setProductOptionInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.hasProductOptionInfo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional CloudProduct cloud_product = 5;
 * @return {?proto.aviwest.web.v1.CloudProduct}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.getCloudProduct = function() {
  return /** @type{?proto.aviwest.web.v1.CloudProduct} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.CloudProduct, 5));
};


/**
 * @param {?proto.aviwest.web.v1.CloudProduct|undefined} value
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
*/
proto.aviwest.web.v1.NotificationInfo.prototype.setCloudProduct = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.aviwest.web.v1.NotificationInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
 */
proto.aviwest.web.v1.NotificationInfo.prototype.clearCloudProduct = function() {
  return this.setCloudProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.hasCloudProduct = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional CloudProductError cloud_product_error = 6;
 * @return {?proto.aviwest.web.v1.CloudProductError}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.getCloudProductError = function() {
  return /** @type{?proto.aviwest.web.v1.CloudProductError} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.CloudProductError, 6));
};


/**
 * @param {?proto.aviwest.web.v1.CloudProductError|undefined} value
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
*/
proto.aviwest.web.v1.NotificationInfo.prototype.setCloudProductError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.aviwest.web.v1.NotificationInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.NotificationInfo} returns this
 */
proto.aviwest.web.v1.NotificationInfo.prototype.clearCloudProductError = function() {
  return this.setCloudProductError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.NotificationInfo.prototype.hasCloudProductError = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.NotificationProductInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.NotificationProductInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationProductInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    productId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lastPublicIp: jspb.Message.getFieldWithDefault(msg, 4, ""),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    date: jspb.Message.getFieldWithDefault(msg, 6, ""),
    lastConnectedDate: jspb.Message.getFieldWithDefault(msg, 7, ""),
    firmwareVersion: jspb.Message.getFieldWithDefault(msg, 8, ""),
    licenseType: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.NotificationProductInfo}
 */
proto.aviwest.web.v1.NotificationProductInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.NotificationProductInfo;
  return proto.aviwest.web.v1.NotificationProductInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.NotificationProductInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.NotificationProductInfo}
 */
proto.aviwest.web.v1.NotificationProductInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastPublicIp(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastConnectedDate(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmwareVersion(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLicenseType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.NotificationProductInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.NotificationProductInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationProductInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastPublicIp();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLastConnectedDate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFirmwareVersion();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLicenseType();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.NotificationProductInfo} returns this
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string product_id = 2;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationProductInfo} returns this
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationProductInfo} returns this
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_public_ip = 4;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.getLastPublicIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationProductInfo} returns this
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.setLastPublicIp = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationProductInfo} returns this
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string date = 6;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationProductInfo} returns this
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string last_connected_date = 7;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.getLastConnectedDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationProductInfo} returns this
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.setLastConnectedDate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string firmware_version = 8;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.getFirmwareVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationProductInfo} returns this
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.setFirmwareVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string license_type = 9;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.getLicenseType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationProductInfo} returns this
 */
proto.aviwest.web.v1.NotificationProductInfo.prototype.setLicenseType = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.NotificationProductOptionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.NotificationProductOptionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.aviwest.web.v1.Option.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.NotificationProductOptionInfo}
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.NotificationProductOptionInfo;
  return proto.aviwest.web.v1.NotificationProductOptionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.NotificationProductOptionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.NotificationProductOptionInfo}
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.Option;
      reader.readMessage(value,proto.aviwest.web.v1.Option.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.NotificationProductOptionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.NotificationProductOptionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.aviwest.web.v1.Option.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.NotificationProductOptionInfo} returns this
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated Option options = 2;
 * @return {!Array<!proto.aviwest.web.v1.Option>}
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Option>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Option, 2));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Option>} value
 * @return {!proto.aviwest.web.v1.NotificationProductOptionInfo} returns this
*/
proto.aviwest.web.v1.NotificationProductOptionInfo.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.aviwest.web.v1.Option=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Option}
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.aviwest.web.v1.Option, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.NotificationProductOptionInfo} returns this
 */
proto.aviwest.web.v1.NotificationProductOptionInfo.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.NotificationAccountInfo.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.NotificationAccountInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.NotificationAccountInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationAccountInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    endOfSupport: jspb.Message.getFieldWithDefault(msg, 3, ""),
    keyCreation: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accountOptionsList: jspb.Message.toObjectList(msg.getAccountOptionsList(),
    proto.aviwest.web.v1.AccountOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.NotificationAccountInfo}
 */
proto.aviwest.web.v1.NotificationAccountInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.NotificationAccountInfo;
  return proto.aviwest.web.v1.NotificationAccountInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.NotificationAccountInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.NotificationAccountInfo}
 */
proto.aviwest.web.v1.NotificationAccountInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndOfSupport(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyCreation(value);
      break;
    case 5:
      var value = new proto.aviwest.web.v1.AccountOption;
      reader.readMessage(value,proto.aviwest.web.v1.AccountOption.deserializeBinaryFromReader);
      msg.addAccountOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.NotificationAccountInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.NotificationAccountInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.NotificationAccountInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEndOfSupport();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getKeyCreation();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.aviwest.web.v1.AccountOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.NotificationAccountInfo} returns this
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationAccountInfo} returns this
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string end_of_support = 3;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.getEndOfSupport = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationAccountInfo} returns this
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.setEndOfSupport = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string key_creation = 4;
 * @return {string}
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.getKeyCreation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.NotificationAccountInfo} returns this
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.setKeyCreation = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated AccountOption account_options = 5;
 * @return {!Array<!proto.aviwest.web.v1.AccountOption>}
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.getAccountOptionsList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.AccountOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.AccountOption, 5));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.AccountOption>} value
 * @return {!proto.aviwest.web.v1.NotificationAccountInfo} returns this
*/
proto.aviwest.web.v1.NotificationAccountInfo.prototype.setAccountOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.aviwest.web.v1.AccountOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.AccountOption}
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.addAccountOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.aviwest.web.v1.AccountOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.NotificationAccountInfo} returns this
 */
proto.aviwest.web.v1.NotificationAccountInfo.prototype.clearAccountOptionsList = function() {
  return this.setAccountOptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Action.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Action.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Action} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Action.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    created: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, ""),
    level: jspb.Message.getFieldWithDefault(msg, 4, ""),
    origin: jspb.Message.getFieldWithDefault(msg, 5, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 8, 0),
    accountName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    context: jspb.Message.getFieldWithDefault(msg, 12, ""),
    userEmail: jspb.Message.getFieldWithDefault(msg, 13, ""),
    organizationId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Action}
 */
proto.aviwest.web.v1.Action.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Action;
  return proto.aviwest.web.v1.Action.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Action} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Action}
 */
proto.aviwest.web.v1.Action.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreated(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLevel(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setProductId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setContext(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Action.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Action.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Action} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Action.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getCreated();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLevel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOrigin();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProductId();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getContext();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Action.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string created = 2;
 * @return {string}
 */
proto.aviwest.web.v1.Action.prototype.getCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.aviwest.web.v1.Action.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string level = 4;
 * @return {string}
 */
proto.aviwest.web.v1.Action.prototype.getLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string origin = 5;
 * @return {string}
 */
proto.aviwest.web.v1.Action.prototype.getOrigin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setOrigin = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint64 product_id = 6;
 * @return {number}
 */
proto.aviwest.web.v1.Action.prototype.getProductId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setProductId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint64 account_id = 8;
 * @return {number}
 */
proto.aviwest.web.v1.Action.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string account_name = 9;
 * @return {string}
 */
proto.aviwest.web.v1.Action.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string context = 12;
 * @return {string}
 */
proto.aviwest.web.v1.Action.prototype.getContext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setContext = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string user_email = 13;
 * @return {string}
 */
proto.aviwest.web.v1.Action.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string organization_id = 14;
 * @return {string}
 */
proto.aviwest.web.v1.Action.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string subscription_id = 15;
 * @return {string}
 */
proto.aviwest.web.v1.Action.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Action} returns this
 */
proto.aviwest.web.v1.Action.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.Actions.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Actions.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Actions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Actions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Actions.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.Action.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Actions}
 */
proto.aviwest.web.v1.Actions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Actions;
  return proto.aviwest.web.v1.Actions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Actions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Actions}
 */
proto.aviwest.web.v1.Actions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.Action;
      reader.readMessage(value,proto.aviwest.web.v1.Action.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Actions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Actions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Actions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Actions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.Action.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Actions.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Actions} returns this
 */
proto.aviwest.web.v1.Actions.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Actions.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Actions} returns this
 */
proto.aviwest.web.v1.Actions.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.aviwest.web.v1.Actions.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Actions} returns this
 */
proto.aviwest.web.v1.Actions.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Action data = 4;
 * @return {!Array<!proto.aviwest.web.v1.Action>}
 */
proto.aviwest.web.v1.Actions.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Action>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Action, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Action>} value
 * @return {!proto.aviwest.web.v1.Actions} returns this
*/
proto.aviwest.web.v1.Actions.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.Action=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Action}
 */
proto.aviwest.web.v1.Actions.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.Action, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.Actions} returns this
 */
proto.aviwest.web.v1.Actions.prototype.clearDataList = function() {
  return this.setDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.AccountDockerOption.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountDockerOption.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountDockerOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountDockerOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountDockerOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.aviwest.web.v1.Option.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountDockerOption}
 */
proto.aviwest.web.v1.AccountDockerOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountDockerOption;
  return proto.aviwest.web.v1.AccountDockerOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountDockerOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountDockerOption}
 */
proto.aviwest.web.v1.AccountDockerOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.Option;
      reader.readMessage(value,proto.aviwest.web.v1.Option.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountDockerOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountDockerOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountDockerOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountDockerOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.aviwest.web.v1.Option.serializeBinaryToWriter
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.aviwest.web.v1.AccountDockerOption.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.AccountDockerOption} returns this
 */
proto.aviwest.web.v1.AccountDockerOption.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Option options = 2;
 * @return {!Array<!proto.aviwest.web.v1.Option>}
 */
proto.aviwest.web.v1.AccountDockerOption.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Option>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Option, 2));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Option>} value
 * @return {!proto.aviwest.web.v1.AccountDockerOption} returns this
*/
proto.aviwest.web.v1.AccountDockerOption.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.aviwest.web.v1.Option=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Option}
 */
proto.aviwest.web.v1.AccountDockerOption.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.aviwest.web.v1.Option, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.AccountDockerOption} returns this
 */
proto.aviwest.web.v1.AccountDockerOption.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.AccountDockerOptions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AccountDockerOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AccountDockerOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AccountDockerOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountDockerOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.AccountDockerOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AccountDockerOptions}
 */
proto.aviwest.web.v1.AccountDockerOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AccountDockerOptions;
  return proto.aviwest.web.v1.AccountDockerOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AccountDockerOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AccountDockerOptions}
 */
proto.aviwest.web.v1.AccountDockerOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.AccountDockerOption;
      reader.readMessage(value,proto.aviwest.web.v1.AccountDockerOption.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AccountDockerOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AccountDockerOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AccountDockerOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AccountDockerOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.AccountDockerOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountDockerOption data = 1;
 * @return {!Array<!proto.aviwest.web.v1.AccountDockerOption>}
 */
proto.aviwest.web.v1.AccountDockerOptions.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.AccountDockerOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.AccountDockerOption, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.AccountDockerOption>} value
 * @return {!proto.aviwest.web.v1.AccountDockerOptions} returns this
*/
proto.aviwest.web.v1.AccountDockerOptions.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.AccountDockerOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.AccountDockerOption}
 */
proto.aviwest.web.v1.AccountDockerOptions.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.AccountDockerOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.AccountDockerOptions} returns this
 */
proto.aviwest.web.v1.AccountDockerOptions.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.FieldUnit.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.FieldUnit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.FieldUnit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.FieldUnit.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    created: jspb.Message.getFieldWithDefault(msg, 3, ""),
    updated: jspb.Message.getFieldWithDefault(msg, 4, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    familyName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    firmwareName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    hwId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 10, 0),
    status: jspb.Message.getFieldWithDefault(msg, 11, ""),
    firmwareVersion: jspb.Message.getFieldWithDefault(msg, 12, ""),
    lastConnectedDate: jspb.Message.getFieldWithDefault(msg, 13, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    productName: jspb.Message.getFieldWithDefault(msg, 16, ""),
    ownerPhone: jspb.Message.getFieldWithDefault(msg, 18, ""),
    ownerEmail: jspb.Message.getFieldWithDefault(msg, 19, ""),
    comments: jspb.Message.getFieldWithDefault(msg, 20, ""),
    remoteControlUrl: jspb.Message.getFieldWithDefault(msg, 21, ""),
    instanceCount: jspb.Message.getFieldWithDefault(msg, 22, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 23, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 24, ""),
    groupUuid: jspb.Message.getFieldWithDefault(msg, 25, ""),
    mcrVisible: jspb.Message.getBooleanFieldWithDefault(msg, 26, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.FieldUnit}
 */
proto.aviwest.web.v1.FieldUnit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.FieldUnit;
  return proto.aviwest.web.v1.FieldUnit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.FieldUnit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.FieldUnit}
 */
proto.aviwest.web.v1.FieldUnit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreated(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdated(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilyName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmwareName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setHwId(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmwareVersion(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastConnectedDate(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerPhone(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerEmail(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setComments(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemoteControlUrl(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstanceCount(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupUuid(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMcrVisible(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.FieldUnit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.FieldUnit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.FieldUnit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.FieldUnit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCreated();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUpdated();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFamilyName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFirmwareName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getHwId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFirmwareVersion();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLastConnectedDate();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getOwnerPhone();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getOwnerEmail();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getComments();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getRemoteControlUrl();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getInstanceCount();
  if (f !== 0) {
    writer.writeUint32(
      22,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getGroupUuid();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getMcrVisible();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 version = 2;
 * @return {number}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string created = 3;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string updated = 4;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getUpdated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setUpdated = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string display_name = 6;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string family_name = 7;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getFamilyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setFamilyName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string firmware_name = 8;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getFirmwareName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setFirmwareName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string hw_id = 9;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getHwId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setHwId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional uint64 account_id = 10;
 * @return {number}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string status = 11;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string firmware_version = 12;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getFirmwareVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setFirmwareVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string last_connected_date = 13;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getLastConnectedDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setLastConnectedDate = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool active = 14;
 * @return {boolean}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string product_name = 16;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string owner_phone = 18;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getOwnerPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setOwnerPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string owner_email = 19;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getOwnerEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setOwnerEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string comments = 20;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getComments = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setComments = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string remote_control_url = 21;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getRemoteControlUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setRemoteControlUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional uint32 instance_count = 22;
 * @return {number}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getInstanceCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setInstanceCount = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional string organization_id = 23;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string subscription_id = 24;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string group_uuid = 25;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getGroupUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setGroupUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional bool mcr_visible = 26;
 * @return {boolean}
 */
proto.aviwest.web.v1.FieldUnit.prototype.getMcrVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.FieldUnit} returns this
 */
proto.aviwest.web.v1.FieldUnit.prototype.setMcrVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.FieldUnits.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.FieldUnits.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.FieldUnits.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.FieldUnits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.FieldUnits.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.FieldUnit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.FieldUnits}
 */
proto.aviwest.web.v1.FieldUnits.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.FieldUnits;
  return proto.aviwest.web.v1.FieldUnits.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.FieldUnits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.FieldUnits}
 */
proto.aviwest.web.v1.FieldUnits.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.FieldUnit;
      reader.readMessage(value,proto.aviwest.web.v1.FieldUnit.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.FieldUnits.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.FieldUnits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.FieldUnits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.FieldUnits.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.FieldUnit.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.FieldUnits.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.FieldUnits} returns this
 */
proto.aviwest.web.v1.FieldUnits.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.FieldUnits.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.FieldUnits} returns this
 */
proto.aviwest.web.v1.FieldUnits.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.aviwest.web.v1.FieldUnits.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.FieldUnits} returns this
 */
proto.aviwest.web.v1.FieldUnits.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated FieldUnit data = 4;
 * @return {!Array<!proto.aviwest.web.v1.FieldUnit>}
 */
proto.aviwest.web.v1.FieldUnits.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.FieldUnit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.FieldUnit, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.FieldUnit>} value
 * @return {!proto.aviwest.web.v1.FieldUnits} returns this
*/
proto.aviwest.web.v1.FieldUnits.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.FieldUnit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.FieldUnit}
 */
proto.aviwest.web.v1.FieldUnits.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.FieldUnit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.FieldUnits} returns this
 */
proto.aviwest.web.v1.FieldUnits.prototype.clearDataList = function() {
  return this.setDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.MakitoConfigurationForm.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.MakitoConfigurationForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.MakitoConfigurationForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.MakitoConfigurationForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    organizationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    deviceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    videoEncoderId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    audioEncoderIdList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.MakitoConfigurationForm}
 */
proto.aviwest.web.v1.MakitoConfigurationForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.MakitoConfigurationForm;
  return proto.aviwest.web.v1.MakitoConfigurationForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.MakitoConfigurationForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.MakitoConfigurationForm}
 */
proto.aviwest.web.v1.MakitoConfigurationForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoEncoderId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addAudioEncoderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.MakitoConfigurationForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.MakitoConfigurationForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.MakitoConfigurationForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVideoEncoderId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAudioEncoderIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional string organization_id = 1;
 * @return {string}
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.MakitoConfigurationForm} returns this
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.MakitoConfigurationForm} returns this
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string device_id = 3;
 * @return {string}
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.MakitoConfigurationForm} returns this
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string video_encoder_id = 4;
 * @return {string}
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.getVideoEncoderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.MakitoConfigurationForm} returns this
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.setVideoEncoderId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string audio_encoder_id = 5;
 * @return {!Array<string>}
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.getAudioEncoderIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.aviwest.web.v1.MakitoConfigurationForm} returns this
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.setAudioEncoderIdList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.MakitoConfigurationForm} returns this
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.addAudioEncoderId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.MakitoConfigurationForm} returns this
 */
proto.aviwest.web.v1.MakitoConfigurationForm.prototype.clearAudioEncoderIdList = function() {
  return this.setAudioEncoderIdList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.LiveForm.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LiveForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LiveForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LiveForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fieldUnitId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    instanceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    deviceId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    videoEncoderId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    audioEncoderIdList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LiveForm}
 */
proto.aviwest.web.v1.LiveForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LiveForm;
  return proto.aviwest.web.v1.LiveForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LiveForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LiveForm}
 */
proto.aviwest.web.v1.LiveForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFieldUnitId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setInstanceId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoEncoderId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addAudioEncoderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LiveForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LiveForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LiveForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getFieldUnitId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getInstanceId();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getVideoEncoderId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAudioEncoderIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
};


/**
 * optional uint64 account_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.LiveForm.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.LiveForm} returns this
 */
proto.aviwest.web.v1.LiveForm.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 field_unit_id = 2;
 * @return {number}
 */
proto.aviwest.web.v1.LiveForm.prototype.getFieldUnitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.LiveForm} returns this
 */
proto.aviwest.web.v1.LiveForm.prototype.setFieldUnitId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 instance_id = 3;
 * @return {number}
 */
proto.aviwest.web.v1.LiveForm.prototype.getInstanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.LiveForm} returns this
 */
proto.aviwest.web.v1.LiveForm.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string organization_id = 4;
 * @return {string}
 */
proto.aviwest.web.v1.LiveForm.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveForm} returns this
 */
proto.aviwest.web.v1.LiveForm.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subscription_id = 5;
 * @return {string}
 */
proto.aviwest.web.v1.LiveForm.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveForm} returns this
 */
proto.aviwest.web.v1.LiveForm.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string device_id = 7;
 * @return {string}
 */
proto.aviwest.web.v1.LiveForm.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveForm} returns this
 */
proto.aviwest.web.v1.LiveForm.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string video_encoder_id = 8;
 * @return {string}
 */
proto.aviwest.web.v1.LiveForm.prototype.getVideoEncoderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveForm} returns this
 */
proto.aviwest.web.v1.LiveForm.prototype.setVideoEncoderId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated string audio_encoder_id = 9;
 * @return {!Array<string>}
 */
proto.aviwest.web.v1.LiveForm.prototype.getAudioEncoderIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.aviwest.web.v1.LiveForm} returns this
 */
proto.aviwest.web.v1.LiveForm.prototype.setAudioEncoderIdList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.LiveForm} returns this
 */
proto.aviwest.web.v1.LiveForm.prototype.addAudioEncoderId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.LiveForm} returns this
 */
proto.aviwest.web.v1.LiveForm.prototype.clearAudioEncoderIdList = function() {
  return this.setAudioEncoderIdList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LatencyForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LatencyForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LatencyForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LatencyForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fieldUnitId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    instanceId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    deviceId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    videoEncoderId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    latency: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LatencyForm}
 */
proto.aviwest.web.v1.LatencyForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LatencyForm;
  return proto.aviwest.web.v1.LatencyForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LatencyForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LatencyForm}
 */
proto.aviwest.web.v1.LatencyForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFieldUnitId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstanceId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoEncoderId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLatency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LatencyForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LatencyForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LatencyForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LatencyForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFieldUnitId();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getInstanceId();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getVideoEncoderId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLatency();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
};


/**
 * optional uint64 account_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.LatencyForm.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.LatencyForm} returns this
 */
proto.aviwest.web.v1.LatencyForm.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string organization_id = 2;
 * @return {string}
 */
proto.aviwest.web.v1.LatencyForm.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LatencyForm} returns this
 */
proto.aviwest.web.v1.LatencyForm.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string subscription_id = 3;
 * @return {string}
 */
proto.aviwest.web.v1.LatencyForm.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LatencyForm} returns this
 */
proto.aviwest.web.v1.LatencyForm.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 field_unit_id = 4;
 * @return {number}
 */
proto.aviwest.web.v1.LatencyForm.prototype.getFieldUnitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.LatencyForm} returns this
 */
proto.aviwest.web.v1.LatencyForm.prototype.setFieldUnitId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 instance_id = 5;
 * @return {number}
 */
proto.aviwest.web.v1.LatencyForm.prototype.getInstanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.LatencyForm} returns this
 */
proto.aviwest.web.v1.LatencyForm.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string device_id = 6;
 * @return {string}
 */
proto.aviwest.web.v1.LatencyForm.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LatencyForm} returns this
 */
proto.aviwest.web.v1.LatencyForm.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string video_encoder_id = 7;
 * @return {string}
 */
proto.aviwest.web.v1.LatencyForm.prototype.getVideoEncoderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LatencyForm} returns this
 */
proto.aviwest.web.v1.LatencyForm.prototype.setVideoEncoderId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint32 latency = 8;
 * @return {number}
 */
proto.aviwest.web.v1.LatencyForm.prototype.getLatency = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.LatencyForm} returns this
 */
proto.aviwest.web.v1.LatencyForm.prototype.setLatency = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.BitrateForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.BitrateForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.BitrateForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.BitrateForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fieldUnitId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    instanceId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    deviceId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    videoEncoderId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    bitrate: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.BitrateForm}
 */
proto.aviwest.web.v1.BitrateForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.BitrateForm;
  return proto.aviwest.web.v1.BitrateForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.BitrateForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.BitrateForm}
 */
proto.aviwest.web.v1.BitrateForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFieldUnitId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstanceId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoEncoderId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBitrate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.BitrateForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.BitrateForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.BitrateForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.BitrateForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFieldUnitId();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getInstanceId();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getVideoEncoderId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBitrate();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
};


/**
 * optional uint64 account_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.BitrateForm.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.BitrateForm} returns this
 */
proto.aviwest.web.v1.BitrateForm.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string organization_id = 2;
 * @return {string}
 */
proto.aviwest.web.v1.BitrateForm.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.BitrateForm} returns this
 */
proto.aviwest.web.v1.BitrateForm.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string subscription_id = 3;
 * @return {string}
 */
proto.aviwest.web.v1.BitrateForm.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.BitrateForm} returns this
 */
proto.aviwest.web.v1.BitrateForm.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 field_unit_id = 4;
 * @return {number}
 */
proto.aviwest.web.v1.BitrateForm.prototype.getFieldUnitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.BitrateForm} returns this
 */
proto.aviwest.web.v1.BitrateForm.prototype.setFieldUnitId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 instance_id = 5;
 * @return {number}
 */
proto.aviwest.web.v1.BitrateForm.prototype.getInstanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.BitrateForm} returns this
 */
proto.aviwest.web.v1.BitrateForm.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string device_id = 6;
 * @return {string}
 */
proto.aviwest.web.v1.BitrateForm.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.BitrateForm} returns this
 */
proto.aviwest.web.v1.BitrateForm.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string video_encoder_id = 7;
 * @return {string}
 */
proto.aviwest.web.v1.BitrateForm.prototype.getVideoEncoderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.BitrateForm} returns this
 */
proto.aviwest.web.v1.BitrateForm.prototype.setVideoEncoderId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint32 bitrate = 8;
 * @return {number}
 */
proto.aviwest.web.v1.BitrateForm.prototype.getBitrate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.BitrateForm} returns this
 */
proto.aviwest.web.v1.BitrateForm.prototype.setBitrate = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.ShInputForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.ShInputForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.ShInputForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ShInputForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    streamhubId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    inputUid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    organizationId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.ShInputForm}
 */
proto.aviwest.web.v1.ShInputForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.ShInputForm;
  return proto.aviwest.web.v1.ShInputForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.ShInputForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.ShInputForm}
 */
proto.aviwest.web.v1.ShInputForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreamhubId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInputUid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.ShInputForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.ShInputForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.ShInputForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ShInputForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getStreamhubId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInputUid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional uint64 account_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.ShInputForm.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.ShInputForm} returns this
 */
proto.aviwest.web.v1.ShInputForm.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string streamhub_id = 2;
 * @return {string}
 */
proto.aviwest.web.v1.ShInputForm.prototype.getStreamhubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ShInputForm} returns this
 */
proto.aviwest.web.v1.ShInputForm.prototype.setStreamhubId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string input_uid = 3;
 * @return {string}
 */
proto.aviwest.web.v1.ShInputForm.prototype.getInputUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ShInputForm} returns this
 */
proto.aviwest.web.v1.ShInputForm.prototype.setInputUid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string organization_id = 4;
 * @return {string}
 */
proto.aviwest.web.v1.ShInputForm.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ShInputForm} returns this
 */
proto.aviwest.web.v1.ShInputForm.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subscription_id = 5;
 * @return {string}
 */
proto.aviwest.web.v1.ShInputForm.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ShInputForm} returns this
 */
proto.aviwest.web.v1.ShInputForm.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.RouteUpdateForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.RouteUpdateForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.RouteUpdateForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RouteUpdateForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    route: (f = msg.getRoute()) && proto.aviwest.web.v1.Route.toObject(includeInstance, f),
    organizationId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.RouteUpdateForm}
 */
proto.aviwest.web.v1.RouteUpdateForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.RouteUpdateForm;
  return proto.aviwest.web.v1.RouteUpdateForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.RouteUpdateForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.RouteUpdateForm}
 */
proto.aviwest.web.v1.RouteUpdateForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.Route;
      reader.readMessage(value,proto.aviwest.web.v1.Route.deserializeBinaryFromReader);
      msg.setRoute(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.RouteUpdateForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.RouteUpdateForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.RouteUpdateForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RouteUpdateForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getRoute();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.aviwest.web.v1.Route.serializeBinaryToWriter
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint64 account_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.RouteUpdateForm.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.RouteUpdateForm} returns this
 */
proto.aviwest.web.v1.RouteUpdateForm.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Route route = 2;
 * @return {?proto.aviwest.web.v1.Route}
 */
proto.aviwest.web.v1.RouteUpdateForm.prototype.getRoute = function() {
  return /** @type{?proto.aviwest.web.v1.Route} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.Route, 2));
};


/**
 * @param {?proto.aviwest.web.v1.Route|undefined} value
 * @return {!proto.aviwest.web.v1.RouteUpdateForm} returns this
*/
proto.aviwest.web.v1.RouteUpdateForm.prototype.setRoute = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.RouteUpdateForm} returns this
 */
proto.aviwest.web.v1.RouteUpdateForm.prototype.clearRoute = function() {
  return this.setRoute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.RouteUpdateForm.prototype.hasRoute = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string organization_id = 3;
 * @return {string}
 */
proto.aviwest.web.v1.RouteUpdateForm.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RouteUpdateForm} returns this
 */
proto.aviwest.web.v1.RouteUpdateForm.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string subscription_id = 4;
 * @return {string}
 */
proto.aviwest.web.v1.RouteUpdateForm.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RouteUpdateForm} returns this
 */
proto.aviwest.web.v1.RouteUpdateForm.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.GetRoutesByHwIdForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.GetRoutesByHwIdForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hwId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    organizationId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.GetRoutesByHwIdForm}
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.GetRoutesByHwIdForm;
  return proto.aviwest.web.v1.GetRoutesByHwIdForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.GetRoutesByHwIdForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.GetRoutesByHwIdForm}
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHwId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.GetRoutesByHwIdForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.GetRoutesByHwIdForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getHwId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint64 account_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.GetRoutesByHwIdForm} returns this
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string hw_id = 2;
 * @return {string}
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.prototype.getHwId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.GetRoutesByHwIdForm} returns this
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.prototype.setHwId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string organization_id = 3;
 * @return {string}
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.GetRoutesByHwIdForm} returns this
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string subscription_id = 4;
 * @return {string}
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.GetRoutesByHwIdForm} returns this
 */
proto.aviwest.web.v1.GetRoutesByHwIdForm.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.BookForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.BookForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.BookForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.BookForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    streamhubId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    inputUid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fieldUnitId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    instanceId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    deviceId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    videoEncoderId: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.BookForm}
 */
proto.aviwest.web.v1.BookForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.BookForm;
  return proto.aviwest.web.v1.BookForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.BookForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.BookForm}
 */
proto.aviwest.web.v1.BookForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreamhubId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInputUid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldUnitId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstanceId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoEncoderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.BookForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.BookForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.BookForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.BookForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getStreamhubId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInputUid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFieldUnitId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInstanceId();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getVideoEncoderId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional uint64 account_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.BookForm.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.BookForm} returns this
 */
proto.aviwest.web.v1.BookForm.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string streamhub_id = 2;
 * @return {string}
 */
proto.aviwest.web.v1.BookForm.prototype.getStreamhubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.BookForm} returns this
 */
proto.aviwest.web.v1.BookForm.prototype.setStreamhubId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string input_uid = 3;
 * @return {string}
 */
proto.aviwest.web.v1.BookForm.prototype.getInputUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.BookForm} returns this
 */
proto.aviwest.web.v1.BookForm.prototype.setInputUid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string field_unit_id = 4;
 * @return {string}
 */
proto.aviwest.web.v1.BookForm.prototype.getFieldUnitId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.BookForm} returns this
 */
proto.aviwest.web.v1.BookForm.prototype.setFieldUnitId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 instance_id = 5;
 * @return {number}
 */
proto.aviwest.web.v1.BookForm.prototype.getInstanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.BookForm} returns this
 */
proto.aviwest.web.v1.BookForm.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string organization_id = 6;
 * @return {string}
 */
proto.aviwest.web.v1.BookForm.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.BookForm} returns this
 */
proto.aviwest.web.v1.BookForm.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string subscription_id = 7;
 * @return {string}
 */
proto.aviwest.web.v1.BookForm.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.BookForm} returns this
 */
proto.aviwest.web.v1.BookForm.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string device_id = 8;
 * @return {string}
 */
proto.aviwest.web.v1.BookForm.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.BookForm} returns this
 */
proto.aviwest.web.v1.BookForm.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string video_encoder_id = 9;
 * @return {string}
 */
proto.aviwest.web.v1.BookForm.prototype.getVideoEncoderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.BookForm} returns this
 */
proto.aviwest.web.v1.BookForm.prototype.setVideoEncoderId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.StreamhubList.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.StreamhubList.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.StreamhubList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.StreamhubList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.StreamhubList.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hwIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.StreamhubList}
 */
proto.aviwest.web.v1.StreamhubList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.StreamhubList;
  return proto.aviwest.web.v1.StreamhubList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.StreamhubList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.StreamhubList}
 */
proto.aviwest.web.v1.StreamhubList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addHwIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.StreamhubList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.StreamhubList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.StreamhubList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.StreamhubList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getHwIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional uint64 account_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.StreamhubList.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.StreamhubList} returns this
 */
proto.aviwest.web.v1.StreamhubList.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated string hw_ids = 2;
 * @return {!Array<string>}
 */
proto.aviwest.web.v1.StreamhubList.prototype.getHwIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.aviwest.web.v1.StreamhubList} returns this
 */
proto.aviwest.web.v1.StreamhubList.prototype.setHwIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.StreamhubList} returns this
 */
proto.aviwest.web.v1.StreamhubList.prototype.addHwIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.StreamhubList} returns this
 */
proto.aviwest.web.v1.StreamhubList.prototype.clearHwIdsList = function() {
  return this.setHwIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.AllRoutes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.AllRoutes.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.AllRoutes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.AllRoutes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AllRoutes.toObject = function(includeInstance, msg) {
  var f, obj = {
    routesList: jspb.Message.toObjectList(msg.getRoutesList(),
    proto.aviwest.web.v1.Routes.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.AllRoutes}
 */
proto.aviwest.web.v1.AllRoutes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.AllRoutes;
  return proto.aviwest.web.v1.AllRoutes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.AllRoutes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.AllRoutes}
 */
proto.aviwest.web.v1.AllRoutes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.Routes;
      reader.readMessage(value,proto.aviwest.web.v1.Routes.deserializeBinaryFromReader);
      msg.addRoutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.AllRoutes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.AllRoutes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.AllRoutes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.AllRoutes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.Routes.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Routes routes = 1;
 * @return {!Array<!proto.aviwest.web.v1.Routes>}
 */
proto.aviwest.web.v1.AllRoutes.prototype.getRoutesList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Routes>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Routes, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Routes>} value
 * @return {!proto.aviwest.web.v1.AllRoutes} returns this
*/
proto.aviwest.web.v1.AllRoutes.prototype.setRoutesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.Routes=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Routes}
 */
proto.aviwest.web.v1.AllRoutes.prototype.addRoutes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.Routes, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.AllRoutes} returns this
 */
proto.aviwest.web.v1.AllRoutes.prototype.clearRoutesList = function() {
  return this.setRoutesList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.aviwest.web.v1.LiveNotificationMessage.oneofGroups_ = [[1,3,13,14,15,16,17,19]];

/**
 * @enum {number}
 */
proto.aviwest.web.v1.LiveNotificationMessage.MessageCase = {
  MESSAGE_NOT_SET: 0,
  ECHO: 1,
  FU_STATUS: 3,
  CTRL_FU_PREVIEW: 13,
  CTRL_SH_PREVIEW_INPUT: 14,
  CTRL_SH_EVENT: 15,
  CTRL_FU_EVENT: 16,
  READY: 17,
  CTRL_MAK_EVENT: 19
};

/**
 * @return {proto.aviwest.web.v1.LiveNotificationMessage.MessageCase}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.getMessageCase = function() {
  return /** @type {proto.aviwest.web.v1.LiveNotificationMessage.MessageCase} */(jspb.Message.computeOneofCase(this, proto.aviwest.web.v1.LiveNotificationMessage.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LiveNotificationMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LiveNotificationMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveNotificationMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    echo: (f = msg.getEcho()) && proto.aviwest.web.v1.NotificationEcho.toObject(includeInstance, f),
    fuStatus: (f = msg.getFuStatus()) && proto.aviwest.web.v1.FieldUnitStatus.toObject(includeInstance, f),
    ctrlFuPreview: (f = msg.getCtrlFuPreview()) && proto.aviwest.web.v1.CtrlFuPreview.toObject(includeInstance, f),
    ctrlShPreviewInput: (f = msg.getCtrlShPreviewInput()) && proto.aviwest.web.v1.CtrlShPreviewInput.toObject(includeInstance, f),
    ctrlShEvent: (f = msg.getCtrlShEvent()) && proto.aviwest.web.v1.CtrlShEvent.toObject(includeInstance, f),
    ctrlFuEvent: (f = msg.getCtrlFuEvent()) && proto.aviwest.web.v1.CtrlFuEvent.toObject(includeInstance, f),
    ready: (f = msg.getReady()) && proto.aviwest.web.v1.ServiceReady.toObject(includeInstance, f),
    ctrlMakEvent: (f = msg.getCtrlMakEvent()) && proto.aviwest.web.v1.CtrlMakEvent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage}
 */
proto.aviwest.web.v1.LiveNotificationMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LiveNotificationMessage;
  return proto.aviwest.web.v1.LiveNotificationMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LiveNotificationMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage}
 */
proto.aviwest.web.v1.LiveNotificationMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.NotificationEcho;
      reader.readMessage(value,proto.aviwest.web.v1.NotificationEcho.deserializeBinaryFromReader);
      msg.setEcho(value);
      break;
    case 3:
      var value = new proto.aviwest.web.v1.FieldUnitStatus;
      reader.readMessage(value,proto.aviwest.web.v1.FieldUnitStatus.deserializeBinaryFromReader);
      msg.setFuStatus(value);
      break;
    case 13:
      var value = new proto.aviwest.web.v1.CtrlFuPreview;
      reader.readMessage(value,proto.aviwest.web.v1.CtrlFuPreview.deserializeBinaryFromReader);
      msg.setCtrlFuPreview(value);
      break;
    case 14:
      var value = new proto.aviwest.web.v1.CtrlShPreviewInput;
      reader.readMessage(value,proto.aviwest.web.v1.CtrlShPreviewInput.deserializeBinaryFromReader);
      msg.setCtrlShPreviewInput(value);
      break;
    case 15:
      var value = new proto.aviwest.web.v1.CtrlShEvent;
      reader.readMessage(value,proto.aviwest.web.v1.CtrlShEvent.deserializeBinaryFromReader);
      msg.setCtrlShEvent(value);
      break;
    case 16:
      var value = new proto.aviwest.web.v1.CtrlFuEvent;
      reader.readMessage(value,proto.aviwest.web.v1.CtrlFuEvent.deserializeBinaryFromReader);
      msg.setCtrlFuEvent(value);
      break;
    case 17:
      var value = new proto.aviwest.web.v1.ServiceReady;
      reader.readMessage(value,proto.aviwest.web.v1.ServiceReady.deserializeBinaryFromReader);
      msg.setReady(value);
      break;
    case 19:
      var value = new proto.aviwest.web.v1.CtrlMakEvent;
      reader.readMessage(value,proto.aviwest.web.v1.CtrlMakEvent.deserializeBinaryFromReader);
      msg.setCtrlMakEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LiveNotificationMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LiveNotificationMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveNotificationMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEcho();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.aviwest.web.v1.NotificationEcho.serializeBinaryToWriter
    );
  }
  f = message.getFuStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.aviwest.web.v1.FieldUnitStatus.serializeBinaryToWriter
    );
  }
  f = message.getCtrlFuPreview();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.aviwest.web.v1.CtrlFuPreview.serializeBinaryToWriter
    );
  }
  f = message.getCtrlShPreviewInput();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.aviwest.web.v1.CtrlShPreviewInput.serializeBinaryToWriter
    );
  }
  f = message.getCtrlShEvent();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.aviwest.web.v1.CtrlShEvent.serializeBinaryToWriter
    );
  }
  f = message.getCtrlFuEvent();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.aviwest.web.v1.CtrlFuEvent.serializeBinaryToWriter
    );
  }
  f = message.getReady();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.aviwest.web.v1.ServiceReady.serializeBinaryToWriter
    );
  }
  f = message.getCtrlMakEvent();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.aviwest.web.v1.CtrlMakEvent.serializeBinaryToWriter
    );
  }
};


/**
 * optional NotificationEcho echo = 1;
 * @return {?proto.aviwest.web.v1.NotificationEcho}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.getEcho = function() {
  return /** @type{?proto.aviwest.web.v1.NotificationEcho} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.NotificationEcho, 1));
};


/**
 * @param {?proto.aviwest.web.v1.NotificationEcho|undefined} value
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveNotificationMessage.prototype.setEcho = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.aviwest.web.v1.LiveNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.clearEcho = function() {
  return this.setEcho(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.hasEcho = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FieldUnitStatus fu_status = 3;
 * @return {?proto.aviwest.web.v1.FieldUnitStatus}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.getFuStatus = function() {
  return /** @type{?proto.aviwest.web.v1.FieldUnitStatus} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.FieldUnitStatus, 3));
};


/**
 * @param {?proto.aviwest.web.v1.FieldUnitStatus|undefined} value
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveNotificationMessage.prototype.setFuStatus = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.aviwest.web.v1.LiveNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.clearFuStatus = function() {
  return this.setFuStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.hasFuStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CtrlFuPreview ctrl_fu_preview = 13;
 * @return {?proto.aviwest.web.v1.CtrlFuPreview}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.getCtrlFuPreview = function() {
  return /** @type{?proto.aviwest.web.v1.CtrlFuPreview} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.CtrlFuPreview, 13));
};


/**
 * @param {?proto.aviwest.web.v1.CtrlFuPreview|undefined} value
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveNotificationMessage.prototype.setCtrlFuPreview = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.aviwest.web.v1.LiveNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.clearCtrlFuPreview = function() {
  return this.setCtrlFuPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.hasCtrlFuPreview = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional CtrlShPreviewInput ctrl_sh_preview_input = 14;
 * @return {?proto.aviwest.web.v1.CtrlShPreviewInput}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.getCtrlShPreviewInput = function() {
  return /** @type{?proto.aviwest.web.v1.CtrlShPreviewInput} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.CtrlShPreviewInput, 14));
};


/**
 * @param {?proto.aviwest.web.v1.CtrlShPreviewInput|undefined} value
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveNotificationMessage.prototype.setCtrlShPreviewInput = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.aviwest.web.v1.LiveNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.clearCtrlShPreviewInput = function() {
  return this.setCtrlShPreviewInput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.hasCtrlShPreviewInput = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional CtrlShEvent ctrl_sh_event = 15;
 * @return {?proto.aviwest.web.v1.CtrlShEvent}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.getCtrlShEvent = function() {
  return /** @type{?proto.aviwest.web.v1.CtrlShEvent} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.CtrlShEvent, 15));
};


/**
 * @param {?proto.aviwest.web.v1.CtrlShEvent|undefined} value
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveNotificationMessage.prototype.setCtrlShEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.aviwest.web.v1.LiveNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.clearCtrlShEvent = function() {
  return this.setCtrlShEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.hasCtrlShEvent = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional CtrlFuEvent ctrl_fu_event = 16;
 * @return {?proto.aviwest.web.v1.CtrlFuEvent}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.getCtrlFuEvent = function() {
  return /** @type{?proto.aviwest.web.v1.CtrlFuEvent} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.CtrlFuEvent, 16));
};


/**
 * @param {?proto.aviwest.web.v1.CtrlFuEvent|undefined} value
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveNotificationMessage.prototype.setCtrlFuEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.aviwest.web.v1.LiveNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.clearCtrlFuEvent = function() {
  return this.setCtrlFuEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.hasCtrlFuEvent = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional ServiceReady ready = 17;
 * @return {?proto.aviwest.web.v1.ServiceReady}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.getReady = function() {
  return /** @type{?proto.aviwest.web.v1.ServiceReady} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.ServiceReady, 17));
};


/**
 * @param {?proto.aviwest.web.v1.ServiceReady|undefined} value
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveNotificationMessage.prototype.setReady = function(value) {
  return jspb.Message.setOneofWrapperField(this, 17, proto.aviwest.web.v1.LiveNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.clearReady = function() {
  return this.setReady(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.hasReady = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional CtrlMakEvent ctrl_mak_event = 19;
 * @return {?proto.aviwest.web.v1.CtrlMakEvent}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.getCtrlMakEvent = function() {
  return /** @type{?proto.aviwest.web.v1.CtrlMakEvent} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.CtrlMakEvent, 19));
};


/**
 * @param {?proto.aviwest.web.v1.CtrlMakEvent|undefined} value
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
*/
proto.aviwest.web.v1.LiveNotificationMessage.prototype.setCtrlMakEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 19, proto.aviwest.web.v1.LiveNotificationMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.LiveNotificationMessage} returns this
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.clearCtrlMakEvent = function() {
  return this.setCtrlMakEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.LiveNotificationMessage.prototype.hasCtrlMakEvent = function() {
  return jspb.Message.getField(this, 19) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.ServiceReady.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.ServiceReady.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.ServiceReady} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ServiceReady.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.ServiceReady}
 */
proto.aviwest.web.v1.ServiceReady.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.ServiceReady;
  return proto.aviwest.web.v1.ServiceReady.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.ServiceReady} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.ServiceReady}
 */
proto.aviwest.web.v1.ServiceReady.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.ServiceReady.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.ServiceReady.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.ServiceReady} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ServiceReady.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.Routes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Routes.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Routes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Routes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Routes.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.Route.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Routes}
 */
proto.aviwest.web.v1.Routes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Routes;
  return proto.aviwest.web.v1.Routes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Routes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Routes}
 */
proto.aviwest.web.v1.Routes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.aviwest.web.v1.Route;
      reader.readMessage(value,proto.aviwest.web.v1.Route.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Routes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Routes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Routes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Routes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.Route.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Route data = 1;
 * @return {!Array<!proto.aviwest.web.v1.Route>}
 */
proto.aviwest.web.v1.Routes.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Route>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Route, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Route>} value
 * @return {!proto.aviwest.web.v1.Routes} returns this
*/
proto.aviwest.web.v1.Routes.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.Route=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Route}
 */
proto.aviwest.web.v1.Routes.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.Route, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.Routes} returns this
 */
proto.aviwest.web.v1.Routes.prototype.clearDataList = function() {
  return this.setDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.Route.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Route.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Route.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Route} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Route.toObject = function(includeInstance, msg) {
  var f, obj = {
    shHwId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    input: (f = msg.getInput()) && proto.aviwest.web.v1.RouteInput.toObject(includeInstance, f),
    encodersList: jspb.Message.toObjectList(msg.getEncodersList(),
    proto.aviwest.web.v1.RouteNode.toObject, includeInstance),
    outputsList: jspb.Message.toObjectList(msg.getOutputsList(),
    proto.aviwest.web.v1.RouteNode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Route}
 */
proto.aviwest.web.v1.Route.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Route;
  return proto.aviwest.web.v1.Route.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Route} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Route}
 */
proto.aviwest.web.v1.Route.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setShHwId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.aviwest.web.v1.RouteInput;
      reader.readMessage(value,proto.aviwest.web.v1.RouteInput.deserializeBinaryFromReader);
      msg.setInput(value);
      break;
    case 5:
      var value = new proto.aviwest.web.v1.RouteNode;
      reader.readMessage(value,proto.aviwest.web.v1.RouteNode.deserializeBinaryFromReader);
      msg.addEncoders(value);
      break;
    case 6:
      var value = new proto.aviwest.web.v1.RouteNode;
      reader.readMessage(value,proto.aviwest.web.v1.RouteNode.deserializeBinaryFromReader);
      msg.addOutputs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Route.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Route.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Route} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Route.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShHwId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInput();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.aviwest.web.v1.RouteInput.serializeBinaryToWriter
    );
  }
  f = message.getEncodersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.aviwest.web.v1.RouteNode.serializeBinaryToWriter
    );
  }
  f = message.getOutputsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.aviwest.web.v1.RouteNode.serializeBinaryToWriter
    );
  }
};


/**
 * optional string sh_hw_id = 1;
 * @return {string}
 */
proto.aviwest.web.v1.Route.prototype.getShHwId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Route} returns this
 */
proto.aviwest.web.v1.Route.prototype.setShHwId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.aviwest.web.v1.Route.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Route} returns this
 */
proto.aviwest.web.v1.Route.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RouteInput input = 3;
 * @return {?proto.aviwest.web.v1.RouteInput}
 */
proto.aviwest.web.v1.Route.prototype.getInput = function() {
  return /** @type{?proto.aviwest.web.v1.RouteInput} */ (
    jspb.Message.getWrapperField(this, proto.aviwest.web.v1.RouteInput, 3));
};


/**
 * @param {?proto.aviwest.web.v1.RouteInput|undefined} value
 * @return {!proto.aviwest.web.v1.Route} returns this
*/
proto.aviwest.web.v1.Route.prototype.setInput = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.aviwest.web.v1.Route} returns this
 */
proto.aviwest.web.v1.Route.prototype.clearInput = function() {
  return this.setInput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.Route.prototype.hasInput = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated RouteNode encoders = 5;
 * @return {!Array<!proto.aviwest.web.v1.RouteNode>}
 */
proto.aviwest.web.v1.Route.prototype.getEncodersList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.RouteNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.RouteNode, 5));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.RouteNode>} value
 * @return {!proto.aviwest.web.v1.Route} returns this
*/
proto.aviwest.web.v1.Route.prototype.setEncodersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.aviwest.web.v1.RouteNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.RouteNode}
 */
proto.aviwest.web.v1.Route.prototype.addEncoders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.aviwest.web.v1.RouteNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.Route} returns this
 */
proto.aviwest.web.v1.Route.prototype.clearEncodersList = function() {
  return this.setEncodersList([]);
};


/**
 * repeated RouteNode outputs = 6;
 * @return {!Array<!proto.aviwest.web.v1.RouteNode>}
 */
proto.aviwest.web.v1.Route.prototype.getOutputsList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.RouteNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.RouteNode, 6));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.RouteNode>} value
 * @return {!proto.aviwest.web.v1.Route} returns this
*/
proto.aviwest.web.v1.Route.prototype.setOutputsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.aviwest.web.v1.RouteNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.RouteNode}
 */
proto.aviwest.web.v1.Route.prototype.addOutputs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.aviwest.web.v1.RouteNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.Route} returns this
 */
proto.aviwest.web.v1.Route.prototype.clearOutputsList = function() {
  return this.setOutputsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.RouteInput.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.RouteInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.RouteInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RouteInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    uid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    enable: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.RouteInput}
 */
proto.aviwest.web.v1.RouteInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.RouteInput;
  return proto.aviwest.web.v1.RouteInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.RouteInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.RouteInput}
 */
proto.aviwest.web.v1.RouteInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.RouteInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.RouteInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.RouteInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RouteInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnable();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string uid = 1;
 * @return {string}
 */
proto.aviwest.web.v1.RouteInput.prototype.getUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RouteInput} returns this
 */
proto.aviwest.web.v1.RouteInput.prototype.setUid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool enable = 2;
 * @return {boolean}
 */
proto.aviwest.web.v1.RouteInput.prototype.getEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.RouteInput} returns this
 */
proto.aviwest.web.v1.RouteInput.prototype.setEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.RouteNode.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.RouteNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.RouteNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RouteNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    uid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    enable: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    sourceId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.RouteNode}
 */
proto.aviwest.web.v1.RouteNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.RouteNode;
  return proto.aviwest.web.v1.RouteNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.RouteNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.RouteNode}
 */
proto.aviwest.web.v1.RouteNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnable(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.RouteNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.RouteNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.RouteNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RouteNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnable();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getSourceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string uid = 1;
 * @return {string}
 */
proto.aviwest.web.v1.RouteNode.prototype.getUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RouteNode} returns this
 */
proto.aviwest.web.v1.RouteNode.prototype.setUid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool enable = 2;
 * @return {boolean}
 */
proto.aviwest.web.v1.RouteNode.prototype.getEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.RouteNode} returns this
 */
proto.aviwest.web.v1.RouteNode.prototype.setEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string source_id = 3;
 * @return {string}
 */
proto.aviwest.web.v1.RouteNode.prototype.getSourceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RouteNode} returns this
 */
proto.aviwest.web.v1.RouteNode.prototype.setSourceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.CtrlShEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.CtrlShEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.CtrlShEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CtrlShEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    eventType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    event: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.CtrlShEvent}
 */
proto.aviwest.web.v1.CtrlShEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.CtrlShEvent;
  return proto.aviwest.web.v1.CtrlShEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.CtrlShEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.CtrlShEvent}
 */
proto.aviwest.web.v1.CtrlShEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.CtrlShEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.CtrlShEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.CtrlShEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CtrlShEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getEventType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEvent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.CtrlShEvent.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CtrlShEvent} returns this
 */
proto.aviwest.web.v1.CtrlShEvent.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string event_type = 2;
 * @return {string}
 */
proto.aviwest.web.v1.CtrlShEvent.prototype.getEventType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CtrlShEvent} returns this
 */
proto.aviwest.web.v1.CtrlShEvent.prototype.setEventType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string event = 3;
 * @return {string}
 */
proto.aviwest.web.v1.CtrlShEvent.prototype.getEvent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CtrlShEvent} returns this
 */
proto.aviwest.web.v1.CtrlShEvent.prototype.setEvent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.CtrlFuEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.CtrlFuEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.CtrlFuEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CtrlFuEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    instanceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    eventType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    event: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.CtrlFuEvent}
 */
proto.aviwest.web.v1.CtrlFuEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.CtrlFuEvent;
  return proto.aviwest.web.v1.CtrlFuEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.CtrlFuEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.CtrlFuEvent}
 */
proto.aviwest.web.v1.CtrlFuEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstanceId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.CtrlFuEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.CtrlFuEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.CtrlFuEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CtrlFuEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getInstanceId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getEventType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEvent();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.CtrlFuEvent.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CtrlFuEvent} returns this
 */
proto.aviwest.web.v1.CtrlFuEvent.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 instance_id = 3;
 * @return {number}
 */
proto.aviwest.web.v1.CtrlFuEvent.prototype.getInstanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CtrlFuEvent} returns this
 */
proto.aviwest.web.v1.CtrlFuEvent.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string event_type = 4;
 * @return {string}
 */
proto.aviwest.web.v1.CtrlFuEvent.prototype.getEventType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CtrlFuEvent} returns this
 */
proto.aviwest.web.v1.CtrlFuEvent.prototype.setEventType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string event = 5;
 * @return {string}
 */
proto.aviwest.web.v1.CtrlFuEvent.prototype.getEvent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CtrlFuEvent} returns this
 */
proto.aviwest.web.v1.CtrlFuEvent.prototype.setEvent = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.CtrlMakEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.CtrlMakEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.CtrlMakEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CtrlMakEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    sId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    instanceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    eventType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    event: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.CtrlMakEvent}
 */
proto.aviwest.web.v1.CtrlMakEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.CtrlMakEvent;
  return proto.aviwest.web.v1.CtrlMakEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.CtrlMakEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.CtrlMakEvent}
 */
proto.aviwest.web.v1.CtrlMakEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstanceId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.CtrlMakEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.CtrlMakEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.CtrlMakEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CtrlMakEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInstanceId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getEventType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEvent();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string s_id = 1;
 * @return {string}
 */
proto.aviwest.web.v1.CtrlMakEvent.prototype.getSId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CtrlMakEvent} returns this
 */
proto.aviwest.web.v1.CtrlMakEvent.prototype.setSId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 instance_id = 3;
 * @return {number}
 */
proto.aviwest.web.v1.CtrlMakEvent.prototype.getInstanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CtrlMakEvent} returns this
 */
proto.aviwest.web.v1.CtrlMakEvent.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string event_type = 4;
 * @return {string}
 */
proto.aviwest.web.v1.CtrlMakEvent.prototype.getEventType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CtrlMakEvent} returns this
 */
proto.aviwest.web.v1.CtrlMakEvent.prototype.setEventType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string event = 5;
 * @return {string}
 */
proto.aviwest.web.v1.CtrlMakEvent.prototype.getEvent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CtrlMakEvent} returns this
 */
proto.aviwest.web.v1.CtrlMakEvent.prototype.setEvent = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.CtrlShPreviewInput.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.CtrlShPreviewInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.CtrlShPreviewInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CtrlShPreviewInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    inputId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    preview: jspb.Message.getFieldWithDefault(msg, 4, ""),
    audioLevels: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.CtrlShPreviewInput}
 */
proto.aviwest.web.v1.CtrlShPreviewInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.CtrlShPreviewInput;
  return proto.aviwest.web.v1.CtrlShPreviewInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.CtrlShPreviewInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.CtrlShPreviewInput}
 */
proto.aviwest.web.v1.CtrlShPreviewInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setInputId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreview(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudioLevels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.CtrlShPreviewInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.CtrlShPreviewInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.CtrlShPreviewInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CtrlShPreviewInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getInputId();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getPreview();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAudioLevels();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.CtrlShPreviewInput.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CtrlShPreviewInput} returns this
 */
proto.aviwest.web.v1.CtrlShPreviewInput.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 input_id = 3;
 * @return {number}
 */
proto.aviwest.web.v1.CtrlShPreviewInput.prototype.getInputId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CtrlShPreviewInput} returns this
 */
proto.aviwest.web.v1.CtrlShPreviewInput.prototype.setInputId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string preview = 4;
 * @return {string}
 */
proto.aviwest.web.v1.CtrlShPreviewInput.prototype.getPreview = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CtrlShPreviewInput} returns this
 */
proto.aviwest.web.v1.CtrlShPreviewInput.prototype.setPreview = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string audio_levels = 6;
 * @return {string}
 */
proto.aviwest.web.v1.CtrlShPreviewInput.prototype.getAudioLevels = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CtrlShPreviewInput} returns this
 */
proto.aviwest.web.v1.CtrlShPreviewInput.prototype.setAudioLevels = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.CtrlFuPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.CtrlFuPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.CtrlFuPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CtrlFuPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    instanceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    preview: jspb.Message.getFieldWithDefault(msg, 4, ""),
    audioLevels: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.CtrlFuPreview}
 */
proto.aviwest.web.v1.CtrlFuPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.CtrlFuPreview;
  return proto.aviwest.web.v1.CtrlFuPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.CtrlFuPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.CtrlFuPreview}
 */
proto.aviwest.web.v1.CtrlFuPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstanceId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreview(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudioLevels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.CtrlFuPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.CtrlFuPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.CtrlFuPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CtrlFuPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getInstanceId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getPreview();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAudioLevels();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.CtrlFuPreview.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CtrlFuPreview} returns this
 */
proto.aviwest.web.v1.CtrlFuPreview.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 instance_id = 3;
 * @return {number}
 */
proto.aviwest.web.v1.CtrlFuPreview.prototype.getInstanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CtrlFuPreview} returns this
 */
proto.aviwest.web.v1.CtrlFuPreview.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string preview = 4;
 * @return {string}
 */
proto.aviwest.web.v1.CtrlFuPreview.prototype.getPreview = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CtrlFuPreview} returns this
 */
proto.aviwest.web.v1.CtrlFuPreview.prototype.setPreview = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string audio_levels = 6;
 * @return {string}
 */
proto.aviwest.web.v1.CtrlFuPreview.prototype.getAudioLevels = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CtrlFuPreview} returns this
 */
proto.aviwest.web.v1.CtrlFuPreview.prototype.setAudioLevels = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.FieldUnitStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.FieldUnitStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.FieldUnitStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.FieldUnitStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldUnitId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, ""),
    instanceId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    remoteControlUrl: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.FieldUnitStatus}
 */
proto.aviwest.web.v1.FieldUnitStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.FieldUnitStatus;
  return proto.aviwest.web.v1.FieldUnitStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.FieldUnitStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.FieldUnitStatus}
 */
proto.aviwest.web.v1.FieldUnitStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFieldUnitId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstanceId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemoteControlUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.FieldUnitStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.FieldUnitStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.FieldUnitStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.FieldUnitStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldUnitId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInstanceId();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getRemoteControlUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional uint64 field_unit_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.FieldUnitStatus.prototype.getFieldUnitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.FieldUnitStatus} returns this
 */
proto.aviwest.web.v1.FieldUnitStatus.prototype.setFieldUnitId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnitStatus.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnitStatus} returns this
 */
proto.aviwest.web.v1.FieldUnitStatus.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 instance_id = 4;
 * @return {number}
 */
proto.aviwest.web.v1.FieldUnitStatus.prototype.getInstanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.FieldUnitStatus} returns this
 */
proto.aviwest.web.v1.FieldUnitStatus.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string remote_control_url = 8;
 * @return {string}
 */
proto.aviwest.web.v1.FieldUnitStatus.prototype.getRemoteControlUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.FieldUnitStatus} returns this
 */
proto.aviwest.web.v1.FieldUnitStatus.prototype.setRemoteControlUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.ToCtrlId.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.ToCtrlId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.ToCtrlId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ToCtrlId.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hwId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    instanceId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.ToCtrlId}
 */
proto.aviwest.web.v1.ToCtrlId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.ToCtrlId;
  return proto.aviwest.web.v1.ToCtrlId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.ToCtrlId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.ToCtrlId}
 */
proto.aviwest.web.v1.ToCtrlId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHwId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstanceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.ToCtrlId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.ToCtrlId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.ToCtrlId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ToCtrlId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getHwId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInstanceId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.ToCtrlId.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.ToCtrlId} returns this
 */
proto.aviwest.web.v1.ToCtrlId.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string hw_id = 2;
 * @return {string}
 */
proto.aviwest.web.v1.ToCtrlId.prototype.getHwId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ToCtrlId} returns this
 */
proto.aviwest.web.v1.ToCtrlId.prototype.setHwId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 instance_id = 3;
 * @return {number}
 */
proto.aviwest.web.v1.ToCtrlId.prototype.getInstanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.ToCtrlId} returns this
 */
proto.aviwest.web.v1.ToCtrlId.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.ToCtrlSId.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.ToCtrlSId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.ToCtrlSId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ToCtrlSId.toObject = function(includeInstance, msg) {
  var f, obj = {
    sId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hwId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.ToCtrlSId}
 */
proto.aviwest.web.v1.ToCtrlSId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.ToCtrlSId;
  return proto.aviwest.web.v1.ToCtrlSId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.ToCtrlSId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.ToCtrlSId}
 */
proto.aviwest.web.v1.ToCtrlSId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHwId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.ToCtrlSId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.ToCtrlSId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.ToCtrlSId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.ToCtrlSId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHwId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string s_id = 1;
 * @return {string}
 */
proto.aviwest.web.v1.ToCtrlSId.prototype.getSId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ToCtrlSId} returns this
 */
proto.aviwest.web.v1.ToCtrlSId.prototype.setSId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string hw_id = 2;
 * @return {string}
 */
proto.aviwest.web.v1.ToCtrlSId.prototype.getHwId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.ToCtrlSId} returns this
 */
proto.aviwest.web.v1.ToCtrlSId.prototype.setHwId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.LiveNotificationFilters.repeatedFields_ = [1,2,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.LiveNotificationFilters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.LiveNotificationFilters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveNotificationFilters.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    productsList: jspb.Message.toObjectList(msg.getProductsList(),
    proto.aviwest.web.v1.ToCtrlId.toObject, includeInstance),
    fieldUnitsList: jspb.Message.toObjectList(msg.getFieldUnitsList(),
    proto.aviwest.web.v1.ToCtrlId.toObject, includeInstance),
    makitosList: jspb.Message.toObjectList(msg.getMakitosList(),
    proto.aviwest.web.v1.ToCtrlSId.toObject, includeInstance),
    organizationId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.LiveNotificationFilters}
 */
proto.aviwest.web.v1.LiveNotificationFilters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.LiveNotificationFilters;
  return proto.aviwest.web.v1.LiveNotificationFilters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.LiveNotificationFilters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.LiveNotificationFilters}
 */
proto.aviwest.web.v1.LiveNotificationFilters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 1:
      var value = new proto.aviwest.web.v1.ToCtrlId;
      reader.readMessage(value,proto.aviwest.web.v1.ToCtrlId.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.ToCtrlId;
      reader.readMessage(value,proto.aviwest.web.v1.ToCtrlId.deserializeBinaryFromReader);
      msg.addFieldUnits(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.ToCtrlSId;
      reader.readMessage(value,proto.aviwest.web.v1.ToCtrlSId.deserializeBinaryFromReader);
      msg.addMakitos(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.LiveNotificationFilters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.LiveNotificationFilters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.LiveNotificationFilters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.aviwest.web.v1.ToCtrlId.serializeBinaryToWriter
    );
  }
  f = message.getFieldUnitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.aviwest.web.v1.ToCtrlId.serializeBinaryToWriter
    );
  }
  f = message.getMakitosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.ToCtrlSId.serializeBinaryToWriter
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional uint64 account_id = 3;
 * @return {number}
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.LiveNotificationFilters} returns this
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ToCtrlId products = 1;
 * @return {!Array<!proto.aviwest.web.v1.ToCtrlId>}
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.ToCtrlId>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.ToCtrlId, 1));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.ToCtrlId>} value
 * @return {!proto.aviwest.web.v1.LiveNotificationFilters} returns this
*/
proto.aviwest.web.v1.LiveNotificationFilters.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.aviwest.web.v1.ToCtrlId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.ToCtrlId}
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.aviwest.web.v1.ToCtrlId, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.LiveNotificationFilters} returns this
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * repeated ToCtrlId field_units = 2;
 * @return {!Array<!proto.aviwest.web.v1.ToCtrlId>}
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.getFieldUnitsList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.ToCtrlId>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.ToCtrlId, 2));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.ToCtrlId>} value
 * @return {!proto.aviwest.web.v1.LiveNotificationFilters} returns this
*/
proto.aviwest.web.v1.LiveNotificationFilters.prototype.setFieldUnitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.aviwest.web.v1.ToCtrlId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.ToCtrlId}
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.addFieldUnits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.aviwest.web.v1.ToCtrlId, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.LiveNotificationFilters} returns this
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.clearFieldUnitsList = function() {
  return this.setFieldUnitsList([]);
};


/**
 * repeated ToCtrlSId makitos = 4;
 * @return {!Array<!proto.aviwest.web.v1.ToCtrlSId>}
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.getMakitosList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.ToCtrlSId>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.ToCtrlSId, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.ToCtrlSId>} value
 * @return {!proto.aviwest.web.v1.LiveNotificationFilters} returns this
*/
proto.aviwest.web.v1.LiveNotificationFilters.prototype.setMakitosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.ToCtrlSId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.ToCtrlSId}
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.addMakitos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.ToCtrlSId, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.LiveNotificationFilters} returns this
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.clearMakitosList = function() {
  return this.setMakitosList([]);
};


/**
 * optional string organization_id = 5;
 * @return {string}
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveNotificationFilters} returns this
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string subscription_id = 6;
 * @return {string}
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.LiveNotificationFilters} returns this
 */
proto.aviwest.web.v1.LiveNotificationFilters.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Booking.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Booking.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Booking} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Booking.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    created: jspb.Message.getFieldWithDefault(msg, 3, ""),
    updated: jspb.Message.getFieldWithDefault(msg, 4, ""),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    streamhubHwId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    inputId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    fieldUnitHwId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    instanceId: jspb.Message.getFieldWithDefault(msg, 11, 0),
    startDate: jspb.Message.getFieldWithDefault(msg, 12, ""),
    endDate: jspb.Message.getFieldWithDefault(msg, 13, ""),
    organizationId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 15, ""),
    groupUuid: jspb.Message.getFieldWithDefault(msg, 16, ""),
    deviceId: jspb.Message.getFieldWithDefault(msg, 17, ""),
    videoEncoderId: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Booking}
 */
proto.aviwest.web.v1.Booking.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Booking;
  return proto.aviwest.web.v1.Booking.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Booking} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Booking}
 */
proto.aviwest.web.v1.Booking.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreated(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdated(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreamhubHwId(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInputId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldUnitHwId(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstanceId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndDate(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupUuid(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoEncoderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Booking.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Booking.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Booking} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Booking.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCreated();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUpdated();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getStreamhubHwId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getInputId();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getFieldUnitHwId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getInstanceId();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getGroupUuid();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getVideoEncoderId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Booking.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 version = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Booking.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string created = 3;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string updated = 4;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getUpdated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setUpdated = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint64 account_id = 6;
 * @return {number}
 */
proto.aviwest.web.v1.Booking.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string streamhub_hw_id = 8;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getStreamhubHwId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setStreamhubHwId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional uint32 input_id = 9;
 * @return {number}
 */
proto.aviwest.web.v1.Booking.prototype.getInputId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setInputId = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string field_unit_hw_id = 10;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getFieldUnitHwId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setFieldUnitHwId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional uint32 instance_id = 11;
 * @return {number}
 */
proto.aviwest.web.v1.Booking.prototype.getInstanceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string start_date = 12;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string end_date = 13;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string organization_id = 14;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string subscription_id = 15;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string group_uuid = 16;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getGroupUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setGroupUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string device_id = 17;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string video_encoder_id = 18;
 * @return {string}
 */
proto.aviwest.web.v1.Booking.prototype.getVideoEncoderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Booking} returns this
 */
proto.aviwest.web.v1.Booking.prototype.setVideoEncoderId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.Bookings.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Bookings.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Bookings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Bookings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Bookings.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.Booking.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Bookings}
 */
proto.aviwest.web.v1.Bookings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Bookings;
  return proto.aviwest.web.v1.Bookings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Bookings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Bookings}
 */
proto.aviwest.web.v1.Bookings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.Booking;
      reader.readMessage(value,proto.aviwest.web.v1.Booking.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Bookings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Bookings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Bookings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Bookings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.Booking.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Bookings.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Bookings} returns this
 */
proto.aviwest.web.v1.Bookings.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Bookings.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Bookings} returns this
 */
proto.aviwest.web.v1.Bookings.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.aviwest.web.v1.Bookings.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Bookings} returns this
 */
proto.aviwest.web.v1.Bookings.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Booking data = 4;
 * @return {!Array<!proto.aviwest.web.v1.Booking>}
 */
proto.aviwest.web.v1.Bookings.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Booking>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Booking, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Booking>} value
 * @return {!proto.aviwest.web.v1.Bookings} returns this
*/
proto.aviwest.web.v1.Bookings.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.Booking=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Booking}
 */
proto.aviwest.web.v1.Bookings.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.Booking, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.Bookings} returns this
 */
proto.aviwest.web.v1.Bookings.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.StreamhubInputRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.StreamhubInputRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.StreamhubInputRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.StreamhubInputRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    streamhubHwId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    inputId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.StreamhubInputRequest}
 */
proto.aviwest.web.v1.StreamhubInputRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.StreamhubInputRequest;
  return proto.aviwest.web.v1.StreamhubInputRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.StreamhubInputRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.StreamhubInputRequest}
 */
proto.aviwest.web.v1.StreamhubInputRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreamhubHwId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInputId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.StreamhubInputRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.StreamhubInputRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.StreamhubInputRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.StreamhubInputRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStreamhubHwId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInputId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional string streamhub_hw_id = 1;
 * @return {string}
 */
proto.aviwest.web.v1.StreamhubInputRequest.prototype.getStreamhubHwId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.StreamhubInputRequest} returns this
 */
proto.aviwest.web.v1.StreamhubInputRequest.prototype.setStreamhubHwId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 input_id = 2;
 * @return {number}
 */
proto.aviwest.web.v1.StreamhubInputRequest.prototype.getInputId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.StreamhubInputRequest} returns this
 */
proto.aviwest.web.v1.StreamhubInputRequest.prototype.setInputId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.Versions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Versions.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Versions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Versions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Versions.toObject = function(includeInstance, msg) {
  var f, obj = {
    streamhubList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Versions}
 */
proto.aviwest.web.v1.Versions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Versions;
  return proto.aviwest.web.v1.Versions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Versions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Versions}
 */
proto.aviwest.web.v1.Versions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addStreamhub(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Versions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Versions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Versions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Versions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStreamhubList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string streamhub = 1;
 * @return {!Array<string>}
 */
proto.aviwest.web.v1.Versions.prototype.getStreamhubList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.aviwest.web.v1.Versions} returns this
 */
proto.aviwest.web.v1.Versions.prototype.setStreamhubList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Versions} returns this
 */
proto.aviwest.web.v1.Versions.prototype.addStreamhub = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.Versions} returns this
 */
proto.aviwest.web.v1.Versions.prototype.clearStreamhubList = function() {
  return this.setStreamhubList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.CloudProductCreationForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.CloudProductCreationForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CloudProductCreationForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    location: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    password: jspb.Message.getFieldWithDefault(msg, 5, ""),
    startDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
    stopDate: jspb.Message.getFieldWithDefault(msg, 7, ""),
    ope: jspb.Message.getFieldWithDefault(msg, 8, ""),
    customer: jspb.Message.getFieldWithDefault(msg, 9, ""),
    securityRules: jspb.Message.getFieldWithDefault(msg, 10, ""),
    version: jspb.Message.getFieldWithDefault(msg, 11, ""),
    organizationId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    groupId: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm}
 */
proto.aviwest.web.v1.CloudProductCreationForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.CloudProductCreationForm;
  return proto.aviwest.web.v1.CloudProductCreationForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.CloudProductCreationForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm}
 */
proto.aviwest.web.v1.CloudProductCreationForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStopDate(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpe(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomer(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityRules(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.CloudProductCreationForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.CloudProductCreationForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CloudProductCreationForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStopDate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOpe();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCustomer();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSecurityRules();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string location = 2;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 account_id = 4;
 * @return {number}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string password = 5;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string start_date = 6;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string stop_date = 7;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getStopDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setStopDate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string ope = 8;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getOpe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setOpe = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string customer = 9;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getCustomer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setCustomer = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string security_rules = 10;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getSecurityRules = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setSecurityRules = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string version = 11;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string organization_id = 12;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string subscription_id = 13;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string group_id = 14;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductCreationForm} returns this
 */
proto.aviwest.web.v1.CloudProductCreationForm.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.CloudProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.CloudProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.CloudProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CloudProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    location: jspb.Message.getFieldWithDefault(msg, 3, ""),
    startDate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    stopDate: jspb.Message.getFieldWithDefault(msg, 5, ""),
    status: jspb.Message.getFieldWithDefault(msg, 6, ""),
    type: jspb.Message.getFieldWithDefault(msg, 7, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 8, 0),
    publicIp: jspb.Message.getFieldWithDefault(msg, 9, ""),
    host: jspb.Message.getFieldWithDefault(msg, 10, ""),
    ope: jspb.Message.getFieldWithDefault(msg, 11, ""),
    customer: jspb.Message.getFieldWithDefault(msg, 12, ""),
    version: jspb.Message.getFieldWithDefault(msg, 13, ""),
    password: jspb.Message.getFieldWithDefault(msg, 14, ""),
    securityRules: jspb.Message.getFieldWithDefault(msg, 15, ""),
    sso: jspb.Message.getFieldWithDefault(msg, 16, ""),
    organizationId: jspb.Message.getFieldWithDefault(msg, 17, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 18, ""),
    groupId: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.CloudProduct}
 */
proto.aviwest.web.v1.CloudProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.CloudProduct;
  return proto.aviwest.web.v1.CloudProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.CloudProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.CloudProduct}
 */
proto.aviwest.web.v1.CloudProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStopDate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicIp(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpe(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomer(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityRules(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSso(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.CloudProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.CloudProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.CloudProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CloudProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStopDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getPublicIp();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getOpe();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCustomer();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getSecurityRules();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSso();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string identifier = 1;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string location = 3;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string start_date = 4;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string stop_date = 5;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getStopDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setStopDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string type = 7;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint64 account_id = 8;
 * @return {number}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string public_ip = 9;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getPublicIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setPublicIp = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string host = 10;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string ope = 11;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getOpe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setOpe = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string customer = 12;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getCustomer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setCustomer = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string version = 13;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string password = 14;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string security_rules = 15;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getSecurityRules = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setSecurityRules = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string sso = 16;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getSso = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setSso = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string organization_id = 17;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string subscription_id = 18;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string group_id = 19;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProduct.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProduct} returns this
 */
proto.aviwest.web.v1.CloudProduct.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.CloudProducts.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.CloudProducts.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.CloudProducts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.CloudProducts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CloudProducts.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.CloudProduct.toObject, includeInstance),
    running: jspb.Message.getFieldWithDefault(msg, 5, 0),
    paused: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.CloudProducts}
 */
proto.aviwest.web.v1.CloudProducts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.CloudProducts;
  return proto.aviwest.web.v1.CloudProducts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.CloudProducts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.CloudProducts}
 */
proto.aviwest.web.v1.CloudProducts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.CloudProduct;
      reader.readMessage(value,proto.aviwest.web.v1.CloudProduct.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRunning(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPaused(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.CloudProducts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.CloudProducts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.CloudProducts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CloudProducts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.CloudProduct.serializeBinaryToWriter
    );
  }
  f = message.getRunning();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getPaused();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.CloudProducts.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CloudProducts} returns this
 */
proto.aviwest.web.v1.CloudProducts.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.CloudProducts.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CloudProducts} returns this
 */
proto.aviwest.web.v1.CloudProducts.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.aviwest.web.v1.CloudProducts.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CloudProducts} returns this
 */
proto.aviwest.web.v1.CloudProducts.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated CloudProduct data = 4;
 * @return {!Array<!proto.aviwest.web.v1.CloudProduct>}
 */
proto.aviwest.web.v1.CloudProducts.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.CloudProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.CloudProduct, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.CloudProduct>} value
 * @return {!proto.aviwest.web.v1.CloudProducts} returns this
*/
proto.aviwest.web.v1.CloudProducts.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.CloudProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.CloudProduct}
 */
proto.aviwest.web.v1.CloudProducts.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.CloudProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.CloudProducts} returns this
 */
proto.aviwest.web.v1.CloudProducts.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional uint32 running = 5;
 * @return {number}
 */
proto.aviwest.web.v1.CloudProducts.prototype.getRunning = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CloudProducts} returns this
 */
proto.aviwest.web.v1.CloudProducts.prototype.setRunning = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 paused = 6;
 * @return {number}
 */
proto.aviwest.web.v1.CloudProducts.prototype.getPaused = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CloudProducts} returns this
 */
proto.aviwest.web.v1.CloudProducts.prototype.setPaused = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.CloudProductError.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.CloudProductError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.CloudProductError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CloudProductError.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    errorcode: jspb.Message.getFieldWithDefault(msg, 3, 0),
    errormessage: jspb.Message.getFieldWithDefault(msg, 4, ""),
    organizationId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.CloudProductError}
 */
proto.aviwest.web.v1.CloudProductError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.CloudProductError;
  return proto.aviwest.web.v1.CloudProductError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.CloudProductError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.CloudProductError}
 */
proto.aviwest.web.v1.CloudProductError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setErrorcode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrormessage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.CloudProductError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.CloudProductError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.CloudProductError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.CloudProductError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getErrorcode();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getErrormessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string identifier = 1;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductError.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductError} returns this
 */
proto.aviwest.web.v1.CloudProductError.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 account_id = 2;
 * @return {number}
 */
proto.aviwest.web.v1.CloudProductError.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CloudProductError} returns this
 */
proto.aviwest.web.v1.CloudProductError.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 errorCode = 3;
 * @return {number}
 */
proto.aviwest.web.v1.CloudProductError.prototype.getErrorcode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.CloudProductError} returns this
 */
proto.aviwest.web.v1.CloudProductError.prototype.setErrorcode = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string errorMessage = 4;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductError.prototype.getErrormessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductError} returns this
 */
proto.aviwest.web.v1.CloudProductError.prototype.setErrormessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string organization_id = 5;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductError.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductError} returns this
 */
proto.aviwest.web.v1.CloudProductError.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string subscription_id = 6;
 * @return {string}
 */
proto.aviwest.web.v1.CloudProductError.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.CloudProductError} returns this
 */
proto.aviwest.web.v1.CloudProductError.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.RequestFieldUnits.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.RequestFieldUnits.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.RequestFieldUnits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RequestFieldUnits.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    offset: jspb.Message.getFieldWithDefault(msg, 2, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.RequestFieldUnits}
 */
proto.aviwest.web.v1.RequestFieldUnits.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.RequestFieldUnits;
  return proto.aviwest.web.v1.RequestFieldUnits.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.RequestFieldUnits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.RequestFieldUnits}
 */
proto.aviwest.web.v1.RequestFieldUnits.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.RequestFieldUnits.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.RequestFieldUnits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.RequestFieldUnits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RequestFieldUnits.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.RequestFieldUnits.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.RequestFieldUnits} returns this
 */
proto.aviwest.web.v1.RequestFieldUnits.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 offset = 2;
 * @return {number}
 */
proto.aviwest.web.v1.RequestFieldUnits.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.RequestFieldUnits} returns this
 */
proto.aviwest.web.v1.RequestFieldUnits.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 limit = 3;
 * @return {number}
 */
proto.aviwest.web.v1.RequestFieldUnits.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.RequestFieldUnits} returns this
 */
proto.aviwest.web.v1.RequestFieldUnits.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.RegistrationCode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.RegistrationCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RegistrationCode.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    created: jspb.Message.getFieldWithDefault(msg, 3, ""),
    updated: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    name: jspb.Message.getFieldWithDefault(msg, 7, ""),
    type: jspb.Message.getFieldWithDefault(msg, 8, ""),
    expirationDate: jspb.Message.getFieldWithDefault(msg, 9, ""),
    code: jspb.Message.getFieldWithDefault(msg, 10, ""),
    status: jspb.Message.getFieldWithDefault(msg, 11, ""),
    usedCount: jspb.Message.getFieldWithDefault(msg, 12, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    groupUuid: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.RegistrationCode}
 */
proto.aviwest.web.v1.RegistrationCode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.RegistrationCode;
  return proto.aviwest.web.v1.RegistrationCode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.RegistrationCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.RegistrationCode}
 */
proto.aviwest.web.v1.RegistrationCode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreated(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdated(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpirationDate(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUsedCount(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.RegistrationCode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.RegistrationCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RegistrationCode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCreated();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUpdated();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExpirationDate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getUsedCount();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getGroupUuid();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 version = 2;
 * @return {number}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string created = 3;
 * @return {string}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string updated = 4;
 * @return {string}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getUpdated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setUpdated = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint64 account_id = 5;
 * @return {number}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string name = 7;
 * @return {string}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string type = 8;
 * @return {string}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string expiration_date = 9;
 * @return {string}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getExpirationDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setExpirationDate = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string code = 10;
 * @return {string}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string status = 11;
 * @return {string}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional uint32 used_count = 12;
 * @return {number}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getUsedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setUsedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string organization_id = 13;
 * @return {string}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string subscription_id = 14;
 * @return {string}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string group_uuid = 15;
 * @return {string}
 */
proto.aviwest.web.v1.RegistrationCode.prototype.getGroupUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.RegistrationCode} returns this
 */
proto.aviwest.web.v1.RegistrationCode.prototype.setGroupUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.RegistrationCodes.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.RegistrationCodes.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.RegistrationCodes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.RegistrationCodes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RegistrationCodes.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.RegistrationCode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.RegistrationCodes}
 */
proto.aviwest.web.v1.RegistrationCodes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.RegistrationCodes;
  return proto.aviwest.web.v1.RegistrationCodes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.RegistrationCodes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.RegistrationCodes}
 */
proto.aviwest.web.v1.RegistrationCodes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.RegistrationCode;
      reader.readMessage(value,proto.aviwest.web.v1.RegistrationCode.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.RegistrationCodes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.RegistrationCodes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.RegistrationCodes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.RegistrationCodes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.RegistrationCode.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.RegistrationCodes.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.RegistrationCodes} returns this
 */
proto.aviwest.web.v1.RegistrationCodes.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.RegistrationCodes.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.RegistrationCodes} returns this
 */
proto.aviwest.web.v1.RegistrationCodes.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.aviwest.web.v1.RegistrationCodes.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.RegistrationCodes} returns this
 */
proto.aviwest.web.v1.RegistrationCodes.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated RegistrationCode data = 4;
 * @return {!Array<!proto.aviwest.web.v1.RegistrationCode>}
 */
proto.aviwest.web.v1.RegistrationCodes.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.RegistrationCode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.RegistrationCode, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.RegistrationCode>} value
 * @return {!proto.aviwest.web.v1.RegistrationCodes} returns this
*/
proto.aviwest.web.v1.RegistrationCodes.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.RegistrationCode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.RegistrationCode}
 */
proto.aviwest.web.v1.RegistrationCodes.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.RegistrationCode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.RegistrationCodes} returns this
 */
proto.aviwest.web.v1.RegistrationCodes.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Device.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Device.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Device} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Device.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sId: jspb.Message.getFieldWithDefault(msg, 30, ""),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    created: jspb.Message.getFieldWithDefault(msg, 3, ""),
    updated: jspb.Message.getFieldWithDefault(msg, 4, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    familyName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    firmwareName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    hwId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 10, 0),
    status: jspb.Message.getFieldWithDefault(msg, 11, ""),
    firmwareVersion: jspb.Message.getFieldWithDefault(msg, 12, ""),
    lastConnectedDate: jspb.Message.getFieldWithDefault(msg, 13, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    productName: jspb.Message.getFieldWithDefault(msg, 16, ""),
    ownerPhone: jspb.Message.getFieldWithDefault(msg, 18, ""),
    ownerEmail: jspb.Message.getFieldWithDefault(msg, 19, ""),
    comments: jspb.Message.getFieldWithDefault(msg, 20, ""),
    remoteControlUrl: jspb.Message.getFieldWithDefault(msg, 21, ""),
    instanceCount: jspb.Message.getFieldWithDefault(msg, 22, 0),
    organizationId: jspb.Message.getFieldWithDefault(msg, 23, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 24, ""),
    groupUuid: jspb.Message.getFieldWithDefault(msg, 25, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Device}
 */
proto.aviwest.web.v1.Device.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Device;
  return proto.aviwest.web.v1.Device.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Device} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Device}
 */
proto.aviwest.web.v1.Device.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setSId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreated(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdated(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilyName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmwareName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setHwId(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmwareVersion(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastConnectedDate(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerPhone(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerEmail(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setComments(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemoteControlUrl(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstanceCount(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Device.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Device.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Device} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Device.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getSId();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCreated();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUpdated();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFamilyName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFirmwareName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getHwId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFirmwareVersion();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLastConnectedDate();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getOwnerPhone();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getOwnerEmail();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getComments();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getRemoteControlUrl();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getInstanceCount();
  if (f !== 0) {
    writer.writeUint32(
      22,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getGroupUuid();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Device.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string s_id = 30;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getSId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setSId = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional uint32 version = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Device.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string created = 3;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string updated = 4;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getUpdated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setUpdated = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string display_name = 6;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string family_name = 7;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getFamilyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setFamilyName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string firmware_name = 8;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getFirmwareName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setFirmwareName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string hw_id = 9;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getHwId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setHwId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional uint64 account_id = 10;
 * @return {number}
 */
proto.aviwest.web.v1.Device.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string status = 11;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string firmware_version = 12;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getFirmwareVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setFirmwareVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string last_connected_date = 13;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getLastConnectedDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setLastConnectedDate = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool active = 14;
 * @return {boolean}
 */
proto.aviwest.web.v1.Device.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string product_name = 16;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string owner_phone = 18;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getOwnerPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setOwnerPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string owner_email = 19;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getOwnerEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setOwnerEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string comments = 20;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getComments = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setComments = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string remote_control_url = 21;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getRemoteControlUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setRemoteControlUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional uint32 instance_count = 22;
 * @return {number}
 */
proto.aviwest.web.v1.Device.prototype.getInstanceCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setInstanceCount = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional string organization_id = 23;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string subscription_id = 24;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string group_uuid = 25;
 * @return {string}
 */
proto.aviwest.web.v1.Device.prototype.getGroupUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.Device} returns this
 */
proto.aviwest.web.v1.Device.prototype.setGroupUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.Devices.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.Devices.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.Devices.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.Devices} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Devices.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.aviwest.web.v1.Device.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.Devices}
 */
proto.aviwest.web.v1.Devices.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.Devices;
  return proto.aviwest.web.v1.Devices.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.Devices} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.Devices}
 */
proto.aviwest.web.v1.Devices.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.aviwest.web.v1.Device;
      reader.readMessage(value,proto.aviwest.web.v1.Device.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.Devices.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.Devices.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.Devices} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.Devices.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.aviwest.web.v1.Device.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.aviwest.web.v1.Devices.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Devices} returns this
 */
proto.aviwest.web.v1.Devices.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.aviwest.web.v1.Devices.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Devices} returns this
 */
proto.aviwest.web.v1.Devices.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.aviwest.web.v1.Devices.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.Devices} returns this
 */
proto.aviwest.web.v1.Devices.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Device data = 4;
 * @return {!Array<!proto.aviwest.web.v1.Device>}
 */
proto.aviwest.web.v1.Devices.prototype.getDataList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.Device>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.Device, 4));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.Device>} value
 * @return {!proto.aviwest.web.v1.Devices} returns this
*/
proto.aviwest.web.v1.Devices.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.aviwest.web.v1.Device=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.Device}
 */
proto.aviwest.web.v1.Devices.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.aviwest.web.v1.Device, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.Devices} returns this
 */
proto.aviwest.web.v1.Devices.prototype.clearDataList = function() {
  return this.setDataList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.aviwest.web.v1.DeviceId.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.aviwest.web.v1.DeviceId.IdCase = {
  ID_NOT_SET: 0,
  N: 1,
  S: 2
};

/**
 * @return {proto.aviwest.web.v1.DeviceId.IdCase}
 */
proto.aviwest.web.v1.DeviceId.prototype.getIdCase = function() {
  return /** @type {proto.aviwest.web.v1.DeviceId.IdCase} */(jspb.Message.computeOneofCase(this, proto.aviwest.web.v1.DeviceId.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.DeviceId.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.DeviceId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.DeviceId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.DeviceId.toObject = function(includeInstance, msg) {
  var f, obj = {
    n: jspb.Message.getFieldWithDefault(msg, 1, 0),
    s: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.DeviceId}
 */
proto.aviwest.web.v1.DeviceId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.DeviceId;
  return proto.aviwest.web.v1.DeviceId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.DeviceId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.DeviceId}
 */
proto.aviwest.web.v1.DeviceId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setN(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.DeviceId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.DeviceId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.DeviceId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.DeviceId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint64 n = 1;
 * @return {number}
 */
proto.aviwest.web.v1.DeviceId.prototype.getN = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.DeviceId} returns this
 */
proto.aviwest.web.v1.DeviceId.prototype.setN = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.aviwest.web.v1.DeviceId.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.aviwest.web.v1.DeviceId} returns this
 */
proto.aviwest.web.v1.DeviceId.prototype.clearN = function() {
  return jspb.Message.setOneofField(this, 1, proto.aviwest.web.v1.DeviceId.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.DeviceId.prototype.hasN = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string s = 2;
 * @return {string}
 */
proto.aviwest.web.v1.DeviceId.prototype.getS = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.aviwest.web.v1.DeviceId} returns this
 */
proto.aviwest.web.v1.DeviceId.prototype.setS = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.aviwest.web.v1.DeviceId.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.aviwest.web.v1.DeviceId} returns this
 */
proto.aviwest.web.v1.DeviceId.prototype.clearS = function() {
  return jspb.Message.setOneofField(this, 2, proto.aviwest.web.v1.DeviceId.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.aviwest.web.v1.DeviceId.prototype.hasS = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.aviwest.web.v1.DeviceIds.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.aviwest.web.v1.DeviceIds.prototype.toObject = function(opt_includeInstance) {
  return proto.aviwest.web.v1.DeviceIds.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.aviwest.web.v1.DeviceIds} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.DeviceIds.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    idsList: jspb.Message.toObjectList(msg.getIdsList(),
    proto.aviwest.web.v1.DeviceId.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.aviwest.web.v1.DeviceIds}
 */
proto.aviwest.web.v1.DeviceIds.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.aviwest.web.v1.DeviceIds;
  return proto.aviwest.web.v1.DeviceIds.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.aviwest.web.v1.DeviceIds} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.aviwest.web.v1.DeviceIds}
 */
proto.aviwest.web.v1.DeviceIds.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountId(value);
      break;
    case 2:
      var value = new proto.aviwest.web.v1.DeviceId;
      reader.readMessage(value,proto.aviwest.web.v1.DeviceId.deserializeBinaryFromReader);
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.aviwest.web.v1.DeviceIds.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.aviwest.web.v1.DeviceIds.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.aviwest.web.v1.DeviceIds} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.aviwest.web.v1.DeviceIds.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.aviwest.web.v1.DeviceId.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 account_id = 1;
 * @return {number}
 */
proto.aviwest.web.v1.DeviceIds.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.aviwest.web.v1.DeviceIds} returns this
 */
proto.aviwest.web.v1.DeviceIds.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated DeviceId ids = 2;
 * @return {!Array<!proto.aviwest.web.v1.DeviceId>}
 */
proto.aviwest.web.v1.DeviceIds.prototype.getIdsList = function() {
  return /** @type{!Array<!proto.aviwest.web.v1.DeviceId>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.aviwest.web.v1.DeviceId, 2));
};


/**
 * @param {!Array<!proto.aviwest.web.v1.DeviceId>} value
 * @return {!proto.aviwest.web.v1.DeviceIds} returns this
*/
proto.aviwest.web.v1.DeviceIds.prototype.setIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.aviwest.web.v1.DeviceId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.aviwest.web.v1.DeviceId}
 */
proto.aviwest.web.v1.DeviceIds.prototype.addIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.aviwest.web.v1.DeviceId, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.aviwest.web.v1.DeviceIds} returns this
 */
proto.aviwest.web.v1.DeviceIds.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};


goog.object.extend(exports, proto.aviwest.web.v1);
